import { WebSocket as Ue } from "isows";
import hs from "lodash.omit";
import M from "lodash.pick";
import * as e from "valibot";
import { isBlurhashValid as ws } from "blurhash";
import gs from "http-link-header";
import { serialize as vs } from "object-to-formdata";
import vt from "query-string";
const _s = [
  "/assets/default_header.webp",
  // GoToSocial
  "/headers/original/missing.png",
  // Mastodon
  "/api/v1/accounts/identicon",
  // Mitra
  /\/static\/img\/missing\.[a-z0-9]+\.png$/,
  // NeoDB
  "/storage/headers/missing.png",
  // Pixelfed
  "/images/banner.png",
  // Pleroma
  "/assets/transparent.png"
  // Iceshrimp.net
], Ut = (a = "") => a === "" || _s.some((t) => typeof t == "string" ? a.endsWith(t) : t.test(a)), ks = [
  /\/assets\/default_avatars\/GoToSocial_icon[1-6]\.webp$/,
  // GoToSocial
  "/avatars/original/missing.png",
  // Mastodon
  "/api/v1/accounts/identicon",
  // Mitra
  "/s/img/avatar.svg",
  // NeoDB
  "/avatars/default.jpg",
  // Pixelfed
  "/images/avi.png"
  // Pleroma
], Bt = (a = "") => a === "" || ks.some((t) => typeof t == "string" ? a.endsWith(t) : t.test(a)), Vt = (a) => {
  try {
    const t = a.url;
    return new URL(t).host;
  } catch {
    return "";
  }
}, ys = (a) => {
  const t = a.acct, [s, n] = t.split("@");
  return n ? t : [s, Vt(a)].join("@");
}, ee = e.object({
  shortcode: e.string(),
  url: e.string(),
  static_url: e.fallback(e.string(), ""),
  visible_in_picker: e.fallback(e.boolean(), !0),
  category: e.fallback(e.nullable(e.string()), null)
}), F = e.object({
  blocked_by: e.fallback(e.boolean(), !1),
  blocking: e.fallback(e.boolean(), !1),
  domain_blocking: e.fallback(e.boolean(), !1),
  endorsed: e.fallback(e.boolean(), !1),
  followed_by: e.fallback(e.boolean(), !1),
  following: e.fallback(e.boolean(), !1),
  id: e.string(),
  muting: e.fallback(e.boolean(), !1),
  muting_notifications: e.fallback(e.boolean(), !1),
  note: e.fallback(e.string(), ""),
  notifying: e.fallback(e.boolean(), !1),
  requested: e.fallback(e.boolean(), !1),
  showing_reblogs: e.fallback(e.boolean(), !1)
}), js = e.pipe(e.string(), e.regex(/^#[a-f0-9]{6}$/i)), le = e.object({
  id: e.fallback(e.string(), ""),
  name: e.fallback(e.string(), ""),
  color: e.fallback(js, ""),
  permissions: e.fallback(e.string(), ""),
  highlighted: e.fallback(e.boolean(), !0)
}), h = e.pipe(
  e.string(),
  // Adapted from Zod
  // https://github.com/colinhacks/zod/blob/main/src/types.ts#L619
  // at least it's not chatgpt
  e.regex(/^\d{4}-\d{2}-\d{2}T([01]\d|2[0-3]):[0-5]\d:[0-5]\d(\.\d+)?(([+-]\d{2}:?\d{2})|(Z)?)$/)
), tt = e.pipe(e.string(), e.transform((a) => a.slice(0, 10)), e.regex(/^\d{4}-\d{2}-\d{2}$/)), r = (a) => e.pipe(
  e.fallback(e.array(e.any()), []),
  e.transform((t) => (t || []).map((s) => {
    const n = e.safeParse(a, s);
    return n.success ? n.output : void 0;
  }).filter((s) => !!s))
), Ss = e.pipe(e.string(), e.emoji()), ut = e.pipe(e.string(), e.regex(/^\w+\/[-+.\w]+$/)), j = (a) => e.optional(
  e.pipe(
    e.any(),
    e.transform((t) => typeof t == "object" && t !== null ? t : {}),
    e.object(a)
  ),
  {}
), Es = (a) => a?.filter((t) => t.startsWith("badge:")).map((t) => e.parse(le, { id: t, name: t.replace(/^badge:/, "") })), qs = ["https://pl.fediverse.pl/users/mkljczk", "https://gts.mkljczk.pl/users/mkljczk", "https://gts.mkljczk.pl/@mkljczk"], pt = e.transform((a) => {
  if (!a?.acct) return null;
  const t = a.username || a.acct.split("@")[0], s = a.fqn || ys(a), n = s.split("@")[1] || "", o = (a.pleroma?.is_cat ?? a.is_cat) || qs.includes(a.uri ?? a.url), b = a.pleroma?.speak_as_cat ?? a.speak_as_cat ?? o;
  return {
    username: t,
    fqn: s,
    domain: n,
    avatar: a.avatar || a.avatar_static,
    header: a.header || a.header_static,
    avatar_default: Bt(a.avatar || a.avatar_static),
    header_default: Ut(a.header || a.header_static),
    local: typeof a.pleroma?.is_local == "boolean" ? a.pleroma.is_local : a.acct.split("@")[1] === void 0,
    discoverable: a.discoverable || a.pleroma?.source?.discoverable,
    verified: a.verified || a.pleroma?.tags?.includes("verified"),
    ...a.role?.permissions ? {
      is_admin: (a.role?.permissions & 1) === 1
    } : {},
    ap_id: a.pleroma?.ap_id ?? a.actor_id,
    ...M(a.pleroma || {}, [
      "background_image",
      "relationship",
      "is_moderator",
      "is_admin",
      "hide_favorites",
      "hide_followers",
      "hide_follows",
      "hide_followers_count",
      "hide_follows_count",
      "accepts_chat_messages",
      "favicon",
      "birthday",
      "deactivated",
      "avatar_description",
      "header_description",
      "settings_store",
      "chat_token",
      "allow_following_move",
      "unread_conversation_count",
      "unread_notifications_count",
      "notification_settings",
      "location"
    ]),
    ...M(a.akkoma || {}, [
      "permit_followback"
    ]),
    is_cat: o,
    speak_as_cat: b,
    ...(M(a.other_settings || {}), ["birthday", "location"]),
    __meta: M(a, ["pleroma", "source"]),
    ...a,
    display_name: a.display_name?.replace(/^[\s\u180E\u200B-\u200D\u2060\uFEFF]+|[\s\u180E\u200B-\u200D\u2060\uFEFF]+$/g, "").trim() || t,
    roles: a.roles?.length ? a.roles : Es(a.pleroma?.tags),
    source: a.source ? { ...M(a.pleroma?.source || {}, [
      "show_role",
      "no_rich_text",
      "discoverable",
      "actor_type",
      "show_birthday"
    ]), ...a.source } : void 0
  };
}), zt = e.object({
  name: e.string(),
  value: e.string(),
  verified_at: e.fallback(e.nullable(h), null)
}), Ts = e.object({
  id: e.string(),
  username: e.fallback(e.string(), ""),
  acct: e.fallback(e.string(), ""),
  url: e.pipe(e.string(), e.url()),
  display_name: e.fallback(e.string(), ""),
  note: e.fallback(e.pipe(e.string(), e.transform((a) => a === "<p></p>" ? "" : a)), ""),
  avatar: e.fallback(e.string(), ""),
  avatar_static: e.fallback(e.pipe(e.string(), e.url()), ""),
  header: e.fallback(e.pipe(e.string(), e.url()), ""),
  header_static: e.fallback(e.pipe(e.string(), e.url()), ""),
  locked: e.fallback(e.boolean(), !1),
  fields: r(zt),
  emojis: r(ee),
  bot: e.fallback(e.boolean(), !1),
  group: e.fallback(e.boolean(), !1),
  discoverable: e.fallback(e.boolean(), !1),
  indexable: e.fallback(e.nullable(e.boolean()), null),
  noindex: e.fallback(e.nullable(e.boolean()), null),
  memorial: e.fallback(e.nullable(e.boolean()), null),
  suspended: e.fallback(e.optional(e.boolean()), void 0),
  limited: e.fallback(e.optional(e.boolean()), void 0),
  created_at: e.fallback(h, (/* @__PURE__ */ new Date()).toISOString()),
  last_status_at: e.fallback(e.nullable(e.pipe(e.string(), e.isoDate())), null),
  statuses_count: e.fallback(e.number(), 0),
  followers_count: e.fallback(e.number(), 0),
  following_count: e.fallback(e.number(), 0),
  roles: r(le),
  hide_collections: e.fallback(e.optional(e.boolean()), void 0),
  fqn: e.string(),
  ap_id: e.fallback(e.nullable(e.string()), null),
  background_image: e.fallback(e.nullable(e.string()), null),
  relationship: e.fallback(e.optional(F), void 0),
  is_moderator: e.fallback(e.optional(e.boolean()), void 0),
  is_admin: e.fallback(e.optional(e.boolean()), void 0),
  is_suggested: e.fallback(e.optional(e.boolean()), void 0),
  hide_favorites: e.fallback(e.boolean(), !0),
  hide_followers: e.fallback(e.optional(e.boolean()), void 0),
  hide_follows: e.fallback(e.optional(e.boolean()), void 0),
  hide_followers_count: e.fallback(e.optional(e.boolean()), void 0),
  hide_follows_count: e.fallback(e.optional(e.boolean()), void 0),
  accepts_chat_messages: e.fallback(e.nullable(e.boolean()), null),
  favicon: e.fallback(e.optional(e.string()), void 0),
  birthday: e.fallback(e.optional(e.pipe(e.string(), e.isoDate())), void 0),
  deactivated: e.fallback(e.optional(e.boolean()), void 0),
  location: e.fallback(e.optional(e.string()), void 0),
  local: e.fallback(e.optional(e.boolean()), !1),
  permit_followback: e.fallback(e.optional(e.boolean()), void 0),
  avatar_description: e.fallback(e.string(), ""),
  custom_css: e.fallback(e.string(), ""),
  enable_rss: e.fallback(e.boolean(), !1),
  header_description: e.fallback(e.string(), ""),
  verified: e.fallback(e.optional(e.boolean()), void 0),
  domain: e.fallback(e.string(), ""),
  pronouns: e.fallback(e.array(e.string()), []),
  /** Mention policy */
  mention_policy: e.fallback(e.picklist(["none", "only_known", "only_followers"]), "none"),
  /** The reported subscribers of this user */
  subscribers_count: e.fallback(e.number(), 0),
  /** Identity proofs */
  identity_proofs: r(e.object({
    /** The key of a given field's key-value pair */
    name: e.fallback(e.string(), ""),
    /** The value associated with the name key */
    value: e.fallback(e.string(), ""),
    /** Timestamp of when the server verified the field value */
    verified_at: e.fallback(h, (/* @__PURE__ */ new Date()).toISOString())
  })),
  /** Payment options */
  payment_options: r(e.object({
    /** Payment type */
    type: e.picklist(["link", "monero-subscription"]),
    /** Link name (only for link type) */
    name: e.fallback(e.nullable(e.string()), null),
    /** Link URL (only for link type) */
    href: e.fallback(e.nullable(e.string()), null),
    /** CAIP-2 chain ID (only for monero-subscription type) */
    chain_id: e.fallback(e.nullable(e.string()), null),
    /** Subscription price (only for monero-subscription type) */
    price: e.fallback(e.nullable(e.string()), null),
    /** Unique identifier of a proposal object */
    object_id: e.fallback(e.nullable(e.string()), null)
  })),
  /** Whether the user is a cat */
  is_cat: e.fallback(e.boolean(), !1),
  /** Whether the user's posts should be nyanified */
  speak_as_cat: e.fallback(e.boolean(), !1),
  __meta: j({
    pleroma: e.optional(e.any(), void 0),
    source: e.optional(e.any(), void 0)
  }),
  avatar_default: e.fallback(e.boolean(), !1),
  header_default: e.fallback(e.boolean(), !1)
}), Ce = e.object({
  ...Ts.entries,
  moved: e.fallback(e.nullable(e.lazy(() => Ce)), null)
}), $s = e.pipe(e.any(), pt, Ce), w = $s, Os = e.pipe(e.any(), pt, e.object({
  ...Ce.entries,
  source: e.fallback(e.nullable(j({
    attribution_domains: e.fallback(e.optional(e.nullable(e.array(e.string()))), null),
    note: e.fallback(e.optional(e.string()), ""),
    fields: e.fallback(e.optional(r(zt)), []),
    privacy: e.fallback(e.optional(e.picklist(["public", "unlisted", "private", "direct"])), "public"),
    sensitive: e.fallback(e.optional(e.boolean()), !1),
    language: e.fallback(e.optional(e.nullable(e.string())), null),
    follow_requests_count: e.fallback(e.optional(e.pipe(e.number(), e.integer(), e.minValue(0))), 0),
    hide_collections: e.fallback(e.optional(e.boolean()), void 0),
    discoverable: e.fallback(e.optional(e.boolean()), void 0),
    indexable: e.fallback(e.nullable(e.boolean()), null),
    quote_policy: e.fallback(e.nullable(e.picklist(["public", "followers", "nobody"])), null),
    show_role: e.fallback(e.optional(e.nullable(e.boolean())), void 0),
    no_rich_text: e.fallback(e.optional(e.nullable(e.boolean())), void 0),
    actor_type: e.fallback(e.optional(e.string()), void 0),
    show_birthday: e.fallback(e.optional(e.boolean()), void 0),
    also_known_as_uris: e.fallback(e.optional(e.array(e.string())), void 0),
    status_content_type: e.fallback(e.optional(e.string()), void 0),
    web_layout: e.fallback(e.optional(e.picklist(["microblog", "gallery"])), void 0),
    web_visibility: e.fallback(e.optional(e.picklist(["public", "unlisted", "none"])), void 0)
  })), null),
  role: e.fallback(e.nullable(le), null),
  settings_store: e.fallback(e.optional(e.record(e.string(), e.any())), void 0),
  chat_token: e.fallback(e.optional(e.string()), void 0),
  allow_following_move: e.fallback(e.optional(e.boolean()), void 0),
  unread_conversation_count: e.fallback(e.optional(e.number()), void 0),
  unread_notifications_count: e.fallback(e.optional(e.number()), void 0),
  notification_settings: e.fallback(e.optional(e.object({
    block_from_strangers: e.fallback(e.boolean(), !1),
    hide_notification_contents: e.fallback(e.boolean(), !1)
  })), void 0)
})), ve = Os, Ps = e.pipe(e.any(), pt, e.object({
  ...Ce.entries,
  mute_expires_at: e.fallback(e.nullable(h), null)
})), As = Ps, Rs = e.object({
  text: e.string(),
  state: e.picklist(["approved", "rejected", "pending"])
}), Ht = e.object({
  id: e.string(),
  action: e.picklist(["none", "disable", "mark_statuses_as_sensitive", "delete_statuses", "sensitive", "silence", "suspend"]),
  text: e.fallback(e.string(), ""),
  status_ids: e.fallback(e.array(e.string()), []),
  target_account: w,
  appeal: e.fallback(e.nullable(Rs), null),
  created_at: e.fallback(h, (/* @__PURE__ */ new Date()).toISOString())
}), Ls = e.object({
  ip: e.pipe(e.string(), e.ip()),
  used_at: h
}), C = e.pipe(
  e.any(),
  e.transform((a) => a.account ? a : {
    id: a.id,
    account: null,
    username: a.nickname,
    domain: a.nickname.split("@")[1] || null,
    created_at: a.created_at,
    email: a.email,
    invite_request: a.registration_reason,
    role: a.roles?.is_admin ? e.parse(le, { name: "Admin" }) : a.roles?.moderator ? e.parse(le, { name: "Moderator " }) : null,
    confirmed: a.is_confirmed,
    approved: a.is_approved,
    disabled: !a.is_active,
    actor_type: a.actor_type,
    display_name: a.display_name,
    suggested: a.is_suggested
  }),
  e.object({
    id: e.string(),
    username: e.string(),
    domain: e.fallback(e.nullable(e.string()), null),
    created_at: e.fallback(h, (/* @__PURE__ */ new Date()).toISOString()),
    email: e.fallback(e.nullable(e.string()), null),
    ip: e.fallback(e.nullable(e.pipe(e.string(), e.ip())), null),
    ips: r(Ls),
    locale: e.fallback(e.nullable(e.string()), null),
    invite_request: e.fallback(e.nullable(e.string()), null),
    role: e.fallback(e.nullable(le), null),
    confirmed: e.fallback(e.boolean(), !1),
    approved: e.fallback(e.boolean(), !1),
    disabled: e.fallback(e.boolean(), !1),
    silenced: e.fallback(e.boolean(), !1),
    suspended: e.fallback(e.boolean(), !1),
    account: e.fallback(e.nullable(w), null),
    created_by_application_id: e.fallback(e.optional(e.string()), void 0),
    invited_by_account_id: e.fallback(e.optional(e.string()), void 0),
    actor_type: e.fallback(e.nullable(e.string()), null),
    display_name: e.fallback(e.nullable(e.string()), null),
    suggested: e.fallback(e.nullable(e.boolean()), null)
  })
), Xt = e.object({
  name: e.fallback(e.string(), ""),
  count: e.fallback(e.pipe(e.number(), e.integer(), e.minValue(0)), 0),
  me: e.fallback(e.boolean(), !1),
  url: e.fallback(e.nullable(e.string()), null),
  static_url: e.fallback(e.nullable(e.string()), null),
  announcement_id: e.fallback(e.string(), "")
}), Wt = e.pipe(
  e.object({
    id: e.string(),
    username: e.fallback(e.string(), ""),
    url: e.fallback(e.pipe(e.string(), e.url()), ""),
    acct: e.string()
  }),
  e.transform((a) => (a.username || (a.username = a.acct.split("@")[0]), a))
), Jt = e.array(e.object({
  day: e.pipe(e.unknown(), e.transform(Number)),
  accounts: e.pipe(e.unknown(), e.transform(Number)),
  uses: e.pipe(e.unknown(), e.transform(Number))
})), X = e.object({
  name: e.pipe(e.string(), e.transform((a) => a.startsWith("#") ? a.slice(1) : a), e.minLength(1)),
  url: e.fallback(e.pipe(e.string(), e.url()), ""),
  history: e.fallback(e.nullable(Jt), null),
  following: e.fallback(e.optional(e.boolean()), void 0),
  total: e.fallback(e.nullable(e.number()), null)
}), dt = e.object({
  id: e.string(),
  content: e.fallback(e.string(), ""),
  starts_at: e.fallback(e.nullable(h), null),
  ends_at: e.fallback(e.nullable(h), null),
  all_day: e.fallback(e.boolean(), !1),
  read: e.fallback(e.boolean(), !1),
  published_at: e.fallback(h, (/* @__PURE__ */ new Date()).toISOString()),
  reactions: r(Xt),
  statuses: e.pipe(
    e.any(),
    e.transform((a) => Array.isArray(a) ? Object.fromEntries(a.map((t) => [t.url, t.account?.acct]) || []) : a),
    e.record(e.string(), e.string())
  ),
  mentions: r(Wt),
  tags: r(X),
  emojis: r(ee),
  updated_at: e.fallback(h, (/* @__PURE__ */ new Date()).toISOString())
}), _e = e.pipe(
  e.any(),
  e.transform((a) => ({
    ...a,
    ...M(a.pleroma, "raw_content")
  })),
  e.object({
    ...dt.entries,
    raw_content: e.fallback(e.string(), "")
  })
), ke = e.object({
  id: e.string(),
  canonical_email_hash: e.string()
}), Ns = e.object({
  period: h,
  frequency: e.picklist(["day", "month"]),
  data: e.array(e.object({
    date: h,
    rate: e.number(),
    value: e.pipe(e.unknown(), e.transform(Number))
  }))
}), ue = e.object({
  category: e.fallback(e.nullable(e.string()), null),
  content_type: e.fallback(e.nullable(e.string()), null),
  disabled: e.fallback(e.boolean(), !1),
  domain: e.fallback(e.nullable(e.string()), null),
  id: e.string(),
  shortcode: e.string(),
  static_url: e.fallback(e.string(), ""),
  total_file_size: e.fallback(e.nullable(e.number()), null),
  updated_at: e.fallback(e.optional(h), void 0),
  uri: e.fallback(e.string(), ""),
  url: e.string(),
  visible_in_picker: e.fallback(e.boolean(), !0)
}), xs = e.object({
  key: e.string(),
  data: e.array(e.object({
    key: e.string(),
    human_key: e.string(),
    value: e.string(),
    unit: e.fallback(e.optional(e.string()), void 0),
    human_value: e.fallback(e.optional(e.string()), void 0)
  }))
}), Be = e.object({
  domain: e.fallback(e.string(), ""),
  id: e.pipe(e.unknown(), e.transform(String)),
  public: e.fallback(e.boolean(), !1),
  resolves: e.fallback(e.boolean(), !1),
  last_checked_at: e.fallback(e.nullable(h), null)
}), Ve = e.object({
  id: e.string(),
  domain: e.string(),
  created_at: h
}), ye = e.object({
  id: e.string(),
  domain: e.string(),
  digest: e.string(),
  created_at: h,
  severity: e.picklist(["silence", "suspend", "noop"]),
  reject_media: e.boolean(),
  reject_reports: e.boolean(),
  private_comment: e.fallback(e.nullable(e.string()), null),
  public_comment: e.fallback(e.nullable(e.string()), null),
  obfuscate: e.boolean()
}), ze = e.object({
  id: e.string(),
  domain: e.string(),
  created_at: h,
  history: e.array(e.object({
    day: e.pipe(e.unknown(), e.transform(String)),
    accounts: e.pipe(e.unknown(), e.transform(String)),
    uses: e.pipe(e.unknown(), e.transform(String))
  }))
}), je = e.object({
  id: e.string(),
  ip: e.pipe(e.string(), e.ip()),
  severity: e.picklist(["sign_up_requires_approval", "sign_up_block", "no_access"]),
  comment: e.fallback(e.string(), ""),
  created_at: h,
  expires_at: e.fallback(e.nullable(h), null)
}), Is = e.object({
  key: e.string(),
  unit: e.fallback(e.nullable(e.string()), null),
  total: e.pipe(e.unknown(), e.transform(Number)),
  human_value: e.fallback(e.optional(e.string()), void 0),
  previous_total: e.fallback(e.optional(e.pipe(e.unknown(), e.transform(Number))), void 0),
  data: e.array(e.object({
    date: tt,
    value: e.pipe(e.unknown(), e.transform(Number))
  }))
}), Ds = e.object({
  id: e.pipe(e.unknown(), e.transform(String)),
  data: e.fallback(e.record(e.string(), e.any()), {}),
  time: e.fallback(e.number(), 0),
  message: e.fallback(e.string(), "")
}), _t = e.object({
  configs: e.array(e.object({
    value: e.any(),
    group: e.string(),
    key: e.string()
  })),
  need_reboot: e.boolean()
}), He = e.pipe(
  e.any(),
  e.transform((a) => ({ id: a.actor, ...a })),
  e.object({
    actor: e.fallback(e.string(), ""),
    id: e.string(),
    followed_back: e.fallback(e.boolean(), !1)
  })
), Fs = e.object({
  id: e.string(),
  text: e.fallback(e.string(), ""),
  hint: e.fallback(e.string(), ""),
  translations: e.optional(e.record(e.string(), e.object({
    text: e.fallback(e.string(), ""),
    hint: e.fallback(e.string(), "")
  })), void 0)
}), Me = e.pipe(
  e.any(),
  e.transform((a) => ({
    ...a,
    hint: a.hint || a.subtext
  })),
  Fs
), Kt = e.object({
  count: e.fallback(e.nullable(e.number()), null),
  me: e.fallback(e.boolean(), !1),
  name: Ss,
  url: e.fallback(e.undefined(), void 0),
  static_url: e.fallback(e.undefined(), void 0),
  accounts: r(w),
  account_ids: e.fallback(r(e.string()), [])
}), Cs = e.object({
  ...Kt.entries,
  name: e.string(),
  url: e.pipe(e.string(), e.url()),
  static_url: e.pipe(e.string(), e.url())
}), mt = e.pipe(
  e.any(),
  e.transform((a) => a ? {
    url: a.url,
    static_url: a.url,
    account_ids: a.accounts?.map((t) => t?.id),
    ...a
  } : null),
  e.union([Kt, Cs])
), fe = e.object({
  id: e.string(),
  keyword: e.string(),
  whole_word: e.boolean()
}), Ne = e.object({
  id: e.string(),
  status_id: e.string()
}), Yt = e.object({
  id: e.string(),
  title: e.string(),
  context: e.array(e.picklist(["home", "notifications", "public", "thread", "account"])),
  expires_at: e.fallback(e.nullable(h), null),
  filter_action: e.fallback(e.picklist(["warn", "hide", "blur"]), "warn"),
  keywords: r(fe),
  statuses: r(Ne)
}), Se = e.pipe(
  e.any(),
  e.transform((a) => a.phrase ? {
    ...a,
    title: a.phrase,
    keywords: [{
      id: "1",
      keyword: a.phrase,
      whole_word: a.whole_word
    }],
    filter_action: a.irreversible ? "hide" : "warn"
  } : a),
  Yt
), Ms = e.omit(Yt, ["keywords", "statuses"]), Gs = e.object({
  filter: Ms,
  keyword_matches: e.fallback(e.nullable(e.string()), null),
  status_matches: e.fallback(e.nullable(e.string()), null)
});
var Fe = /* @__PURE__ */ ((a) => (a.OWNER = "owner", a.ADMIN = "admin", a.USER = "user", a))(Fe || {});
const Xe = e.pipe(e.any(), e.transform((a) => {
  if (!a.account)
    return {
      id: a.id,
      account: a,
      role: {
        founder: "owner",
        admin: "admin"
      }[a.role] || "user"
    };
}), e.object({
  id: e.string(),
  account: w,
  role: e.enum(Fe)
})), xe = e.object({
  id: e.string(),
  member: e.fallback(e.boolean(), !1),
  role: e.fallback(e.enum(Fe), Fe.USER),
  requested: e.fallback(e.boolean(), !1)
}), B = e.pipe(e.any(), e.transform((a) => {
  const t = Vt(a);
  return a?.config && (a = {
    display_name: a.name,
    members_count: a.member_count,
    note: a.short_description,
    relationship: a.self ? {
      ...a.self,
      member: a.self.is_member,
      role: {
        founder: "owner",
        admin: "admin"
      }[a.self.role] || "user",
      id: a.id
    } : null,
    ...a
  }), {
    domain: t,
    ...a,
    avatar: a.avatar || a.avatar_static,
    header: a.header || a.header_static,
    avatar_default: Bt(a.avatar || a.avatar_static),
    header_default: Ut(a.header || a.header_static)
  };
}), e.object({
  avatar: e.fallback(e.string(), ""),
  avatar_static: e.fallback(e.string(), ""),
  created_at: e.fallback(h, (/* @__PURE__ */ new Date()).toISOString()),
  display_name: e.fallback(e.string(), ""),
  domain: e.fallback(e.string(), ""),
  emojis: r(ee),
  header: e.fallback(e.string(), ""),
  header_static: e.fallback(e.string(), ""),
  id: e.pipe(e.unknown(), e.transform(String)),
  locked: e.fallback(e.boolean(), !1),
  membership_required: e.fallback(e.boolean(), !1),
  members_count: e.fallback(e.number(), 0),
  owner: e.fallback(e.nullable(e.object({ id: e.string() })), null),
  note: e.fallback(e.pipe(e.string(), e.transform((a) => a === "<p></p>" ? "" : a)), ""),
  relationship: e.fallback(e.nullable(xe), null),
  statuses_visibility: e.fallback(e.string(), "public"),
  uri: e.fallback(e.string(), ""),
  url: e.fallback(e.string(), ""),
  avatar_description: e.fallback(e.string(), ""),
  header_description: e.fallback(e.string(), ""),
  avatar_default: e.fallback(e.boolean(), !1),
  header_default: e.fallback(e.boolean(), !1)
})), kt = e.picklist(["public", "followers", "following", "mutuals", "mentioned", "author", "me"]), We = j({
  always: e.fallback(e.array(kt), ["public", "me"]),
  with_approval: e.fallback(e.array(kt), [])
}), be = j({
  can_favourite: We,
  can_reblog: We,
  can_reply: We
}), yt = j({
  public: be,
  unlisted: be,
  private: be,
  direct: be
}), Zt = e.pipe(e.string(), e.check(
  (a) => ws(a).result,
  "invalid blurhash"
  // .errorReason
)), we = e.object({
  id: e.string(),
  type: e.string(),
  url: e.fallback(e.pipe(e.string(), e.url()), ""),
  preview_url: e.fallback(e.pipe(e.string(), e.url()), ""),
  remote_url: e.fallback(e.nullable(e.pipe(e.string(), e.url())), null),
  description: e.fallback(e.string(), ""),
  blurhash: e.fallback(e.nullable(Zt), null),
  mime_type: e.fallback(e.nullable(ut), null)
}), he = e.object({
  width: e.number(),
  height: e.number(),
  size: e.fallback(e.nullable(e.pipe(e.string(), e.regex(/\d+x\d+$/))), null),
  aspect: e.fallback(e.nullable(e.number()), null)
}), Us = e.object({
  ...we.entries,
  type: e.literal("image"),
  meta: e.fallback(e.object({
    original: e.fallback(e.optional(he), void 0),
    small: e.fallback(e.optional(he), void 0),
    focus: e.fallback(e.optional(e.object({
      x: e.pipe(e.number(), e.minValue(-1), e.maxValue(1)),
      y: e.pipe(e.number(), e.minValue(-1), e.maxValue(1))
    })), void 0)
  }), {})
}), Bs = e.object({
  ...we.entries,
  type: e.literal("video"),
  meta: e.fallback(e.object({
    duration: e.fallback(e.optional(e.number()), void 0),
    original: e.fallback(e.optional(e.object({
      ...he.entries,
      frame_rate: e.fallback(e.nullable(e.pipe(e.string(), e.regex(/\d+\/\d+$/))), null),
      duration: e.fallback(e.nullable(e.pipe(e.number(), e.minValue(0))), null)
    })), void 0),
    small: e.fallback(e.optional(he), void 0)
    // WIP: add rest
  }), {})
}), Vs = e.object({
  ...we.entries,
  type: e.literal("gifv"),
  meta: e.fallback(e.object({
    duration: e.fallback(e.optional(e.number()), void 0),
    original: e.fallback(e.optional(he), void 0),
    focus: e.fallback(e.optional(e.object({
      x: e.pipe(e.number(), e.minValue(-1), e.maxValue(1)),
      y: e.pipe(e.number(), e.minValue(-1), e.maxValue(1))
    })), void 0)
  }), {})
}), zs = e.object({
  ...we.entries,
  type: e.literal("audio"),
  meta: e.fallback(e.object({
    duration: e.fallback(e.optional(e.number()), void 0),
    colors: e.fallback(e.optional(e.object({
      background: e.fallback(e.optional(e.string()), void 0),
      foreground: e.fallback(e.optional(e.string()), void 0),
      accent: e.fallback(e.optional(e.string()), void 0),
      duration: e.fallback(e.optional(e.number()), void 0)
    })), void 0),
    original: e.fallback(e.optional(e.object({
      duration: e.fallback(e.optional(e.number()), void 0),
      bitrate: e.fallback(e.optional(e.pipe(e.number(), e.minValue(0))), void 0)
    })), void 0)
  }), {})
}), Hs = e.object({
  ...we.entries,
  type: e.literal("unknown")
}), re = e.pipe(
  e.any(),
  e.transform((a) => a ? {
    mime_type: a.pleroma?.mime_type,
    preview_url: a.url,
    ...a
  } : null),
  e.variant("type", [
    Us,
    Bs,
    Vs,
    zs,
    Hs
  ])
), Xs = e.object({
  title: e.fallback(e.string(), ""),
  votes_count: e.fallback(e.number(), 0),
  title_map: e.fallback(e.nullable(e.record(e.string(), e.string())), null)
}), st = e.object({
  emojis: r(ee),
  expired: e.fallback(e.boolean(), !1),
  expires_at: e.fallback(e.nullable(h), null),
  id: e.string(),
  multiple: e.fallback(e.boolean(), !1),
  options: e.pipe(e.array(Xs), e.minLength(2)),
  voters_count: e.fallback(e.number(), 0),
  votes_count: e.fallback(e.number(), 0),
  own_votes: e.fallback(e.nullable(e.pipe(e.array(e.number()), e.minLength(1))), null),
  voted: e.fallback(e.boolean(), !1),
  non_anonymous: e.fallback(e.boolean(), !1)
}), Ws = e.object({
  name: e.string(),
  url: e.pipe(e.string(), e.url()),
  account: e.fallback(e.nullable(w), null)
}), Qt = e.object({
  /** @deprecated */
  author_name: e.fallback(e.string(), ""),
  /** @deprecated */
  author_url: e.fallback(e.pipe(e.string(), e.url()), ""),
  authors: r(Ws),
  blurhash: e.fallback(e.nullable(e.string()), null),
  description: e.fallback(e.string(), ""),
  embed_url: e.fallback(e.pipe(e.string(), e.url()), ""),
  height: e.fallback(e.number(), 0),
  html: e.fallback(e.string(), ""),
  image: e.fallback(e.nullable(e.string()), null),
  image_description: e.fallback(e.string(), ""),
  provider_name: e.fallback(e.string(), ""),
  provider_url: e.fallback(e.pipe(e.string(), e.url()), ""),
  title: e.fallback(e.string(), ""),
  type: e.fallback(e.picklist(["link", "photo", "video", "rich"]), "link"),
  url: e.pipe(e.string(), e.url()),
  width: e.fallback(e.number(), 0)
}), es = e.picklist(["pending", "accepted", "rejected", "revoked", "deleted", "unauthorized", "blocked_account", "blocked_domain", "muted-account"]), ft = e.object({
  state: e.fallback(es, "accepted"),
  quoted_status: e.fallback(e.nullable(e.lazy(() => f)), null)
}), bt = e.object({
  state: e.fallback(es, "accepted"),
  quoted_status_id: e.fallback(e.nullable(e.string()), null)
}), at = e.object({
  id: e.string(),
  url: e.string(),
  title: e.fallback(e.nullable(e.string()), null),
  description: e.fallback(e.nullable(e.string()), null),
  image_url: e.fallback(e.nullable(e.string()), null)
}), Js = e.object({
  id: e.string(),
  options: e.array(e.object({
    title: e.string()
  }))
}), Ks = e.object({
  id: e.string(),
  description: e.fallback(e.string(), "")
}), nt = e.pipe(
  e.any(),
  e.transform((a) => a?.text ? {
    content: a.text,
    detected_source_language: a.detected_language
  } : a),
  e.object({
    id: e.fallback(e.nullable(e.string()), null),
    content: e.fallback(e.string(), ""),
    spoiler_text: e.fallback(e.string(), ""),
    poll: e.fallback(e.optional(Js), void 0),
    media_attachments: r(Ks),
    detected_source_language: e.string(),
    provider: e.fallback(e.nullable(e.string()), null)
  })
), Ys = e.object({
  name: e.fallback(e.string(), ""),
  start_time: e.fallback(e.nullable(h), null),
  end_time: e.fallback(e.nullable(h), null),
  join_mode: e.fallback(e.nullable(e.picklist(["free", "restricted", "invite", "external"])), null),
  participants_count: e.fallback(e.number(), 0),
  location: e.fallback(e.nullable(e.object({
    name: e.fallback(e.string(), ""),
    url: e.fallback(e.pipe(e.string(), e.url()), ""),
    latitude: e.fallback(e.nullable(e.number()), null),
    longitude: e.fallback(e.nullable(e.number()), null),
    street: e.fallback(e.string(), ""),
    postal_code: e.fallback(e.string(), ""),
    locality: e.fallback(e.string(), ""),
    region: e.fallback(e.string(), ""),
    country: e.fallback(e.string(), "")
  })), null),
  join_state: e.fallback(e.nullable(e.picklist(["pending", "reject", "accept"])), null)
}), ht = e.object({
  id: e.string(),
  uri: e.fallback(e.pipe(e.string(), e.url()), ""),
  created_at: e.fallback(h, (/* @__PURE__ */ new Date()).toISOString()),
  account: w,
  content: e.fallback(e.pipe(e.string(), e.transform((a) => a === "<p></p>" ? "" : a)), ""),
  visibility: e.fallback(e.string(), "public"),
  sensitive: e.pipe(e.unknown(), e.transform(Boolean)),
  spoiler_text: e.fallback(e.string(), ""),
  media_attachments: r(re),
  application: e.fallback(e.nullable(e.object({
    name: e.string(),
    website: e.fallback(e.nullable(e.pipe(e.string(), e.url())), null)
  })), null),
  mentions: r(Wt),
  tags: r(X),
  emojis: r(ee),
  reblogs_count: e.fallback(e.number(), 0),
  favourites_count: e.fallback(e.number(), 0),
  replies_count: e.fallback(e.number(), 0),
  url: e.fallback(e.pipe(e.string(), e.url()), ""),
  in_reply_to_id: e.fallback(e.nullable(e.string()), null),
  in_reply_to_account_id: e.fallback(e.nullable(e.string()), null),
  poll: e.fallback(e.nullable(st), null),
  card: e.fallback(e.nullable(Qt), null),
  language: e.fallback(e.nullable(e.string()), null),
  text: e.fallback(e.nullable(e.string()), null),
  edited_at: e.fallback(e.nullable(h), null),
  favourited: e.fallback(e.pipe(e.unknown(), e.transform(Boolean)), !1),
  reblogged: e.fallback(e.pipe(e.unknown(), e.transform(Boolean)), !1),
  muted: e.fallback(e.pipe(e.unknown(), e.transform(Boolean)), !1),
  bookmarked: e.fallback(e.pipe(e.unknown(), e.transform(Boolean)), !1),
  pinned: e.fallback(e.pipe(e.unknown(), e.transform(Boolean)), !1),
  filtered: r(Gs),
  approval_status: e.fallback(e.nullable(e.picklist(["pending", "approval", "rejected"])), null),
  group: e.fallback(e.nullable(B), null),
  scheduled_at: e.fallback(e.null(), null),
  quote_id: e.fallback(e.nullable(e.string()), null),
  local: e.fallback(e.optional(e.boolean()), void 0),
  conversation_id: e.fallback(e.optional(e.string()), void 0),
  direct_conversation_id: e.fallback(e.optional(e.string()), void 0),
  in_reply_to_account_acct: e.fallback(e.optional(e.string()), void 0),
  expires_at: e.fallback(e.optional(h), void 0),
  thread_muted: e.fallback(e.optional(e.boolean()), void 0),
  emoji_reactions: r(mt),
  parent_visible: e.fallback(e.optional(e.boolean()), void 0),
  pinned_at: e.fallback(e.nullable(h), null),
  quote_visible: e.fallback(e.optional(e.boolean()), void 0),
  quote_url: e.fallback(e.optional(e.string()), void 0),
  quotes_count: e.fallback(e.number(), 0),
  bookmark_folder: e.fallback(e.nullable(e.string()), null),
  list_id: e.fallback(e.nullable(e.number()), null),
  event: e.fallback(e.nullable(Ys), null),
  translation: e.fallback(e.union([e.nullable(nt), e.literal(!1)]), null),
  rss_feed: e.fallback(e.nullable(at), null),
  content_map: e.fallback(e.nullable(e.record(e.string(), e.string())), null),
  text_map: e.fallback(e.nullable(e.record(e.string(), e.string())), null),
  spoiler_text_map: e.fallback(e.nullable(e.record(e.string(), e.string())), null),
  dislikes_count: e.fallback(e.number(), 0),
  disliked: e.fallback(e.pipe(e.unknown(), e.transform(Boolean)), !1),
  local_only: e.fallback(e.optional(e.boolean()), void 0),
  interaction_policy: be,
  content_type: e.fallback(e.nullable(e.string()), null)
}), ts = (a) => {
  if (!a) return null;
  let t = null;
  const s = a.quote ?? a.pleroma?.quote;
  let n = s?.id ?? a.quote_id ?? a.pleroma?.quote_id;
  return s?.state ? (t = s, n = s.quoted_status?.id || s.quoted_status_id) : s ? t = {
    state: "accepted",
    quoted_status: s
  } : n && (t = {
    state: "accepted",
    quoted_status_id: n
  }), a = {
    // @ts-ignore
    emoji_reactions: a.reactions,
    ...M(a.pleroma || {}, [
      "local",
      "conversation_id",
      "direct_conversation_id",
      "in_reply_to_account_acct",
      "expires_at",
      "thread_muted",
      "emoji_reactions",
      "parent_visible",
      "pinned_at",
      "quote_url",
      "quote_visible",
      "quotes_count",
      "bookmark_folder",
      "list_id",
      "event",
      "translation",
      "rss_feed"
    ]),
    ...M(a.friendica || {}, [
      "dislikes_count",
      "disliked"
    ]),
    ...a,
    quote: t,
    quote_id: n
  }, !a.interaction_policy && a.comments_disabled === !0 && (a.interaction_policy = {
    can_reply: {
      always: ["author"]
    }
  }), a;
}, f = e.pipe(e.any(), e.transform(ts), e.object({
  ...ht.entries,
  reblog: e.fallback(e.nullable(e.lazy(() => f)), null),
  quote: e.fallback(e.nullable(e.lazy(() => e.union([ft, bt]))), null)
})), Zs = e.pipe(e.any(), e.transform(ts), e.object({
  ...e.omit(ht, ["account"]).entries,
  account: e.fallback(e.nullable(w), null),
  reblog: e.fallback(e.nullable(e.lazy(() => f)), null),
  quote: e.fallback(e.nullable(e.lazy(() => e.union([ft, bt]))), null)
})), Qs = e.partial(e.object({
  ...ht.entries,
  reblog: e.fallback(e.nullable(e.lazy(() => f)), null),
  quote: e.fallback(e.nullable(e.lazy(() => e.union([ft, bt]))), null)
})), Z = e.pipe(
  e.any(),
  e.transform((a) => a.actor ? {
    action_taken: a.state !== "open",
    comment: a.content,
    updated_at: a.created_at,
    account: a.actor,
    target_account: a.account,
    ...M(a, ["id", "assigned_account", "created_at", "rules", "statuses"])
  } : a),
  e.object({
    id: e.string(),
    action_taken: e.fallback(e.optional(e.boolean()), void 0),
    action_taken_at: e.fallback(e.nullable(h), null),
    category: e.fallback(e.optional(e.string()), void 0),
    comment: e.fallback(e.optional(e.string()), void 0),
    forwarded: e.fallback(e.optional(e.boolean()), void 0),
    created_at: e.fallback(e.optional(h), void 0),
    updated_at: e.fallback(e.optional(h), void 0),
    account: C,
    target_account: C,
    assigned_account: e.fallback(e.nullable(C), null),
    action_taken_by_account: e.fallback(e.nullable(C), null),
    statuses: r(Zs),
    rules: r(Me)
  })
), Je = e.object({
  id: e.string(),
  text: e.fallback(e.string(), ""),
  hint: e.fallback(e.string(), ""),
  priority: e.fallback(e.nullable(e.number()), null),
  created_at: e.fallback(e.optional(h), void 0),
  updated_at: e.fallback(e.optional(h), void 0)
}), ea = e.object({
  ...X.entries,
  id: e.string(),
  trendable: e.boolean(),
  usable: e.boolean(),
  requires_review: e.boolean()
}), Q = e.object({
  id: e.pipe(e.unknown(), e.transform(String)),
  title: e.string(),
  replies_policy: e.fallback(e.optional(e.picklist(["none", "list", "followed"])), void 0),
  exclusive: e.fallback(e.optional(e.boolean()), void 0),
  antennas: r(e.lazy(() => ae)),
  notify: e.fallback(e.optional(e.boolean()), void 0),
  favourite: e.fallback(e.optional(e.boolean()), void 0)
}), ta = e.object({
  id: e.string(),
  title: e.string(),
  with_media_only: e.boolean(),
  ignore_reblog: e.boolean(),
  stl: e.boolean(),
  ltl: e.boolean(),
  insert_feeds: e.boolean(),
  accounts_count: e.number(),
  domains_count: e.number(),
  tags_count: e.number(),
  keywords_count: e.number(),
  favourite: e.boolean()
}), ae = e.object({
  ...ta.entries,
  list: e.fallback(e.nullable(e.lazy(() => Q)), null)
}), Ie = e.pipe(e.any(), e.transform((a) => ({
  redirect_uris: [a.redirect_uri],
  ...a
})), e.object({
  name: e.fallback(e.string(), ""),
  website: e.fallback(e.optional(e.string()), void 0),
  redirect_uris: r(e.string()),
  id: e.fallback(e.optional(e.string()), void 0),
  /** @deprecated */
  redirect_uri: e.fallback(e.optional(e.string()), void 0),
  /** @deprecated */
  vapid_key: e.fallback(e.optional(e.string()), void 0)
})), sa = e.pipe(
  Ie.pipe[0],
  Ie.pipe[1],
  e.object({
    ...Ie.pipe[2].entries,
    client_id: e.string(),
    client_secret: e.string(),
    client_secret_expires_at: e.fallback(e.nullable(e.pipe(e.unknown(), e.transform(Number))), null)
  })
), aa = e.object({
  async_refresh: e.object({
    id: e.string(),
    status: e.picklist(["running", "finished"]),
    result_count: e.nullable(e.number())
  })
}), na = e.object({
  issuer: e.string(),
  service_documentation: e.string(),
  authorization_endpoint: e.string(),
  token_endpoint: e.string(),
  app_registration_endpoint: e.string(),
  revocation_endpoint: e.string(),
  userinfo_endpoint: e.string(),
  scopes_supported: e.array(e.string()),
  response_types_supported: e.array(e.string()),
  response_modes_supported: e.array(e.string()),
  code_challenge_methods_supported: e.array(e.string()),
  grant_types_supported: e.array(e.string()),
  token_endpoint_auth_methods_supported: e.array(e.string())
}), jt = e.object({
  id: e.pipe(e.unknown(), e.transform(String)),
  content_type: ut,
  file_size: e.fallback(e.number(), 0),
  inserted_at: h,
  processed: e.fallback(e.boolean(), !1),
  url: e.fallback(e.string(), "")
}), pe = e.pipe(e.any(), e.transform((a) => ({
  name: a.title,
  ...a
})), e.object({
  id: e.pipe(e.unknown(), e.transform(String)),
  name: e.fallback(e.string(), ""),
  emoji: e.fallback(e.nullable(e.string()), null),
  emoji_url: e.fallback(e.nullable(e.string()), null)
})), ce = e.object({
  id: e.string(),
  content: e.fallback(e.string(), ""),
  chat_id: e.string(),
  account_id: e.string(),
  created_at: h,
  emojis: r(ee),
  attachment: e.fallback(e.nullable(re), null),
  unread: e.boolean(),
  card: e.fallback(e.nullable(Qt), null)
}), ne = e.object({
  id: e.string(),
  account: w,
  unread: e.pipe(e.number(), e.integer()),
  last_message: e.fallback(e.nullable(ce), null),
  updated_at: h
}), de = e.object({
  id: e.string(),
  title: e.string()
}), oa = e.object({
  ancestors: r(f),
  descendants: r(f),
  references: e.fallback(r(f), [])
}), ot = e.object({
  id: e.string(),
  unread: e.fallback(e.boolean(), !1),
  accounts: r(w),
  last_status: e.fallback(e.nullable(f), null)
}), ra = e.object({
  category: e.string(),
  servers_count: e.fallback(e.nullable(e.pipe(e.unknown(), e.transform(Number))), null)
}), ia = e.object({
  locale: e.string(),
  language: e.string(),
  servers_count: e.fallback(e.nullable(e.pipe(e.unknown(), e.transform(Number))), null)
}), la = e.object({
  domain: e.string(),
  version: e.string(),
  description: e.string(),
  languages: e.array(e.string()),
  region: e.string(),
  categories: e.array(e.string()),
  proxied_thumbnail: e.fallback(e.nullable(e.pipe(e.string(), e.url())), null),
  blurhash: e.fallback(e.nullable(e.string()), null),
  total_users: e.pipe(e.unknown(), e.transform(Number)),
  last_week_users: e.pipe(e.unknown(), e.transform(Number)),
  approval_required: e.boolean(),
  language: e.string(),
  category: e.string()
}), ca = e.object({
  period: e.pipe(e.string(), e.isoDate()),
  server_count: e.fallback(e.nullable(e.pipe(e.unknown(), e.transform(Number))), null),
  user_count: e.fallback(e.nullable(e.pipe(e.unknown(), e.transform(Number))), null),
  active_user_count: e.fallback(e.nullable(e.pipe(e.unknown(), e.transform(Number))), null)
}), ua = e.object({
  domain: e.string(),
  digest: e.string(),
  severity: e.picklist(["silence", "suspend"]),
  comment: e.fallback(e.optional(e.string()), void 0)
}), De = e.pipe(e.any(), e.transform((a) => ({
  ...a,
  thumbnail_url: a.thumbnailUrl,
  content_type: a.contentType,
  is_avatar: a.isAvatar,
  is_banner: a.isBanner
})), e.object({
  id: e.string(),
  url: e.string(),
  thumbnail_url: e.string(),
  filename: e.string(),
  content_type: e.string(),
  sensitive: e.boolean(),
  description: e.fallback(e.nullable(e.string()), null),
  is_avatar: e.boolean(),
  is_banner: e.boolean()
})), pa = e.object({
  id: e.fallback(e.nullable(e.string()), null),
  name: e.fallback(e.nullable(e.string()), null),
  parent_id: e.fallback(e.nullable(e.string()), null),
  files: r(De)
}), oe = e.pipe(e.any(), e.transform((a) => ({
  ...a,
  parent_id: a.parentId
})), e.object({
  ...pa.entries,
  folders: r(e.lazy(() => oe))
})), da = e.object({
  updated_at: h,
  content: e.string()
}), ma = e.object({
  id: e.string(),
  accounts: r(w)
}), Ke = e.object({
  id: e.string(),
  name: e.string(),
  url: e.fallback(e.optional(e.string()), void 0),
  statuses_count: e.number(),
  last_status_at: e.number()
}), ss = e.object({
  id: e.string(),
  type: e.picklist(["domain_block", "user_domain_block", "account_suspension"]),
  purged: e.string(),
  relationships_count: e.fallback(e.optional(e.number()), void 0),
  created_at: h
}), wt = e.object({
  id: e.string(),
  action_taken: e.fallback(e.optional(e.boolean()), void 0),
  action_taken_at: e.fallback(e.nullable(h), null),
  category: e.fallback(e.optional(e.string()), void 0),
  comment: e.fallback(e.optional(e.string()), void 0),
  forwarded: e.fallback(e.optional(e.boolean()), void 0),
  created_at: e.fallback(e.optional(h), void 0),
  status_ids: e.fallback(e.nullable(e.string()), null),
  rule_ids: e.fallback(e.nullable(e.string()), null),
  target_account: e.fallback(e.nullable(w), null)
}), fa = e.object({
  id: e.string(),
  acct: e.string(),
  url: e.pipe(e.string(), e.url()),
  avatar: e.pipe(e.string(), e.url()),
  avatar_static: e.pipe(e.string(), e.url()),
  locked: e.boolean(),
  bot: e.boolean()
}), W = e.object({
  group_key: e.string(),
  notifications_count: e.pipe(e.number(), e.integer()),
  most_recent_notification_id: e.pipe(e.unknown(), e.transform(String), e.string()),
  page_min_id: e.fallback(e.optional(e.string()), void 0),
  page_max_id: e.fallback(e.optional(e.string()), void 0),
  latest_page_notification_at: e.fallback(e.optional(h), void 0),
  sample_account_ids: e.array(e.string()),
  is_muted: e.fallback(e.optional(e.boolean()), void 0),
  is_seen: e.fallback(e.optional(e.boolean()), void 0)
}), ba = e.object({
  ...W.entries,
  type: e.picklist(["follow", "follow_request", "admin.sign_up", "bite"])
}), ha = e.object({
  ...W.entries,
  type: e.literal("mention"),
  subtype: e.fallback(e.nullable(e.picklist(["reply"])), null),
  status_id: e.string()
}), wa = e.object({
  ...W.entries,
  type: e.picklist(["status", "reblog", "favourite", "poll", "update", "event_reminder", "quote", "quoted_update"]),
  status_id: e.string()
}), ga = e.object({
  ...W.entries,
  type: e.literal("admin.report"),
  report: wt
}), va = e.object({
  ...W.entries,
  type: e.literal("severed_relationships"),
  relationship_severance_event: ss
}), _a = e.object({
  ...W.entries,
  type: e.literal("moderation_warning"),
  moderation_warning: Ht
}), ka = e.object({
  ...W.entries,
  type: e.literal("move"),
  target_id: e.string()
}), ya = e.object({
  ...W.entries,
  type: e.literal("emoji_reaction"),
  emoji: e.string(),
  emoji_url: e.fallback(e.nullable(e.string()), null),
  status_id: e.string()
}), ja = e.object({
  ...W.entries,
  type: e.literal("chat_mention"),
  chat_message: ce
}), Sa = e.object({
  ...W.entries,
  type: e.picklist(["participation_accepted", "participation_request"]),
  status_id: e.string(),
  participation_message: e.fallback(e.nullable(e.string()), null)
}), Ea = e.pipe(
  e.any(),
  e.transform((a) => ({
    group_key: `ungrouped-${a.id}`,
    ...M(a.pleroma || {}, ["is_muted", "is_seen"]),
    ...a,
    type: a.type === "pleroma:report" ? "admin.report" : a.type === "reaction" ? "emoji_reaction" : a.type?.replace(/^pleroma:/, "")
  })),
  e.variant("type", [
    ba,
    ha,
    wa,
    ga,
    va,
    _a,
    ka,
    ya,
    ja,
    Sa
  ])
), St = e.object({
  accounts: r(w),
  partial_accounts: e.fallback(e.optional(e.array(fa)), void 0),
  statuses: r(f),
  notification_groups: r(Ea)
}), qa = /^([0-9.]*) \(not true; really snac\/([\w.]*)\)/, Ta = /^WordPress\/[\w+.-]*, EMA\/([\w+.-]*)/, $a = (a) => ({
  ...Object.fromEntries(a.pleroma?.metadata?.features?.map((t) => {
    let s = `${t}.pleroma.pl-api`;
    return (s.startsWith("pleroma:") || s.startsWith("pleroma_")) && (s = s.slice(8)), s.startsWith("akkoma:") && (s = s.slice(7)), s.startsWith("pl:") && (s = s.slice(3)), [s, 1];
  }) || []),
  ...Object.fromEntries(a.fedibird_capabilities?.map((t) => [`${t}.fedibird.pl-api`, 1]) || []),
  ...a.api_versions
}), Oa = (a) => {
  const {
    approval_required: t,
    configuration: s,
    contact_account: n,
    description: o,
    description_limit: b,
    email: g,
    max_media_attachments: S,
    max_toot_chars: i,
    poll_limits: _,
    pleroma: u,
    registrations: J,
    short_description: T,
    thumbnail: I,
    upload_limit: N,
    uri: k,
    urls: z,
    ...D
  } = e.parse(xa, a);
  return {
    ...D,
    account_domain: D.account_domain || k,
    configuration: {
      ...s,
      media_attachments: {
        ...s.media_attachments,
        image_size_limit: N ?? s.media_attachments.image_size_limit,
        video_size_limit: N ?? s.media_attachments.video_size_limit
      },
      polls: {
        ...s.polls,
        max_characters_per_option: _.max_option_chars ?? s.polls.max_characters_per_option,
        max_expiration: _.max_expiration ?? s.polls.max_expiration,
        max_options: _.max_options ?? s.polls.max_options,
        min_expiration: _.min_expiration ?? s.polls.min_expiration
      },
      statuses: {
        ...s.statuses,
        max_characters: i ?? s.statuses.max_characters,
        max_media_attachments: S ?? s.statuses.max_media_attachments
      },
      urls: {
        streaming: z.streaming_api
      },
      vapid: {
        public_key: u.vapid_public_key
      }
    },
    contact: {
      account: n,
      email: g
    },
    description: T || o,
    domain: k,
    pleroma: {
      ...u,
      metadata: {
        ...u.metadata,
        description_limit: b
      }
    },
    registrations: {
      approval_required: t,
      enabled: J
    },
    thumbnail: { url: I }
  };
}, Pa = (a) => {
  if (new RegExp(/[0-9.]+rc[0-9]+/g).test(a))
    return a.split("rc").join("-rc");
  if (a.startsWith("takahe/"))
    return `0.0.0 (compatible; Takahe ${a.slice(7)})`;
  if (a.startsWith("neodb/"))
    return `0.0.0 (compatible; NeoDB ${a.slice(7)})`;
  const t = Ta.exec(a);
  if (t)
    return `0.0.0 (compatible; WordPress ${t[1]})`;
  const s = qa.exec(a);
  return s ? `${s[1]} (compatible; snac ${s[2]})` : a;
}, as = j({
  accounts: e.fallback(e.nullable(e.object({
    allow_custom_css: e.boolean(),
    max_featured_tags: e.pipe(e.number(), e.integer()),
    max_profile_fields: e.pipe(e.number(), e.integer())
  })), null),
  chats: j({
    max_characters: e.fallback(e.number(), 5e3)
  }),
  groups: j({
    max_characters_description: e.fallback(e.number(), 160),
    max_characters_name: e.fallback(e.number(), 50)
  }),
  media_attachments: j({
    image_matrix_limit: e.fallback(e.optional(e.number()), void 0),
    image_size_limit: e.fallback(e.optional(e.number()), void 0),
    supported_mime_types: e.fallback(e.optional(e.array(ut)), void 0),
    video_duration_limit: e.fallback(e.optional(e.number()), void 0),
    video_frame_rate_limit: e.fallback(e.optional(e.number()), void 0),
    video_matrix_limit: e.fallback(e.optional(e.number()), void 0),
    video_size_limit: e.fallback(e.optional(e.number()), void 0)
  }),
  polls: j({
    max_characters_per_option: e.fallback(e.number(), 25),
    max_expiration: e.fallback(e.number(), 2629746),
    max_options: e.fallback(e.number(), 4),
    min_expiration: e.fallback(e.number(), 300)
  }),
  reactions: j({
    max_reactions: e.fallback(e.number(), 0)
  }),
  statuses: j({
    characters_reserved_per_url: e.fallback(e.optional(e.number()), void 0),
    max_characters: e.fallback(e.number(), 500),
    max_media_attachments: e.fallback(e.number(), 4)
  }),
  translation: j({
    enabled: e.fallback(e.boolean(), !1)
  }),
  timelines_access: j({
    ...e.entriesFromList(
      ["hashtag_feeds", "trending_link_feeds"],
      j(
        e.entriesFromList(
          ["local", "remote"],
          e.fallback(e.picklist(["public", "authenticated", "disabled"]), "public")
        )
      )
    ),
    live_feeds: j(
      e.entriesFromList(
        ["local", "bubble", "remote", "wrenched"],
        e.fallback(e.picklist(["public", "authenticated", "disabled"]), "public")
      )
    )
  }),
  urls: j({
    streaming: e.fallback(e.optional(e.pipe(e.string(), e.url())), void 0),
    status: e.fallback(e.optional(e.pipe(e.string(), e.url())), void 0),
    about: e.fallback(e.nullable(e.string()), null),
    privacy_policy: e.fallback(e.nullable(e.string()), null),
    terms_of_service: e.fallback(e.nullable(e.string()), null)
  }),
  vapid: j({
    public_key: e.fallback(e.string(), "")
  }),
  limited_federation: e.optional(e.boolean(), void 0)
}), Aa = j({
  contact_account: e.fallback(e.optional(w), void 0),
  email: e.fallback(e.pipe(e.string(), e.email()), "")
}), ns = j({
  metadata: j({
    account_activation_required: e.fallback(e.boolean(), !1),
    birthday_min_age: e.fallback(e.number(), 0),
    birthday_required: e.fallback(e.boolean(), !1),
    description_limit: e.fallback(e.number(), 1500),
    federation: j({
      enabled: e.fallback(e.boolean(), !0),
      // Assume true unless explicitly false
      mrf_policies: e.fallback(e.optional(e.array(e.string())), void 0),
      mrf_simple: j(e.entriesFromList(
        [
          "accept",
          "avatar_removal",
          "banner_removal",
          "federated_timeline_removal",
          "followers_only",
          "media_nsfw",
          "media_removal",
          "reject",
          "reject_deletes",
          "report_removal"
        ],
        e.fallback(e.array(e.string()), [])
      )),
      mrf_simple_info: j(e.entriesFromList(
        [
          "accept",
          "avatar_removal",
          "banner_removal",
          "federated_timeline_removal",
          "followers_only",
          "media_nsfw",
          "media_removal",
          "reject",
          "reject_deletes",
          "report_removal"
        ],
        e.fallback(e.array(e.tuple([e.string(), e.string()])), [])
      ))
    }),
    fields_limits: j({
      max_fields: e.fallback(e.pipe(e.number(), e.integer(), e.minValue(0)), 4),
      name_length: e.fallback(e.pipe(e.number(), e.integer(), e.minValue(0)), 255),
      value_length: e.fallback(e.pipe(e.number(), e.integer(), e.minValue(0)), 2047)
    }),
    markup: j({
      allow_headings: e.fallback(e.boolean(), !1),
      allow_inline_images: e.fallback(e.boolean(), !1)
    }),
    migration_cooldown_period: e.fallback(e.optional(e.number()), void 0),
    multitenancy: j({
      domains: e.optional(e.array(
        e.object({
          domain: e.pipe(e.unknown(), e.transform(String)),
          id: e.string(),
          public: e.fallback(e.boolean(), !1)
        })
      )),
      enabled: e.fallback(e.boolean(), !1)
    }),
    post_formats: e.fallback(e.array(e.string()), ["text/plain"]),
    restrict_unauthenticated: j({
      activities: j({
        local: e.fallback(e.boolean(), !1),
        remote: e.fallback(e.boolean(), !1)
      }),
      profiles: j({
        local: e.fallback(e.boolean(), !1),
        remote: e.fallback(e.boolean(), !1)
      }),
      timelines: j({
        bubble: e.fallback(e.boolean(), !1),
        federated: e.fallback(e.boolean(), !1),
        local: e.fallback(e.boolean(), !1),
        wrenched: e.fallback(e.boolean(), !1)
      })
    }),
    translation: j({
      allow_remote: e.fallback(e.boolean(), !0),
      allow_unauthenticated: e.fallback(e.boolean(), !1),
      source_languages: e.fallback(e.optional(e.array(e.string())), void 0),
      target_languages: e.fallback(e.optional(e.array(e.string())), void 0)
    })
  }),
  oauth_consumer_strategies: e.fallback(e.array(e.string()), []),
  stats: j({
    mau: e.fallback(e.optional(e.number()), void 0)
  }),
  vapid_public_key: e.fallback(e.string(), "")
}), Ra = j({
  max_expiration: e.fallback(e.optional(e.number()), void 0),
  max_option_chars: e.fallback(e.optional(e.number()), void 0),
  max_options: e.fallback(e.optional(e.number()), void 0),
  min_expiration: e.fallback(e.optional(e.number()), void 0)
}), La = j({
  approval_required: e.fallback(e.boolean(), !1),
  enabled: e.fallback(e.boolean(), !1),
  message: e.fallback(e.optional(e.string()), void 0),
  min_age: e.fallback(e.nullable(e.number()), null),
  reason_required: e.fallback(e.nullable(e.boolean()), null),
  url: e.fallback(e.nullable(e.pipe(e.string(), e.url())), null)
}), os = j({
  domain_count: e.fallback(e.optional(e.number()), void 0),
  status_count: e.fallback(e.optional(e.number()), void 0),
  user_count: e.fallback(e.optional(e.number()), void 0)
}), Na = j({
  url: e.fallback(e.string(), "")
}), rs = j({
  users: j({
    active_month: e.fallback(e.number(), 0)
  })
}), xa = j({
  account_domain: e.fallback(e.string(), ""),
  approval_required: e.fallback(e.boolean(), !1),
  configuration: as,
  contact_account: e.fallback(e.optional(w), void 0),
  description: e.fallback(e.string(), ""),
  description_limit: e.fallback(e.number(), 1500),
  email: e.fallback(e.pipe(e.string(), e.email()), ""),
  feature_quote: e.fallback(e.boolean(), !1),
  languages: e.fallback(e.array(e.string()), []),
  max_media_attachments: e.fallback(e.optional(e.number()), void 0),
  max_toot_chars: e.fallback(e.optional(e.number()), void 0),
  pleroma: ns,
  poll_limits: Ra,
  registrations: e.fallback(e.boolean(), !1),
  rules: r(Me),
  short_description: e.fallback(e.string(), ""),
  stats: os,
  thumbnail: e.fallback(e.string(), ""),
  title: e.fallback(e.string(), ""),
  upload_limit: e.fallback(e.optional(e.number()), void 0),
  uri: e.fallback(e.string(), ""),
  urls: j({
    streaming_api: e.fallback(e.optional(e.pipe(e.string(), e.url())), void 0)
  }),
  usage: rs,
  version: e.fallback(e.string(), "0.0.0")
}), Et = e.pipe(
  e.any(),
  e.transform((a) => {
    a.source_url === "https://github.com/fedify-dev/hollo" && (a.version = `0.0.0 (compatible; Hollo ${a.version})`), typeof a.configuration?.accounts?.allow_custom_css == "boolean" && (a.version = `0.0.0 (compatible; GoToSocial ${a.version})`);
    const t = $a(a);
    if (a.pleroma || (a.pleroma = {
      metadata: {
        post_formats: a.configuration?.statuses?.supported_mime_types || (t["kmyblue_markdown.fedibird.pl-api"] ? ["text/plain", "text/markdown"] : [])
      }
    }), a.pleroma?.metadata?.restrict_unauthenticated?.timelines) {
      const s = a.pleroma.metadata.restrict_unauthenticated.timelines, n = a.pleroma.metadata.features || [];
      a.configuration || (a.configuration = {}), a.configuration.timelines_access = {
        ...a.configuration.timelines_access,
        live_feeds: {
          bubble: s.bubble ? "authenticated" : n.includes("bubble_timeline") ? "public" : "disabled",
          local: s.local ? "authenticated" : "public",
          remote: s.federated ? "authenticated" : "public",
          wrenched: s.wrenched ? "authenticated" : n.includes("pleroma:wrenched_timeline") ? "public" : "disabled"
        }
      };
    }
    return a.domain ? { account_domain: a.domain, ...a, api_versions: t } : { ...Oa(a), api_versions: t };
  }),
  j({
    account_domain: e.fallback(e.string(), ""),
    api_versions: e.fallback(e.record(e.string(), e.number()), {}),
    configuration: as,
    contact: Aa,
    description: e.fallback(e.string(), ""),
    domain: e.fallback(e.string(), ""),
    feature_quote: e.fallback(e.boolean(), !1),
    icons: r(e.object({
      size: e.pipe(e.string(), e.regex(/^[0-9]+x[0-9]+$/)),
      src: e.string()
    })),
    languages: e.fallback(e.array(e.string()), []),
    pleroma: ns,
    registrations: La,
    rules: r(Me),
    stats: os,
    thumbnail: Na,
    title: e.fallback(e.string(), ""),
    usage: rs,
    version: e.pipe(e.fallback(e.string(), "0.0.0"), e.transform(Pa))
  })
), Ee = e.object({
  accepted_at: e.fallback(e.nullable(h), null),
  account: w,
  created_at: h,
  id: e.string(),
  rejected_at: e.fallback(e.nullable(h), null),
  reply: e.fallback(e.nullable(f), null),
  status: e.fallback(e.nullable(f), null),
  type: e.picklist(["favourite", "reply", "reblog"]),
  uri: e.fallback(e.nullable(e.string()), null)
}), is = e.object({
  url: e.fallback(e.pipe(e.string(), e.url()), ""),
  description: e.fallback(e.string(), ""),
  country: e.fallback(e.string(), ""),
  locality: e.fallback(e.string(), ""),
  region: e.fallback(e.string(), ""),
  postal_code: e.fallback(e.string(), ""),
  street: e.fallback(e.string(), ""),
  origin_id: e.fallback(e.string(), ""),
  origin_provider: e.fallback(e.string(), ""),
  type: e.fallback(e.string(), ""),
  timezone: e.fallback(e.string(), ""),
  geom: e.fallback(e.nullable(e.object({
    coordinates: e.fallback(e.nullable(e.tuple([e.number(), e.number()])), null),
    srid: e.fallback(e.string(), "")
  })), null)
}), Ia = e.pipe(
  e.any(),
  e.transform((a) => a ? {
    unread_count: a.pleroma?.unread_count,
    ...a
  } : null),
  e.object({
    last_read_id: e.string(),
    version: e.pipe(e.number(), e.integer()),
    updated_at: h,
    unread_count: e.fallback(e.optional(e.pipe(e.number(), e.integer())), void 0)
  })
), rt = e.record(e.string(), Ia), V = e.object({
  account: w,
  created_at: e.fallback(h, (/* @__PURE__ */ new Date()).toISOString()),
  id: e.string(),
  group_key: e.string(),
  type: e.string(),
  is_muted: e.fallback(e.optional(e.boolean()), void 0),
  is_seen: e.fallback(e.optional(e.boolean()), void 0)
}), Da = e.object({
  ...V.entries,
  type: e.picklist(["follow", "follow_request", "admin.sign_up"])
}), Fa = e.object({
  ...V.entries,
  type: e.literal("mention"),
  subtype: e.fallback(e.nullable(e.picklist(["reply"])), null),
  status: f
}), Ca = e.object({
  ...V.entries,
  type: e.picklist(["status", "reblog", "favourite", "poll", "update", "quote", "quoted_update", "event_reminder"]),
  status: f
}), Ma = e.object({
  ...V.entries,
  type: e.literal("admin.report"),
  report: wt
}), Ga = e.object({
  ...V.entries,
  type: e.literal("severed_relationships"),
  event: ss
}), Ua = e.object({
  ...V.entries,
  type: e.literal("moderation_warning"),
  moderation_warning: Ht
}), Ba = e.object({
  ...V.entries,
  type: e.literal("move"),
  target: w
}), Va = e.object({
  ...V.entries,
  type: e.literal("emoji_reaction"),
  emoji: e.string(),
  emoji_url: e.fallback(e.nullable(e.string()), null),
  status: f
}), za = e.object({
  ...V.entries,
  type: e.literal("chat_mention"),
  chat_message: ce
}), Ha = e.object({
  ...V.entries,
  type: e.picklist(["participation_accepted", "participation_request"]),
  status: f,
  participation_message: e.fallback(e.nullable(e.string()), null)
}), Xa = e.object({
  ...V.entries,
  type: e.literal("bite"),
  status: e.fallback(e.nullable(f), null)
}), it = e.pipe(
  e.any(),
  e.transform((a) => ({
    group_key: `ungrouped-${a.id}`,
    ...M(a.pleroma || {}, ["is_muted", "is_seen"]),
    ...a,
    type: a.type === "pleroma:report" ? "admin.report" : a.type === "reaction" ? "emoji_reaction" : a.type?.replace(/^pleroma:/, "")
  })),
  e.variant("type", [
    Da,
    Fa,
    Ca,
    Ma,
    Ga,
    Ua,
    Ba,
    Va,
    za,
    Ha,
    Xa
  ])
), me = e.picklist(["accept", "filter", "drop"]), qt = e.object({
  for_not_following: me,
  for_not_followers: me,
  for_new_accounts: me,
  for_private_mentions: me,
  for_limited_accounts: me,
  summary: e.object({
    pending_requests_count: e.pipe(e.number(), e.integer()),
    pending_notifications_count: e.pipe(e.number(), e.integer())
  })
}), Tt = e.object({
  id: e.string(),
  created_at: h,
  updated_at: h,
  account: w,
  notifications_count: e.pipe(e.unknown(), e.transform(String)),
  last_status: e.fallback(e.optional(f), void 0)
}), Wa = e.pipe(
  e.any(),
  e.transform((a) => a.application ? {
    ...a,
    app_name: a.application.name,
    app_website: a.application.website,
    scopes: a.scope.split(" ")
  } : {
    ...a,
    valid_until: a?.valid_until?.padEnd(27, "Z")
  }),
  e.object({
    app_name: e.string(),
    app_website: e.fallback(e.string(), ""),
    id: e.pipe(e.unknown(), e.transform(String)),
    created_at: e.fallback(e.nullable(h), null),
    valid_until: e.fallback(e.nullable(h), null),
    last_used: e.fallback(e.nullable(h), null),
    scopes: e.fallback(e.array(e.string()), [])
  })
), Ja = e.object({
  updated_at: h,
  content: e.string()
}), qe = e.object({
  id: e.string(),
  scheduled_at: h,
  params: e.object({
    text: e.fallback(e.nullable(e.string()), null),
    poll: e.fallback(e.nullable(e.object({
      options: e.array(e.string()),
      expires_in: e.pipe(e.unknown(), e.transform(String)),
      multiple: e.fallback(e.optional(e.boolean()), void 0),
      hide_totals: e.fallback(e.optional(e.boolean()), void 0)
    })), null),
    media_ids: e.fallback(e.nullable(e.string()), null),
    sensitive: e.fallback(e.nullable(e.pipe(e.unknown(), e.transform(Boolean))), null),
    spoiler_text: e.fallback(e.nullable(e.string()), null),
    visibility: e.fallback(e.string(), "public"),
    in_reply_to_id: e.fallback(e.nullable(e.string()), null),
    language: e.fallback(e.nullable(e.string()), null),
    application_id: e.fallback(e.nullable(e.pipe(e.number(), e.integer())), null),
    scheduled_at: e.fallback(e.nullable(h), null),
    idempotency: e.fallback(e.nullable(e.string()), null),
    with_rate_limit: e.fallback(e.boolean(), !1),
    expires_in: e.fallback(e.nullable(e.number()), null)
  }),
  media_attachments: r(re)
}), $t = e.pipe(
  e.any(),
  e.transform((a) => a ? {
    external_link: a.externalLink,
    ...a
  } : null),
  e.object({
    id: e.pipe(e.unknown(), e.transform(String)),
    account: w,
    created_at: h,
    title: e.string(),
    artist: e.fallback(e.string(), ""),
    album: e.fallback(e.string(), ""),
    external_link: e.fallback(e.nullable(e.string()), null),
    length: e.fallback(e.nullable(e.number()), null)
  })
), Ka = e.object({
  accounts: r(w),
  statuses: r(f),
  hashtags: r(X),
  groups: r(B)
}), Ot = e.object({
  id: e.number(),
  text: e.string(),
  author: w
}), Ya = e.object({
  content: e.fallback(e.string(), ""),
  spoiler_text: e.fallback(e.string(), ""),
  sensitive: e.pipe(e.unknown(), e.transform(Boolean)),
  created_at: e.fallback(h, (/* @__PURE__ */ new Date()).toISOString()),
  account: w,
  poll: e.fallback(e.nullable(e.object({
    options: e.array(e.object({
      title: e.string()
    }))
  })), null),
  media_attachments: r(re),
  emojis: r(ee)
}), Ye = e.object({
  id: e.string(),
  text: e.fallback(e.string(), ""),
  spoiler_text: e.fallback(e.string(), ""),
  content_type: e.fallback(e.string(), "text/plain"),
  location: e.fallback(e.nullable(is), null),
  text_map: e.fallback(e.nullable(e.record(e.string(), e.string())), null),
  spoiler_text_map: e.fallback(e.nullable(e.record(e.string(), e.string())), null)
}), Za = e.pipe(e.any(), e.transform((a) => ({
  account_id: a.pid,
  story_id: a.sid,
  ...a
})), e.object({
  account_id: e.string(),
  avatar: e.string(),
  local: e.boolean(),
  username: e.string(),
  latest: e.object({
    id: e.pipe(e.unknown(), e.transform(String)),
    type: e.string(),
    preview_url: e.string()
  }),
  url: e.string(),
  seen: e.boolean(),
  story_id: e.pipe(e.unknown(), e.transform(String))
})), Qa = e.pipe(e.any(), e.transform((a) => ({
  id: a.media_id,
  url: a.media_url,
  type: a.media_type
})), e.object({
  id: e.string(),
  url: e.string(),
  type: e.picklist(["photo", "video"])
})), en = e.object({
  id: e.string(),
  type: e.string(),
  duration: e.number(),
  src: e.string(),
  created_at: h,
  expires_at: h,
  view_count: e.fallback(e.nullable(e.number()), null),
  seen: e.boolean(),
  progress: e.number(),
  can_reply: e.boolean(),
  can_react: e.boolean(),
  question: e.optional(e.string(), void 0),
  options: e.optional(e.array(e.string()), void 0),
  voted: e.optional(e.boolean(), void 0),
  voted_index: e.optional(e.number(), void 0)
}), tn = e.object({
  account: w,
  nodes: r(en)
}), sn = e.object({
  state: e.picklist(["follow_pending", "follow_accept", "follow_reject"]),
  follower: e.object({
    id: e.string(),
    follower_count: e.fallback(e.nullable(e.number()), null),
    following_count: e.fallback(e.nullable(e.number()), null)
  }),
  following: e.object({
    id: e.string(),
    follower_count: e.fallback(e.nullable(e.number()), null),
    following_count: e.fallback(e.nullable(e.number()), null)
  })
}), G = e.object({
  stream: e.fallback(e.array(e.string()), [])
}), an = e.object({
  ...G.entries,
  event: e.picklist(["update", "status.update"]),
  payload: e.pipe(e.any(), e.transform((a) => JSON.parse(a)), f)
}), nn = e.object({
  ...G.entries,
  event: e.picklist(["delete", "announcement.delete"]),
  payload: e.string()
}), on = e.object({
  ...G.entries,
  event: e.literal("notification"),
  payload: e.pipe(e.any(), e.transform((a) => JSON.parse(a)), it)
}), rn = e.object({
  ...G.entries,
  event: e.literal("filters_changed")
}), ln = e.object({
  ...G.entries,
  event: e.literal("conversation"),
  payload: e.pipe(e.any(), e.transform((a) => JSON.parse(a)), ot)
}), cn = e.object({
  ...G.entries,
  event: e.literal("announcement"),
  payload: e.pipe(e.any(), e.transform((a) => JSON.parse(a)), dt)
}), un = e.object({
  ...G.entries,
  event: e.literal("announcement.reaction"),
  payload: e.pipe(e.any(), e.transform((a) => JSON.parse(a)), Xt)
}), pn = e.object({
  ...G.entries,
  event: e.literal("chat_update"),
  payload: e.pipe(e.any(), e.transform((a) => JSON.parse(a)), ne)
}), dn = e.object({
  ...G.entries,
  event: e.literal("follow_relationships_update"),
  payload: e.pipe(e.any(), e.transform((a) => JSON.parse(a)), sn)
}), mn = e.object({
  ...G.entries,
  event: e.literal("respond"),
  payload: e.pipe(e.any(), e.transform((a) => JSON.parse(a)), e.object({
    type: e.string(),
    result: e.picklist(["success", "ignored", "error"])
  }))
}), fn = e.object({
  ...G.entries,
  event: e.literal("marker"),
  payload: e.pipe(e.any(), e.transform((a) => JSON.parse(a)), rt)
}), bn = e.object({
  ...G.entries,
  event: e.literal("notifications_merged")
}), hn = e.object({
  ...G.entries,
  event: e.literal("emoji_reaction"),
  payload: e.pipe(e.any(), e.transform((a) => JSON.parse(a)), mt)
}), wn = e.pipe(
  e.any(),
  e.transform((a) => ({
    ...a,
    event: a.event?.replace(/^pleroma:/, "")
  })),
  e.variant("event", [
    an,
    nn,
    on,
    rn,
    ln,
    cn,
    un,
    pn,
    dn,
    mn,
    fn,
    bn,
    hn
  ])
), Pt = e.object({
  /** Subscription ID. */
  id: e.number(),
  /** The date when subscription expires. */
  expires_at: e.fallback(h, (/* @__PURE__ */ new Date()).toISOString())
}), Ze = e.object({
  /** Invoice ID. */
  invoice_id: e.string(),
  /** The ID of the sender. */
  sender_id: e.string(),
  /** The ID of the recipient. */
  recipient_id: e.string(),
  /** CAIP-2 chain ID. */
  chain_id: e.string(),
  /** Payment address. */
  payment_address: e.string(),
  /** Requested payment amount (in atomic units). */
  amount: e.number(),
  /** Invoice status. */
  status: e.picklist(["open", "paid", "forwarded", "timeout", "cancelled", "underpaid", "completed", "failed"]),
  /** The date when invoice was created. */
  created_at: e.fallback(h, (/* @__PURE__ */ new Date()).toISOString()),
  /** The date when invoice times out. */
  invoice_expires_at: e.fallback(h, (/* @__PURE__ */ new Date()).toISOString())
}), gn = e.object({
  /** Subscription type */
  type: e.picklist(["monero"]),
  /** CAIP-2 chain ID. */
  chain_id: e.fallback(e.string(), ""),
  /** Subscription price (only for Monero) */
  price: e.fallback(e.nullable(e.number()), null),
  /** Payout address (only for Monero) */
  payout_address: e.fallback(e.string(), "")
}), vn = e.pipe(
  e.any(),
  e.transform((a) => {
    if (!a) return null;
    if (a?.acct) return {
      source: "staff",
      sources: ["featured"],
      account: a
    };
    if (!a.sources)
      switch (a.sources = [], a.source) {
        case "staff":
          a.sources.push("staff");
          break;
        case "global":
          a.sources.push("most_interactions");
          break;
      }
    return a;
  }),
  e.object({
    source: e.fallback(e.nullable(e.string()), null),
    sources: e.fallback(e.array(e.string()), []),
    account: w
  })
), At = e.object({
  effective_date: tt,
  effective: e.boolean(),
  content: e.string(),
  succeeded_by: e.fallback(e.nullable(tt), null)
}), Te = e.object({
  access_token: e.string(),
  token_type: e.string(),
  scope: e.string(),
  created_at: e.fallback(e.optional(e.number()), void 0),
  id: e.fallback(e.optional(e.pipe(e.unknown(), e.transform(String))), void 0),
  refresh_token: e.fallback(e.optional(e.string()), void 0),
  expires_in: e.fallback(e.optional(e.number()), void 0),
  me: e.fallback(e.optional(e.string()), void 0)
}), Rt = e.pipe(
  e.any(),
  e.transform((a) => ({ ...a, id: a.url })),
  e.object({
    id: e.fallback(e.string(), ""),
    url: e.fallback(e.pipe(e.string(), e.url()), ""),
    title: e.fallback(e.string(), ""),
    description: e.fallback(e.string(), ""),
    type: e.fallback(e.picklist(["link", "photo", "video", "rich"]), "link"),
    author_name: e.fallback(e.string(), ""),
    author_url: e.fallback(e.string(), ""),
    provider_name: e.fallback(e.string(), ""),
    provider_url: e.fallback(e.string(), ""),
    html: e.fallback(e.string(), ""),
    width: e.fallback(e.nullable(e.number()), null),
    height: e.fallback(e.nullable(e.number()), null),
    image: e.fallback(e.nullable(e.string()), null),
    image_description: e.fallback(e.nullable(e.string()), null),
    embed_url: e.fallback(e.string(), ""),
    blurhash: e.fallback(e.nullable(Zt), null),
    history: e.fallback(e.nullable(Jt), null)
  })
), _n = e.object({
  iss: e.string(),
  sub: e.string(),
  name: e.string(),
  preferred_username: e.string(),
  profile: e.string(),
  picture: e.fallback(e.string(), "")
}), Qe = e.object({
  id: e.pipe(e.unknown(), e.transform(String)),
  endpoint: e.string(),
  standard: e.fallback(e.boolean(), !1),
  alerts: e.record(e.string(), e.boolean()),
  server_key: e.string()
});
function Ge(a) {
  return a && a.__esModule && Object.prototype.hasOwnProperty.call(a, "default") ? a.default : a;
}
const kn = typeof process == "object" && process.env && process.env.NODE_DEBUG && /\bsemver\b/i.test(process.env.NODE_DEBUG) ? (...a) => console.error("SEMVER", ...a) : () => {
};
var ls = kn;
const cs = 256, yn = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */
9007199254740991, jn = 16, Sn = cs - 6;
var us = {
  MAX_LENGTH: cs,
  MAX_SAFE_COMPONENT_LENGTH: jn,
  MAX_SAFE_BUILD_LENGTH: Sn,
  MAX_SAFE_INTEGER: yn
}, lt = { exports: {} };
(function(a, t) {
  const {
    MAX_SAFE_COMPONENT_LENGTH: s,
    MAX_SAFE_BUILD_LENGTH: n,
    MAX_LENGTH: o
  } = us, b = ls;
  t = a.exports = {};
  const g = t.re = [], S = t.safeRe = [], i = t.src = [], _ = t.safeSrc = [], u = t.t = {};
  let J = 0;
  const T = "[a-zA-Z0-9-]", I = [
    ["\\s", 1],
    ["\\d", o],
    [T, n]
  ], N = (z) => {
    for (const [D, te] of I)
      z = z.split(`${D}*`).join(`${D}{0,${te}}`).split(`${D}+`).join(`${D}{1,${te}}`);
    return z;
  }, k = (z, D, te) => {
    const ge = N(D), K = J++;
    b(z, K, D), u[z] = K, i[K] = D, _[K] = ge, g[K] = new RegExp(D, te ? "g" : void 0), S[K] = new RegExp(ge, te ? "g" : void 0);
  };
  k("NUMERICIDENTIFIER", "0|[1-9]\\d*"), k("NUMERICIDENTIFIERLOOSE", "\\d+"), k("NONNUMERICIDENTIFIER", `\\d*[a-zA-Z-]${T}*`), k("MAINVERSION", `(${i[u.NUMERICIDENTIFIER]})\\.(${i[u.NUMERICIDENTIFIER]})\\.(${i[u.NUMERICIDENTIFIER]})`), k("MAINVERSIONLOOSE", `(${i[u.NUMERICIDENTIFIERLOOSE]})\\.(${i[u.NUMERICIDENTIFIERLOOSE]})\\.(${i[u.NUMERICIDENTIFIERLOOSE]})`), k("PRERELEASEIDENTIFIER", `(?:${i[u.NONNUMERICIDENTIFIER]}|${i[u.NUMERICIDENTIFIER]})`), k("PRERELEASEIDENTIFIERLOOSE", `(?:${i[u.NONNUMERICIDENTIFIER]}|${i[u.NUMERICIDENTIFIERLOOSE]})`), k("PRERELEASE", `(?:-(${i[u.PRERELEASEIDENTIFIER]}(?:\\.${i[u.PRERELEASEIDENTIFIER]})*))`), k("PRERELEASELOOSE", `(?:-?(${i[u.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${i[u.PRERELEASEIDENTIFIERLOOSE]})*))`), k("BUILDIDENTIFIER", `${T}+`), k("BUILD", `(?:\\+(${i[u.BUILDIDENTIFIER]}(?:\\.${i[u.BUILDIDENTIFIER]})*))`), k("FULLPLAIN", `v?${i[u.MAINVERSION]}${i[u.PRERELEASE]}?${i[u.BUILD]}?`), k("FULL", `^${i[u.FULLPLAIN]}$`), k("LOOSEPLAIN", `[v=\\s]*${i[u.MAINVERSIONLOOSE]}${i[u.PRERELEASELOOSE]}?${i[u.BUILD]}?`), k("LOOSE", `^${i[u.LOOSEPLAIN]}$`), k("GTLT", "((?:<|>)?=?)"), k("XRANGEIDENTIFIERLOOSE", `${i[u.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), k("XRANGEIDENTIFIER", `${i[u.NUMERICIDENTIFIER]}|x|X|\\*`), k("XRANGEPLAIN", `[v=\\s]*(${i[u.XRANGEIDENTIFIER]})(?:\\.(${i[u.XRANGEIDENTIFIER]})(?:\\.(${i[u.XRANGEIDENTIFIER]})(?:${i[u.PRERELEASE]})?${i[u.BUILD]}?)?)?`), k("XRANGEPLAINLOOSE", `[v=\\s]*(${i[u.XRANGEIDENTIFIERLOOSE]})(?:\\.(${i[u.XRANGEIDENTIFIERLOOSE]})(?:\\.(${i[u.XRANGEIDENTIFIERLOOSE]})(?:${i[u.PRERELEASELOOSE]})?${i[u.BUILD]}?)?)?`), k("XRANGE", `^${i[u.GTLT]}\\s*${i[u.XRANGEPLAIN]}$`), k("XRANGELOOSE", `^${i[u.GTLT]}\\s*${i[u.XRANGEPLAINLOOSE]}$`), k("COERCEPLAIN", `(^|[^\\d])(\\d{1,${s}})(?:\\.(\\d{1,${s}}))?(?:\\.(\\d{1,${s}}))?`), k("COERCE", `${i[u.COERCEPLAIN]}(?:$|[^\\d])`), k("COERCEFULL", i[u.COERCEPLAIN] + `(?:${i[u.PRERELEASE]})?(?:${i[u.BUILD]})?(?:$|[^\\d])`), k("COERCERTL", i[u.COERCE], !0), k("COERCERTLFULL", i[u.COERCEFULL], !0), k("LONETILDE", "(?:~>?)"), k("TILDETRIM", `(\\s*)${i[u.LONETILDE]}\\s+`, !0), t.tildeTrimReplace = "$1~", k("TILDE", `^${i[u.LONETILDE]}${i[u.XRANGEPLAIN]}$`), k("TILDELOOSE", `^${i[u.LONETILDE]}${i[u.XRANGEPLAINLOOSE]}$`), k("LONECARET", "(?:\\^)"), k("CARETTRIM", `(\\s*)${i[u.LONECARET]}\\s+`, !0), t.caretTrimReplace = "$1^", k("CARET", `^${i[u.LONECARET]}${i[u.XRANGEPLAIN]}$`), k("CARETLOOSE", `^${i[u.LONECARET]}${i[u.XRANGEPLAINLOOSE]}$`), k("COMPARATORLOOSE", `^${i[u.GTLT]}\\s*(${i[u.LOOSEPLAIN]})$|^$`), k("COMPARATOR", `^${i[u.GTLT]}\\s*(${i[u.FULLPLAIN]})$|^$`), k("COMPARATORTRIM", `(\\s*)${i[u.GTLT]}\\s*(${i[u.LOOSEPLAIN]}|${i[u.XRANGEPLAIN]})`, !0), t.comparatorTrimReplace = "$1$2$3", k("HYPHENRANGE", `^\\s*(${i[u.XRANGEPLAIN]})\\s+-\\s+(${i[u.XRANGEPLAIN]})\\s*$`), k("HYPHENRANGELOOSE", `^\\s*(${i[u.XRANGEPLAINLOOSE]})\\s+-\\s+(${i[u.XRANGEPLAINLOOSE]})\\s*$`), k("STAR", "(<|>)?=?\\s*\\*"), k("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), k("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
})(lt, lt.exports);
var ps = lt.exports;
const En = Object.freeze({ loose: !0 }), qn = Object.freeze({}), Tn = (a) => a ? typeof a != "object" ? En : a : qn;
var $n = Tn;
const Lt = /^[0-9]+$/, On = (a, t) => {
  const s = Lt.test(a), n = Lt.test(t);
  return s && n && (a = +a, t = +t), a === t ? 0 : s && !n ? -1 : n && !s ? 1 : a < t ? -1 : 1;
};
var Pn = {
  compareIdentifiers: On
};
const $e = ls, { MAX_LENGTH: Nt, MAX_SAFE_INTEGER: Oe } = us, { safeRe: Pe, t: Ae } = ps, An = $n, { compareIdentifiers: ie } = Pn;
let Rn = class H {
  constructor(t, s) {
    if (s = An(s), t instanceof H) {
      if (t.loose === !!s.loose && t.includePrerelease === !!s.includePrerelease)
        return t;
      t = t.version;
    } else if (typeof t != "string")
      throw new TypeError(`Invalid version. Must be a string. Got type "${typeof t}".`);
    if (t.length > Nt)
      throw new TypeError(
        `version is longer than ${Nt} characters`
      );
    $e("SemVer", t, s), this.options = s, this.loose = !!s.loose, this.includePrerelease = !!s.includePrerelease;
    const n = t.trim().match(s.loose ? Pe[Ae.LOOSE] : Pe[Ae.FULL]);
    if (!n)
      throw new TypeError(`Invalid Version: ${t}`);
    if (this.raw = t, this.major = +n[1], this.minor = +n[2], this.patch = +n[3], this.major > Oe || this.major < 0)
      throw new TypeError("Invalid major version");
    if (this.minor > Oe || this.minor < 0)
      throw new TypeError("Invalid minor version");
    if (this.patch > Oe || this.patch < 0)
      throw new TypeError("Invalid patch version");
    n[4] ? this.prerelease = n[4].split(".").map((o) => {
      if (/^[0-9]+$/.test(o)) {
        const b = +o;
        if (b >= 0 && b < Oe)
          return b;
      }
      return o;
    }) : this.prerelease = [], this.build = n[5] ? n[5].split(".") : [], this.format();
  }
  format() {
    return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
  }
  toString() {
    return this.version;
  }
  compare(t) {
    if ($e("SemVer.compare", this.version, this.options, t), !(t instanceof H)) {
      if (typeof t == "string" && t === this.version)
        return 0;
      t = new H(t, this.options);
    }
    return t.version === this.version ? 0 : this.compareMain(t) || this.comparePre(t);
  }
  compareMain(t) {
    return t instanceof H || (t = new H(t, this.options)), ie(this.major, t.major) || ie(this.minor, t.minor) || ie(this.patch, t.patch);
  }
  comparePre(t) {
    if (t instanceof H || (t = new H(t, this.options)), this.prerelease.length && !t.prerelease.length)
      return -1;
    if (!this.prerelease.length && t.prerelease.length)
      return 1;
    if (!this.prerelease.length && !t.prerelease.length)
      return 0;
    let s = 0;
    do {
      const n = this.prerelease[s], o = t.prerelease[s];
      if ($e("prerelease compare", s, n, o), n === void 0 && o === void 0)
        return 0;
      if (o === void 0)
        return 1;
      if (n === void 0)
        return -1;
      if (n === o)
        continue;
      return ie(n, o);
    } while (++s);
  }
  compareBuild(t) {
    t instanceof H || (t = new H(t, this.options));
    let s = 0;
    do {
      const n = this.build[s], o = t.build[s];
      if ($e("build compare", s, n, o), n === void 0 && o === void 0)
        return 0;
      if (o === void 0)
        return 1;
      if (n === void 0)
        return -1;
      if (n === o)
        continue;
      return ie(n, o);
    } while (++s);
  }
  // preminor will bump the version up to the next minor release, and immediately
  // down to pre-release. premajor and prepatch work the same way.
  inc(t, s, n) {
    if (t.startsWith("pre")) {
      if (!s && n === !1)
        throw new Error("invalid increment argument: identifier is empty");
      if (s) {
        const o = `-${s}`.match(this.options.loose ? Pe[Ae.PRERELEASELOOSE] : Pe[Ae.PRERELEASE]);
        if (!o || o[1] !== s)
          throw new Error(`invalid identifier: ${s}`);
      }
    }
    switch (t) {
      case "premajor":
        this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", s, n);
        break;
      case "preminor":
        this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", s, n);
        break;
      case "prepatch":
        this.prerelease.length = 0, this.inc("patch", s, n), this.inc("pre", s, n);
        break;
      case "prerelease":
        this.prerelease.length === 0 && this.inc("patch", s, n), this.inc("pre", s, n);
        break;
      case "release":
        if (this.prerelease.length === 0)
          throw new Error(`version ${this.raw} is not a prerelease`);
        this.prerelease.length = 0;
        break;
      case "major":
        (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
        break;
      case "minor":
        (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
        break;
      case "patch":
        this.prerelease.length === 0 && this.patch++, this.prerelease = [];
        break;
      case "pre": {
        const o = Number(n) ? 1 : 0;
        if (this.prerelease.length === 0)
          this.prerelease = [o];
        else {
          let b = this.prerelease.length;
          for (; --b >= 0; )
            typeof this.prerelease[b] == "number" && (this.prerelease[b]++, b = -2);
          if (b === -1) {
            if (s === this.prerelease.join(".") && n === !1)
              throw new Error("invalid increment argument: identifier already exists");
            this.prerelease.push(o);
          }
        }
        if (s) {
          let b = [s, o];
          n === !1 && (b = [s]), ie(this.prerelease[0], s) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = b) : this.prerelease = b;
        }
        break;
      }
      default:
        throw new Error(`invalid increment argument: ${t}`);
    }
    return this.raw = this.format(), this.build.length && (this.raw += `+${this.build.join(".")}`), this;
  }
};
var gt = Rn;
const xt = gt, Ln = (a, t, s = !1) => {
  if (a instanceof xt)
    return a;
  try {
    return new xt(a, t);
  } catch (n) {
    if (!s)
      return null;
    throw n;
  }
};
var ds = Ln;
const It = /* @__PURE__ */ Ge(ds), Nn = gt, xn = ds, { safeRe: Re, t: Le } = ps, In = (a, t) => {
  if (a instanceof Nn)
    return a;
  if (typeof a == "number" && (a = String(a)), typeof a != "string")
    return null;
  t = t || {};
  let s = null;
  if (!t.rtl)
    s = a.match(t.includePrerelease ? Re[Le.COERCEFULL] : Re[Le.COERCE]);
  else {
    const i = t.includePrerelease ? Re[Le.COERCERTLFULL] : Re[Le.COERCERTL];
    let _;
    for (; (_ = i.exec(a)) && (!s || s.index + s[0].length !== a.length); )
      (!s || _.index + _[0].length !== s.index + s[0].length) && (s = _), i.lastIndex = _.index + _[1].length + _[2].length;
    i.lastIndex = -1;
  }
  if (s === null)
    return null;
  const n = s[2], o = s[3] || "0", b = s[4] || "0", g = t.includePrerelease && s[5] ? `-${s[5]}` : "", S = t.includePrerelease && s[6] ? `+${s[6]}` : "";
  return xn(`${n}.${o}.${b}${g}${S}`, t);
};
var Dn = In;
const Dt = /* @__PURE__ */ Ge(Dn), Ft = gt, Fn = (a, t, s) => new Ft(a, s).compare(new Ft(t, s));
var ms = Fn;
const Cn = ms, Mn = (a, t, s) => Cn(a, t, s) > 0;
var Gn = Mn;
const Un = /* @__PURE__ */ Ge(Gn), Bn = ms, Vn = (a, t, s) => Bn(a, t, s) >= 0;
var zn = Vn;
const c = /* @__PURE__ */ Ge(zn), l = (a) => a.some(Boolean), U = "Ditto", A = "Firefish", R = "Friendica", d = "GoToSocial", x = "Hollo", P = "Iceshrimp", E = "Iceshrimp.NET", v = "Mastodon", y = "Mitra", $ = "NeoDB", q = "Pixelfed", p = "Pleroma", L = "Sharkey", se = "snac", O = "Takahe", Y = "Toki", et = "WordPress", m = "Akkoma", Hn = "glitch", Xn = "hometown", lo = "unreleased", Ct = (a) => {
  const t = Wn(a.version || ""), s = !!a.pleroma.metadata.federation.enabled;
  return {
    version: t,
    /**
     * Ability to set description of profile avatar and header.
     * @see PATCH /api/v1/accounts/update_credentials
     */
    accountAvatarDescription: l([
      t.software === d && c(t.version, "0.17.0"),
      t.software === E,
      t.software === p && c(t.version, "2.8.0")
    ]),
    /**
     * Pleroma backups.
     * @see GET /api/v1/pleroma/backups
     * @see POST /api/v1/pleroma/backups
     */
    accountBackups: l([
      t.software === m,
      t.software === p
    ]),
    /**
     * The accounts API allows an acct instead of an ID.
     * @see GET /api/v1/accounts/:acct_or_id
     */
    accountByUsername: l([
      t.software === m,
      t.software === y,
      t.software === p
    ]),
    /**
     * Ability to create accounts.
     * @see POST /api/v1/accounts
     */
    accountCreation: !0,
    /**
     * Ability to control account discoverability.
     * @see PATCH /api/v1/accounts/update_credentials
     */
    accountDiscoverability: l([
      t.software === R,
      t.software === d,
      t.software === x,
      t.software === v,
      t.software === y,
      t.software === L,
      a.api_versions["profile_directory.pleroma.pl-api"] >= 1
    ]),
    /**
     * @see PATCH /api/v1/accounts/update_credentials
     */
    accountEnableRss: t.software === d,
    /**
     * Ability to pin other accounts on one's profile.
     * @see POST /api/v1/accounts/:id/pin
     * @see POST /api/v1/accounts/:id/unpin
     * @see GET /api/v1/pleroma/accounts/:id/endorsements
     * @see GET /api/v1/accounts/:id/endorsements
     */
    accountEndorsements: l([
      t.software === m,
      t.software === p && c(t.version, "2.5.0"),
      a.api_versions.mastodon >= 6
    ]),
    accountIsCat: a.api_versions["is_cat.pleroma.pl-api"] >= 1,
    /**
     * Ability to set one's location on their profile.
     * @see PATCH /api/v1/accounts/update_credentials
     */
    accountLocation: l([
      a.api_versions["account_location.pleroma.pl-api"] >= 1
    ]),
    /**
     * Look up an account by the acct.
     * @see GET /api/v1/accounts/lookup
     */
    accountLookup: l([
      t.software === m,
      t.software === U,
      t.software === A,
      t.software === d,
      t.software === x,
      t.software === P,
      t.software === E,
      t.software === v,
      t.software === y,
      t.software === $,
      t.software === p && c(t.version, "2.5.0"),
      t.software === L,
      t.software === se,
      t.software === O && c(t.version, "0.6.1"),
      t.software === Y,
      t.software === et
    ]),
    /**
     * @see PATCH /api/v1/accounts/update_credentials
     */
    accountMentionPolicy: l([
      t.software === y
    ]),
    /**
     * Move followers to a different ActivityPub account.
     * @see POST /api/pleroma/move_account
     */
    accountMoving: l([
      t.software === m,
      t.software === p && c(t.version, "2.5.0")
    ]),
    /**
     * Ability to subscribe to notifications every time an account posts.
     * @see POST /api/v1/accounts/:id/follow
     */
    accountNotifies: l([
      t.software === m,
      t.software === v,
      t.software === p && c(t.version, "2.5.0"),
      t.software === d
    ]),
    /**
     * @see PATCH /api/v1/accounts/update_credentials
     */
    accountWebLayout: l([
      t.software === d && c(t.version, "0.19.0")
    ]),
    /**
      * @see PATCH /api/v1/accounts/update_credentials
      */
    accountWebVisibility: l([
      t.software === d && c(t.version, "0.17.0")
    ]),
    /**
     * Ability to address a status to a list of users.
     * @see POST /api/v1/statuses
     */
    addressableLists: l([
      t.software === m,
      t.software === p
    ]),
    /**
     * @see GET /api/v1/admin/custom_emojis
     * @see GET /api/v1/admin/custom_emojis/:id
     * @see POST /api/v1/admin/custom_emojis
     * @see PATCH /api/v1/admin/custom_emojis/:id
     * @see DELETE /api/v1/admin/custom_emojis/:id
     */
    adminCustomEmojis: t.software === d,
    /**
     * Ability to manage instance rules by admins.
     * @see GET /api/v1/pleroma/admin/rules
     * @see POST /api/v1/pleroma/admin/rules
     * @see PATCH /api/v1/pleroma/admin/rules/:id
     * @see DELETE /api/v1/pleroma/admin/rules/:id
     * @see GET /api/v1/admin/instance/rules
     * @see GET /api/v1/admin/instance/rules/:id
     * @see POST /api/v1/admin/instance/rules
     * @see PATCH /api/v1/admin/instance/rules/:id
     * @see DELETE /api/v1/admin/instance/rules/:id
     */
    adminRules: l([
      t.software === d,
      t.software === p && c(t.version, "2.7.0")
    ]),
    adminRulesPriority: l([
      t.software === p && c(t.version, "2.7.0")
    ]),
    /**
     * Can display announcements set by admins.
     * @see GET /api/v1/announcements
     * @see POST /api/v1/announcements/:id/dismiss
     * @see {@link https://docs.joinmastodon.org/methods/announcements/}
     */
    announcements: l([
      t.software === m,
      t.software === A,
      t.software === P,
      t.software === E,
      t.software === v,
      t.software === $,
      t.software === p,
      t.software === L,
      t.software === se,
      t.software === O && c(t.version, "0.7.0")
    ]),
    /**
     * Can emoji react to announcements set by admins.
     * @see PUT /api/v1/announcements/:id/reactions/:name
     * @see DELETE /api/v1/announcements/:id/reactions/:name
     * @see {@link https://docs.joinmastodon.org/methods/announcements/}
     */
    announcementsReactions: t.software === v,
    antennas: a.api_versions["kmyblue_antenna.fedibird.pl-api"] >= 1,
    /**
     * Set your birthday and view upcoming birthdays.
     * @see GET /api/v1/pleroma/birthdays
     * @see POST /api/v1/accounts
     * @see PATCH /api/v1/accounts/update_credentials
     */
    birthdays: t.software === p,
    /**
     * Allow to bite users.
     * see POST /api/v1/bite
     */
    bites: l([
      t.software === E,
      t.software === Y,
      a.api_versions["bites.pleroma.pl-api"] >= 1
    ]),
    /** Whether people who blocked you are visible through the API. */
    blockersVisible: a.api_versions["blockers_visible.pleroma.pl-api"] >= 1,
    /**
     * Ability to specify how long the account block should last.
     * @see PUT /api/v1/accounts/:id/block
     */
    blocksDuration: a.api_versions["block_expiration.pleroma.pl-api"] >= 1,
    bookmarkFolderEmojis: a.api_versions["bookmark_folders.pleroma.pl-api"] >= 1,
    /**
     * Can group bookmarks in folders.
     * @see GET /api/v1/pleroma/bookmark_folders
     * @see POST /api/v1/pleroma/bookmark_folders
     * @see PATCH /api/v1/pleroma/bookmark_folders/:id
     * @see DELETE /api/v1/pleroma/bookmark_folders/:id
     */
    bookmarkFolders: l([
      a.api_versions["bookmark_folders.pleroma.pl-api"] >= 1,
      a.api_versions["kmyblue_bookmark_category.fedibird.pl-api"] >= 1
    ]),
    bookmarkFoldersMultiple: a.api_versions["kmyblue_bookmark_category.fedibird.pl-api"] >= 1,
    /**
     * Can bookmark statuses.
     * @see POST /api/v1/statuses/:id/bookmark
     * @see GET /api/v1/bookmarks
     */
    bookmarks: l([
      t.software === m,
      t.software === U,
      t.software === A,
      t.software === d,
      t.software === x,
      t.software === P,
      t.software === E,
      t.software === R,
      t.software === v,
      t.software === y && c(t.version, "3.3.0"),
      t.software === $,
      t.software === q,
      t.software === p,
      t.software === L,
      t.software === O && c(t.version, "0.9.0"),
      t.software === Y
    ]),
    /**
     * Accounts can be marked as bots.
     * @see PATCH /api/v1/accounts/update_credentials
     */
    bots: l([
      t.software === m,
      t.software === d,
      t.software === x,
      t.software === P,
      t.software === E,
      t.software === v,
      t.software === y && c(t.version, "3.22.0"),
      t.software === q,
      t.software === p,
      t.software === se
    ]),
    /**
     * Can display a timeline of statuses from instances selected by instance admin.
     * @see GET /api/v1/timelines/bubble
     */
    bubbleTimeline: l([
      a.api_versions["bubble_timeline.pleroma.pl-api"] >= 1,
      t.software === E
    ]),
    bubbleTimelineStreaming: t.software === E,
    /**
     * @see POST /api/v1/user/email_change
     */
    changeEmail: l([
      t.software === m,
      t.software === d && c(t.version, "0.16.0"),
      t.software === p
    ]),
    /**
     * @see POST /api/v1/user/password_change
     * @see POST /api/v1/settings/change_password
     * @see POST /api/v1.1/accounts/change-password
     * @see POST /api/iceshrimp/auth/change-password
     * @see POST /api/pleroma/change_password
     */
    changePassword: l([
      t.software === m,
      t.software === d,
      t.software === E,
      t.software === y,
      t.software === q,
      t.software === p
    ]),
    /**
     * Pleroma chats API.
     * @see {@link https://docs.pleroma.social/backend/development/API/chats/}
     */
    chats: a.api_versions["chat_messages.pleroma.pl-api"] >= 1,
    /**
     * Ability to delete a chat.
     * @see DELETE /api/v1/pleroma/chats/:id
     */
    chatsDelete: l([
      a.api_versions["chat_delete.pleroma.pl-api"] >= 1
    ]),
    circles: a.api_versions["kmyblue_circle_history.fedibird.pl-api"] >= 1,
    composeAllowHeadings: l([
      t.software !== p && t.software !== m,
      a.pleroma.metadata.markup.allow_headings
    ]),
    composeAllowInlineImages: a.pleroma.metadata.markup.allow_inline_images,
    /**
     * Mastodon's newer solution for direct messaging.
     * @see {@link https://docs.joinmastodon.org/methods/conversations/}
     */
    conversations: l([
      t.software === m,
      t.software === A,
      t.software === R,
      t.software === d && c(t.version, "0.17.0"),
      t.software === P,
      t.software === E,
      t.software === v,
      t.software === $,
      t.software === q,
      t.software === p,
      t.software === L,
      t.software === O
    ]),
    /**
     * @see GET /api/v1/conversations
     */
    conversationsByRecipients: l([
      t.software === m,
      t.software === p
    ]),
    /**
     * Ability to post statuses to the recipients of parent post.
     * @see POST /api/v1/statuses
     */
    createStatusConversationScope: t.software === y,
    /**
     * @see POST /api/v1/statuses
     */
    createStatusExpiration: l([
      t.software === m,
      t.software === p
    ]),
    /**
     * Ability to address recipients of a status explicitly (with `to`).
     * @see POST /api/v1/statuses
     */
    createStatusExplicitAddressing: l([
      t.software === U,
      a.api_versions["explicit_addressing.pleroma.pl-api"] >= 1
    ]),
    /**
     * @see POST /api/v1/statuses
     */
    createStatusReplyToConversation: l([
      t.software === m,
      t.software === p
    ]),
    /**
     * Ability to address a status to a list of users.
     * @see POST /api/v1/statuses
     */
    createStatusListScope: l([
      t.software === m,
      t.software === p
    ]),
    /**
     * @see POST /api/v1/statuses
     */
    createStatusLocalScope: l([
      t.software === m,
      t.software === E,
      t.software === p
    ]),
    /**
     * Ability to post statuses only to accounts with mutual relationship.
     * @see POST /api/v1/statuses
     */
    createStatusMutualsOnlyScope: t.software === d,
    /**
     * Ability to post statuses only to your subscribers.
     * @see POST /api/v1/statuses
     */
    createStatusSubscribersScope: t.software === y,
    /**
     * @see POST /api/v1/statuses
     * @see POST /api/v1/statuses/preview
     */
    createStatusPreview: l([
      t.software === m,
      t.software === p,
      t.software === y
    ]),
    /**
     * Ability to add non-standard reactions to a status.
     */
    customEmojiReacts: l([
      a.api_versions["custom_emoji_reactions.pleroma.pl-api"] >= 1,
      t.software === U && Un(t.version, "1.2.0"),
      t.software === x,
      t.software === y && c(t.version, "3.4.0")
    ]),
    /**
     * @see POST /api/v1/accounts/delete
     * @see POST /api/pleroma/delete_account
     */
    deleteAccount: l([
      t.software === m,
      t.software === d,
      t.software === p
    ]),
    /**
     * @see POST /api/v1/settings/delete_account
     */
    deleteAccountWithoutPassword: t.software === y && c(t.version, "2.14.0"),
    /**
     * @see DELETE /api/v1/media/:id
     */
    deleteMedia: a.api_versions.mastodon >= 4,
    /**
     * Allow to register on a given domain
     * @see GET /api/v1/pleroma/admin/domains
     * @see POST /api/v1/pleroma/admin/domains
     * @see PATCH /api/v1/pleroma/admin/domains/:id
     * @see DELETE /api/v1/pleroma/admin/domains/:id
     */
    domains: l([a.pleroma.metadata.multitenancy.enabled]),
    /**
     * Ability to edit profile information.
     * @see PATCH /api/v1/accounts/update_credentials
     */
    editProfile: l([
      t.software === m,
      t.software === A,
      t.software === R,
      t.software === d,
      t.software === P,
      t.software === E,
      t.software === v,
      t.software === y,
      t.software === $,
      t.software === q,
      t.software === p,
      t.software === O && c(t.version, "0.7.0"),
      t.software === Y
    ]),
    /**
     * Ability to edit published posts.
     * @see PUT /api/v1/statuses/:id
     */
    editStatuses: l([
      t.software === A,
      t.software === R && c(t.version, "2022.12.0"),
      t.software === d && c(t.version, "0.18.0"),
      t.software === P,
      t.software === E,
      t.software === v,
      t.software === y,
      t.software === $,
      t.software === O && c(t.version, "0.8.0"),
      a.api_versions["editing.pleroma.pl-api"] >= 1
    ]),
    /**
     * Soapbox email list.
     * @see POST /api/v1/accounts
     * @see PATCH /api/v1/accounts/update_credentials
     * @see GET /api/v1/pleroma/admin/email_list/subscribers.csv
     * @see GET /api/v1/pleroma/admin/email_list/unsubscribers.csv
     * @see GET /api/v1/pleroma/admin/email_list/combined.csv
     */
    emailList: a.api_versions["email_list.pleroma.pl-api"] >= 1,
    /**
     * Ability to embed posts on external sites.
     * @see GET /api/oembed
     */
    embeds: t.software === v,
    /**
     * Ability to add emoji reactions to a status.
     * @see PUT /api/v1/pleroma/statuses/:id/reactions/:emoji
     * @see DELETE /api/v1/pleroma/statuses/:id/reactions/:emoji
     *
     * @see POST /v1/statuses/:id/react/:emoji
     * @see POST /v1/statuses/:id/unreact/:emoji
     */
    emojiReacts: l([
      t.software === m,
      t.software === A,
      t.software === x,
      t.software === y && c(t.version, "2.21.0"),
      t.software === p,
      a ? a.configuration.reactions.max_reactions > 0 : !1
    ]),
    /**
     * @see GET /api/v1/pleroma/statuses/:id/reactions/:emoji?
     * @see GET /api/v1/statuses/:id/emoji_reactioned_by
     */
    emojiReactsList: l([
      t.software === m,
      t.software === E,
      t.software === p,
      a.api_versions["emoji_reaction.fedibird.pl-api"] >= 1
    ]),
    /**
     * Ability to create and perform actions on events.
     * @see POST /api/v1/pleroma/events
     * @see GET /api/v1/pleroma/events/joined_events
     * @see PUT /api/v1/pleroma/events/:id
     * @see GET /api/v1/pleroma/events/:id/participations
     * @see GET /api/v1/pleroma/events/:id/participation_requests
     * @see POST /api/v1/pleroma/events/:id/participation_requests/:participant_id/authorize
     * @see POST /api/v1/pleroma/events/:id/participation_requests/:participant_id/reject
     * @see POST /api/v1/pleroma/events/:id/join
     * @see POST /api/v1/pleroma/events/:id/leave
     * @see GET /api/v1/pleroma/events/:id/ics
     * @see GET /api/v1/pleroma/search/location
     */
    events: a.api_versions["events.pleroma.pl-api"] >= 1,
    /**
    * Export blocks to CSV file
    * @see GET /api/v1/exports/blocks.csv
    */
    exportBlocks: t.software === d && c(t.version, "0.17.0"),
    /**
     * Export followers to CSV file
     * @see GET /api/v1/exports/followers.csv
     * @see GET /api/v1/settings/export_followers
     */
    exportFollowers: l([
      t.software === d && c(t.version, "0.17.0"),
      t.software === y && c(t.version, "1.27.0")
    ]),
    /**
     * Export follows to CSV file
     * @see GET /api/v1/exports/following.csv
     * @see GET /api/v1/settings/export_follows
     */
    exportFollows: l([
      t.software === d && c(t.version, "0.17.0"),
      t.software === y && c(t.version, "1.27.0")
    ]),
    /**
      * Export lists to CSV file
      * @see GET /api/v1/exports/lists.csv
      */
    exportLists: t.software === d && c(t.version, "0.17.0"),
    /**
      * Export mutes to CSV file
      * @see GET /api/v1/exports/mutes.csv
      */
    exportMutes: t.software === d && c(t.version, "0.17.0"),
    /** Whether the accounts who favourited or emoji-reacted to a status can be viewed through the API. */
    exposableReactions: l([
      t.software === A,
      t.software === R,
      t.software === d,
      t.software === x,
      t.software === P,
      t.software === E,
      t.software === v,
      t.software === y && c(t.version, "4.5.0"),
      t.software === $,
      t.software === L,
      t.software === O && c(t.version, "0.6.1"),
      t.software === Y,
      a.api_versions["exposable_reactions.pleroma.pl-api"] >= 1
    ]),
    /**
     * Can see accounts' followers you know
     * @see GET /api/v1/accounts/familiar_followers
     */
    familiarFollowers: l([
      t.software === U,
      t.software === x,
      t.software === v,
      t.software === $,
      t.software === q,
      t.software === p && c(t.version, "2.7.0"),
      t.software === O
    ]),
    /**
     * @see GET /api/v1/accounts/:accountId/featured_tags
     * @see GET /api/v1/featured_tags
     * @see POST /api/v1/featured_tags
     * @see DELETE /api/v1/featured_tags
     * @see GET /api/v1/featured_tags/suggestions
     */
    featuredTags: l([
      t.software === x,
      t.software === v,
      t.software === $,
      t.software === O && c(t.version, "0.12.0")
    ]),
    /** Whether the instance federates. */
    federating: s,
    /**
     * Can edit and manage timeline filters (aka "muted words").
     * @see {@link https://docs.joinmastodon.org/methods/filters/#v1}
     */
    filters: l([
      t.software === m,
      t.software === d,
      t.software === p,
      t.software === L
    ]),
    /**
     * Can edit and manage timeline filters (aka "muted words").
     * @see {@link https://docs.joinmastodon.org/methods/filters/}
     */
    filtersV2: l([
      t.software === d && c(t.version, "0.16.0"),
      t.software === E,
      t.software === v
    ]),
    filtersV2BlurAction: l([
      t.software === d && c(t.version, "0.20.0"),
      t.software === v && c(t.version, "4.4.0")
    ]),
    /**
     * Allows setting the focal point of a media attachment.
     * @see {@link https://docs.joinmastodon.org/methods/media/}
     */
    focalPoint: l([
      t.software === d,
      t.software === v
    ]),
    /**
     * TODO
     */
    // followAccountLanguages: any([]),
    /**
     * Ability to list followed hashtags.
     * @see GET /api/v1/followed_tags
     */
    followedHashtagsList: l([
      t.software === m,
      t.software === d && c(t.version, "0.17.0"),
      t.software === x,
      t.software === v && c(t.compatVersion, "4.1.0"),
      t.software === $,
      t.software === q,
      t.software === p && c(t.version, "2.9.0"),
      t.software === O && c(t.version, "0.9.0")
    ]),
    /**
     * Ability to follow hashtags.
     * @see POST /api/v1/tags/:name/follow
     * @see POST /api/v1/tags/:name/unfollow
     */
    followHashtags: l([
      t.software === m,
      t.software === d && c(t.version, "0.17.0"),
      t.software === x,
      t.software === v && c(t.compatVersion, "4.0.0"),
      t.software === $,
      t.software === q,
      t.software === p && c(t.version, "2.9.0"),
      t.software === O && c(t.version, "0.9.0")
    ]),
    /**
     * Ability to lock accounts and manually approve followers.
     * @see PATCH /api/v1/accounts/update_credentials
     */
    followRequests: l([
      t.software === m,
      t.software === A,
      t.software === d,
      t.software === v,
      t.software === y,
      t.software === p,
      t.software === Y
    ]),
    /**
     * Whether client settings can be retrieved from the API.
     * @see GET /api/pleroma/frontend_configurations
     * @see PATCH /api/v1/accounts/update_credentials
     */
    frontendConfigurations: l([
      t.software === m,
      t.software === U,
      t.software === y && c(t.version, "1.20.0"),
      t.software === p
    ]),
    /**
     * @see GET /api/v2/notifications/:group_key
     * @see GET /api/v2/notifications/:group_key
     * @see POST /api/v2/notifications/:group_key/dismiss
     * @see GET /api/v2/notifications/:group_key/accounts
     * @see GET /api/v2/notifications/unread_count
     */
    groupedNotifications: a.api_versions.mastodon >= 2,
    /**
     * Groups.
     * @see POST /api/v1/groups
     * @see GET /api/v1/groups
     * @see GET /api/v1/groups/:id
     * @see POST /api/v1/groups/:id/join
     * @see POST /api/v1/groups/:id/leave
     * @see GET /api/v1/groups/:id/memberships
     * @see PUT /api/v1/groups/:group_id
     * @see DELETE /api/v1/groups/:group_id
     * @see GET /api/v1/groups/:group_id/membership_requests
     * @see POST /api/v1/groups/:group_id/membership_requests/:account_id/authorize
     * @see POST /api/v1/groups/:group_id/membership_requests/:account_id/reject
     * @see DELETE /api/v1/groups/:group_id/statuses/:id
     * @see POST /api/v1/groups/:group_id/kick?account_ids[]=…
     * @see GET /api/v1/groups/:group_id/blocks
     * @see POST /api/v1/groups/:group_id/blocks?account_ids[]=…
     * @see DELETE /api/v1/groups/:group_id/blocks?account_ids[]=…
     * @see POST /api/v1/groups/:group_id/promote?role=new_role&account_ids[]=…
     * @see POST /api/v1/groups/:group_id/demote?role=new_role&account_ids[]=…
     * @see GET /api/v1/admin/groups
     * @see GET /api/v1/admin/groups/:group_id
     * @see POST /api/v1/admin/groups/:group_id/suspend
     * @see POST /api/v1/admin/groups/:group_id/unsuspend
     * @see DELETE /api/v1/admin/groups/:group_id
     */
    groups: l([
      t.software === q,
      a.api_versions["groups.pleroma.pl-api"] >= 1
    ]),
    groupsSlugs: a.api_versions["groups.pleroma.pl-api"] >= 1,
    /**
     * Can hide follows/followers lists and counts.
     * @see PATCH /api/v1/accounts/update_credentials
     */
    hideNetwork: l([
      t.software === m,
      t.software === d && c(t.version, "0.15.0"),
      t.software === p
    ]),
    /**
     * Import a .csv file with a list of blocked users.
     * @see POST /api/pleroma/blocks_import
     * @see POST /api/v1/import
     */
    importBlocks: l([
      t.software === m,
      t.software === d && c(t.version, "0.17.0"),
      t.software === p
    ]),
    /**
     * Move followers from remote alias.
     * @see POST /api/v1/settings/import_followers
     */
    importFollowers: l([
      t.software === y && c(t.version, "2.18.0")
    ]),
    /**
     * Import a .csv file with a list of followed users.
     * @see POST /api/pleroma/follow_import
     * @see POST /api/v1/settings/import_follows
     * @see POST /api/v1/import
     */
    importFollows: l([
      t.software === m,
      t.software === d && c(t.version, "0.17.0"),
      t.software === y && c(t.version, "1.10.0"),
      t.software === p
    ]),
    /**
     * Import a .csv file with a list of muted users.
     * @see POST /api/pleroma/mutes_import
     * @see POST /api/v1/import
     */
    importMutes: l([
      t.software === m,
      t.software === d && c(t.version, "0.19.0"),
      t.software === p
    ]),
    /**
     * Allow to specify mode of data import to either `merge` or `overwrite`.
     * @see POST /api/v1/import
     */
    importOverwrite: t.software === d && c(t.version, "0.17.0"),
    /**
     * View posts from specific instance.
     * @see GET /api/v1/timelines/public
     */
    instanceTimeline: l([
      t.software === m,
      t.software === p && c(t.version, "2.7.0")
    ]),
    /**
     * Mastodon server information API v2.
     * @see GET /api/v2/instance
     * @see {@link https://docs.joinmastodon.org/methods/instance/#v2}
    */
    instanceV2: l([
      t.software === A,
      t.software === d,
      t.software === v && c(t.compatVersion, "4.0.0"),
      t.software === y && c(t.version, "2.18.0"),
      t.software === p && c(t.version, "2.7.0")
    ]),
    interactionRequests: t.software === d && c(t.version, "0.17.0"),
    /**
     * Server-side status language detection.
     */
    languageDetection: a.api_versions["language_detection.pleroma.pl-api"] >= 1,
    /**
     * Can translate multiple statuses in a single request.
     * @see POST /api/v1/pl/statuses/translate
     */
    lazyTranslations: a.api_versions["translations.pl.pl-api"] >= 1,
    /**
     * Can create, view, and manage lists.
     * @see {@link https://docs.joinmastodon.org/methods/lists/}
     * @see GET /api/v1/timelines/list/:list_id
     */
    lists: l([
      t.software === m,
      t.software === A,
      t.software === R,
      t.software === d,
      t.software === x,
      t.software === P,
      t.software === E,
      t.software === v,
      t.software === y,
      t.software === $,
      t.software === p,
      t.software === L,
      t.software === se,
      t.software === O && c(t.version, "0.12.0")
    ]),
    listsExclusive: l([
      t.software === d,
      t.software === x,
      t.software === E,
      t.software === v && c(t.version, "4.2.0"),
      t.software === $,
      t.software === O && c(t.version, "0.12.0")
    ]),
    /**
     * Can add a list to favourites.
     * @see POST /api/v1/lists/:list_id/favourite
     * @see POST /api/v1/lists/:list_id/unfavourite
     */
    listsFavourites: a.api_versions["favourite_list.fedibird.pl-api"] >= 1,
    /**
     * Can set to receive notifications for new posts in a list.
     */
    listsNotifications: a.api_versions["kmyblue_list_notification.fedibird.pl-api"] >= 1,
    listsRepliesPolicy: l([
      t.software === R && c(t.version, "2024.12.0"),
      t.software === d,
      t.software === x,
      t.software === v && c(t.version, "3.3.0"),
      t.software === $,
      t.software === O && c(t.version, "0.12.0")
    ]),
    /**
     * Can load latest activities from outbox.
     * @see POST /api/v1/accounts/:id/load_activities
     */
    loadActivities: t.software === y && c(t.version, "2.16.0"),
    /**
     * Can load conversation from a remote server.
     * @see POST /api/v1/statuses/:id/load_conversation
     */
    loadConversation: t.software === y && c(t.version, "2.25.0"),
    /**
     * Ability to post statuses that don't federate.
     * @see POST /api/v1/statuses
     */
    localOnlyStatuses: s && l([
      t.software === d,
      t.software === v && t.build === Xn
    ]),
    /**
     * Can sign in using username instead of e-mail address.
     */
    logInWithUsername: l([
      t.software === m,
      t.software === y,
      t.software === p,
      t.software === Y
    ]),
    /**
     * Can view and manage ActivityPub aliases through the API.
     * @see GET /api/pleroma/aliases
     * @see PATCH /api/v1/accounts/update_credentials
     */
    manageAccountAliases: l([
      t.software === m,
      t.software === p
    ]),
    /**
     * @see GET /api/pleroma/accounts/mfa
     * @see GET /api/pleroma/accounts/mfa/setup/:method
     * @see POST /api/pleroma/accounts/mfa/confirm/:method
     * @see DELETE /api/pleroma/accounts/mfa/:method
     */
    manageMfa: l([
      t.software === m,
      t.software === p,
      t.software === d && c(t.version, "0.19.0")
    ]),
    /**
     * @see GET /api/pleroma/accounts/mfa/backup_codes
     */
    manageMfaBackupCodes: l([
      t.software === m,
      t.software === p
    ]),
    /**
     * @see POST /api/v1/user/2fa/enable
     */
    manageMfaRequiresPassword: l([
      t.software === m,
      t.software === p
    ]),
    /**
     * Can perform moderation actions with account and reports.
     * @see {@link https://docs.joinmastodon.org/methods/admin/}
     * @see GET /api/v1/admin/reports
     * @see POST /api/v1/admin/reports/:report_id/resolve
     * @see POST /api/v1/admin/reports/:report_id/reopen
     * @see POST /api/v1/admin/accounts/:account_id/action
     * @see POST /api/v1/admin/accounts/:account_id/approve
     */
    mastodonAdmin: l([
      t.software === U,
      t.software === d,
      t.software === v,
      a.api_versions["mastodon_admin_api.pleroma.pl-api"] >= 1
    ]),
    mastodonAdminResolveReportWithComment: t.software === d,
    /**
     * @see POST /api/v1/admin/dimensions
     * @see POST /api/v1/admin/measures
     * @see POST /api/v1/admin/retention
     */
    mastodonAdminMetrics: t.software === v && c(t.version, "3.5.0"),
    /**
     * Can perform moderation actions with account and reports.
     * @see {@link https://docs.joinmastodon.org/methods/admin/}
     * @see GET /api/v2/admin/accounts
     */
    mastodonAdminV2: l([
      t.software === d,
      t.software === v && c(t.version, "3.5.0")
    ]),
    /**
     * Supports V2 media uploads.
     * @see POST /api/v2/media
     */
    mediaV2: l([
      t.software === m,
      t.software === A,
      t.software === P,
      t.software === E,
      t.software === v,
      t.software === y,
      t.software === $,
      t.software === p,
      t.software === O,
      t.software === Y,
      t.software === et
    ]),
    /**
     * Ability to include multiple language variants for a post.
     * @see POST /api/v1/statuses
     */
    multiLanguage: a.api_versions["multi_language.pleroma.pl-api"] >= 1,
    /**
     * Ability to hide notifications from people you don't follow.
     * @see PUT /api/pleroma/notification_settings
     */
    muteStrangers: l([
      t.software === m,
      t.software === p
    ]),
    /**
     * Ability to mute users.
     * @see GET /api/v1/mutes
     * @see POST /api/v1/accounts/:id/mute
     * @see POST /api/v1/accounts/:id/unmute
     */
    mutes: l([
      t.software === m,
      t.software === A,
      t.software === R,
      t.software === d && c(t.version, "0.16.0"),
      t.software === P,
      t.software === E,
      t.software === v,
      t.software === y,
      t.software === $,
      t.software === q,
      t.software === p,
      t.software === L,
      t.software === O
    ]),
    /**
     * Ability to specify how long the account mute should last.
     * @see PUT /api/v1/accounts/:id/mute
     */
    mutesDuration: l([
      t.software === m,
      t.software === A,
      t.software === d && c(t.version, "0.16.0"),
      t.software === P,
      t.software === E,
      t.software === v,
      t.software === $,
      t.software === p,
      t.software === O
    ]),
    /**
     * Add private notes to accounts.
     * @see POST /api/v1/accounts/:id/note
     * @see GET /api/v1/accounts/relationships
     */
    notes: l([
      t.software === m,
      t.software === v,
      t.software === p && c(t.version, "2.5.0"),
      t.software === d
    ]),
    /**
     * @see DELETE /api/v1/notifications/destroy_multiple
     */
    notificationsDismissMultiple: l([
      t.software === m,
      t.software === p
    ]),
    /**
     * @see GET /api/v1/notifications
     */
    notificationsExcludeTypes: t.software !== y,
    /**
     * @see GET /api/v1/notifications
     */
    notificationsExcludeVisibilities: l([
      t.software === m,
      t.software === p
    ]),
    /**
     * @see GET /api/v1/notifications/unread_count
     */
    notificationsGetUnreadCount: a.api_versions.mastodon >= 1,
    /**
     * Allows specifying notification types to include, rather than to exclude.
     * @see GET /api/v1/notifications
     */
    notificationsIncludeTypes: l([
      t.software === m,
      t.software === A,
      t.software === P,
      t.software === E,
      t.software === v,
      t.software === $,
      t.software === p && c(t.version, "2.5.0"),
      t.software === O && c(t.version, "0.6.2"),
      t.software === d
    ]),
    /**
     * @see GET /api/v2/notifications/policy
     * @see PATCH /api/v2/notifications/policy
     */
    notificationsPolicy: a.api_versions.mastodon >= 1,
    /**
     * @see POST /api/v1/notifications/requests/accept
     * @see POST /api/v1/notifications/requests/dismiss
     */
    notificationsRequestsAcceptMultiple: a.api_versions.mastodon >= 1,
    /**
     * @see GET api/iceshrimp/follow_requests/outgoing
     * @see GET /api/v1/follow_requests/outgoing
     * @see GET /api/v1/pleroma/outgoing_follow_requests
     */
    outgoingFollowRequests: l([
      t.software === d && c(t.version, "0.20.0"),
      t.software === E,
      a.api_versions["outgoing_follow_requests.pleroma.pl-api"] >= 1
    ]),
    pleromaAdminAccounts: l([
      t.software === m,
      t.software === p
    ]),
    /**
     * Ability to manage announcements by admins.
     * @see GET /api/v1/pleroma/admin/announcements
     * @see GET /api/v1/pleroma/admin/announcements/:id
     * @see POST /api/v1/pleroma/admin/announcements
     * @see PATCH /api/v1/pleroma/admin/announcements/:id
     * @see DELETE /api/v1/pleroma/admin/announcements/:id
     * @see {@link https://docs.pleroma.social/backend/development/API/admin_api/#get-apiv1pleromaadminannouncements}
     */
    pleromaAdminAnnouncements: l([
      t.software === m,
      t.software === p
    ]),
    pleromaAdminModerationLog: l([
      t.software === m,
      t.software === p
    ]),
    pleromaAdminRelays: l([
      t.software === m,
      t.software === p
    ]),
    pleromaAdminStatuses: l([
      t.software === m,
      t.software === p
    ]),
    pleromaAdminStatusesRedact: a.api_versions["admin_statuses_redact.pleroma.pl-api"] >= 1,
    /**
     * Displays a form to follow a user when logged out.
     * @see POST /main/ostatus
     */
    pleromaRemoteFollow: l([
      t.software === m,
      t.software === p
    ]),
    /**
     * Can add polls to statuses.
     * @see POST /api/v1/statuses
     */
    polls: l([
      t.software === A,
      t.software === d,
      t.software === P,
      t.software === E,
      t.software === v,
      t.software === y && c(t.version, "3.15.0"),
      t.software === $,
      t.software === L,
      t.software === O && c(t.version, "0.8.0"),
      a.api_versions["polls.pleroma.pl-api"] >= 1
    ]),
    /**
     * Can select a language for statuses.
     * @see POST /api/v1/statuses
     */
    postLanguages: l([
      t.software === m,
      t.software === d,
      t.software === v,
      t.software === y && c(t.version, "3.23.0"),
      t.software === p && c(t.version, "2.9.0"),
      t.software === L
    ]),
    /**
     * @see GET /api/v1/akkoma/preferred_frontend/available
     * @see PUT /api/v1/akkoma/preferred_frontend
     */
    preferredFrontends: t.software === m,
    /**
     * Can set privacy scopes on statuses.
     * @see POST /api/v1/statuses
     */
    privacyScopes: !0,
    /**
     * A directory of discoverable profiles from the instance.
     * @see {@link https://docs.joinmastodon.org/methods/directory/}
     */
    profileDirectory: l([
      t.software === R,
      t.software === v,
      t.software === y,
      a.api_versions["profile_directory.pleroma.pl-api"] >= 1
    ]),
    /**
     * Ability to set custom profile fields.
     * @see PATCH /api/v1/accounts/update_credentials
     */
    profileFields: l([
      t.software === m,
      t.software === U,
      t.software === d,
      t.software === x,
      t.software === P,
      t.software === E,
      t.software === v,
      t.software === y,
      t.software === $,
      t.software === p,
      t.software === L,
      t.software === se,
      t.software === O && c(t.version, "0.7.0")
    ]),
    /**
     * Returns favorites timeline of any user
     * @see GET /api/v1/pleroma/accounts/:id/favourites
     */
    publicFavourites: l([
      t.software === m,
      t.software === p
    ]),
    /**
     * Can display a timeline of all known public statuses.
     * Local and Fediverse timelines both use this feature.
     * @see GET /api/v1/timelines/public
     */
    publicTimeline: l([
      t.software === m,
      t.software === U,
      t.software === A,
      t.software === R,
      t.software === d,
      t.software === P,
      t.software === E,
      t.software === v,
      t.software === y,
      t.software === $,
      t.software === p,
      t.software === L,
      t.software === se,
      t.software === O,
      t.software === Y,
      t.software === et
    ]),
    /**
     * Ability to quote posts in statuses.
     * @see POST /api/v1/statuses
     */
    quotePosts: l([
      t.software === E,
      t.software === R && c(t.version, "2023.3.0"),
      t.software === L,
      a.api_versions.mastodon >= 7,
      a.api_versions["quote_posting.pleroma.pl-api"] >= 1,
      a.feature_quote === !0
    ]),
    quoteApprovalPolicies: a.api_versions.mastodon >= 7,
    /**
     * Ability to boost a status to a selected scope.
     * @see POST /api/v1/statuses/:id/reblog
     */
    reblogVisibility: l([
      t.software === m,
      t.software === E,
      t.software === v,
      t.software === p
    ]),
    /**
     * Interact with statuses from another instance while logged-out.
     * @see POST /api/v1/pleroma/remote_interaction
     */
    remoteInteractions: l([
      t.software === m,
      t.software === p && c(t.version, "2.5.0")
    ]),
    /**
     * Ability to remove an account from your followers.
     * @see POST /api/v1/accounts/:id/remove_from_followers
     */
    removeFromFollowers: l([
      t.software === m,
      t.software === E,
      t.software === v,
      t.software === y && c(t.version, "2.17.0"),
      t.software === p && c(t.version, "2.5.0")
    ]),
    /**
     * Can request a password reset email through the API.
     * @see POST /auth/password
     */
    resetPassword: l([
      t.software === m,
      t.software === p
    ]),
    /**
     * Ability to post statuses in Markdown, BBCode, and HTML.
     * @see POST /api/v1/statuses
     */
    richText: l([
      t.software === m,
      t.software === v && t.build === Hn,
      t.software === p,
      t.software === y,
      t.software === d,
      a.pleroma.metadata.post_formats.filter((n) => n !== "text/plain").length > 0
    ]),
    /**
     * Ability to follow account feeds using RSS.
     */
    rssFeeds: l([
      t.software === m,
      t.software === v,
      t.software === p,
      t.software === d
    ]),
    /**
     * Ability to subscribe to RSS feeds.
     * @see GET /api/v1/pleroma/rss_feed_subscriptions
     * @see POST /api/v1/pleroma/rss_feed_subscriptions
     * @see DELETE /api/v1/pleroma/rss_feed_subscriptions
     */
    rssFeedSubscriptions: a.api_versions["rss_feed_subscriptions.pleroma.pl-api"] >= 1,
    /**
     * Can schedule statuses to be posted at a later time.
     * @see POST /api/v1/statuses
     * @see {@link https://docs.joinmastodon.org/methods/scheduled_statuses/}
     */
    scheduledStatuses: l([
      t.software === m,
      t.software === A,
      t.software === R,
      t.software === d && c(t.version, "0.18.0"),
      t.software === v,
      t.software === p,
      t.software === L
    ]),
    /**
     * Can publish statuses with a past date. This is intended for importing old statuses.
     * @see POST /api/v1/statuses
     * @see {@link https://docs.gotosocial.org/en/latest/api/swagger/}
     */
    scheduledStatusesBackwards: l([
      t.software === d && c(t.version, "0.18.0"),
      a.api_versions["backwards_schedule_at.pleroma.pl-api"] >= 1
    ]),
    /**
     * Can create Listen activities
     * @see GET /api/v1/pleroma/accounts/:id/scrobbles
     * @see POST /api/v1/pleroma/scrobble
     */
    scrobbles: t.software === p,
    /**
     * Ability to search statuses from the given account.
     * @see {@link https://docs.joinmastodon.org/methods/search/}
     * @see POST /api/v2/search
     */
    searchFromAccount: l([
      t.software === m,
      t.software === U,
      t.software === d,
      t.software === P,
      t.software === v,
      t.software === p
    ]),
    /**
     * Ability to manage account sessions.
     * @see GET /api/oauth_tokens.json
     * @see DELETE /api/oauth_tokens/:id
     * @see GET /api/v1/tokens
     * @see GET /api/v1/tokens/:id
     * @see POST /api/v1/tokens/:id/invalidate
     */
    sessions: l([
      t.software === m,
      t.software === E,
      t.software === p,
      t.software === d && c(t.version, "0.18.2")
    ]),
    shoutbox: a.api_versions["shout.pleroma.pl-api"] >= 1,
    /**
     * Can set content warnings on statuses.
     * @see POST /api/v1/statuses
     */
    spoilers: t.software !== y,
    /**
     * @see POST /api/friendica/statuses/:id/dislike
     * @see POST /api/friendica/statuses/:id/undislike
     * @see GET  /api/friendica/statuses/:id/disliked_by
     */
    statusDislikes: t.software === R && c(t.version, "2023.3.0"),
    /**
     * @see GET /api/web/stories/v1/recent
     * @see GET /api/web/stories/v1/viewers
     * @see GET /api/web/stories/v1/profile/:id
     * @see GET /api/web/stories/v1/exists/:id
     * @see GET /api/web/stories/v1/poll/results
     * @see POST /api/web/stories/v1/viewed
     * @see POST /api/web/stories/v1/react
     * @see POST /api/web/stories/v1/comment
     * @see POST /api/web/stories/v1/publish/poll
     * @see POST /api/web/stories/v1/poll/vote
     * @see POST /api/web/stories/v1/report
     * @see POST /api/web/stories/v1/add
     * @see POST /api/web/stories/v1/crop
     * @see POST /api/web/stories/v1/publish
     * @see DELETE /api/web/stories/v1/delete/:id
     */
    stories: t.software === q,
    /**
     * @see GET    /api/v1/accounts/:id/subscribers
     * @see POST   /api/v1/subscriptions
     * @see GET    /api/v1/subscriptions/options
     * @see POST   /api/v1/subscriptions/options
     * @see GET    /api/v1/subscriptions/find
     * @see POST   /api/v1/subscriptions/invoices
     * @see GET    /api/v1/subscriptions/invoices/:id
     * @see DELETE /api/v1/subscriptions/invoices/:id
     */
    subscriptions: t.software === y,
    /**
     * Can display suggested accounts.
     * @see {@link https://docs.joinmastodon.org/methods/suggestions/}
     */
    suggestions: l([
      t.software === R,
      t.software === P,
      t.software === v,
      t.software === q,
      a.api_versions["v2_suggestions.pleroma.pl-api"] >= 1
    ]),
    /**
     * Remove an account from follow suggestions
     * @see DELETE /api/v1/suggestions/:account_id
     */
    suggestionsDismiss: l([
      t.software === v
    ]),
    /**
     * Supports V2 suggested accounts.
     * @see GET /api/v2/suggestions
     */
    suggestionsV2: l([
      t.software === R,
      t.software === P,
      t.software === v,
      t.software === L,
      a.api_versions["v2_suggestions.pleroma.pl-api"] >= 1
    ]),
    /**
     * Can translate statuses.
     * @see POST /api/v1/statuses/:id/translate
     */
    translations: l([
      a.api_versions["translation.pleroma.pl-api"] >= 1,
      a.api_versions["machine_translation.akkoma.pl-api"] >= 1,
      a.configuration.translation.enabled
    ]),
    /**
     * Trending links.
     * @see GET /api/v1/trends/links
     */
    trendingLinks: t.software === v && c(t.compatVersion, "3.5.0"),
    /**
     * Trending statuses.
     * @see GET /api/v1/trends/statuses
     */
    trendingStatuses: l([
      t.software === U,
      t.software === A,
      t.software === R && c(t.version, "2022.12.0"),
      t.software === P,
      t.software === v,
      t.software === q,
      t.software === L
    ]),
    /**
     * Display trends from a given time range.
     * @see GET /api/pixelfed/v2/discover/posts/trending
     */
    trendingStatusesRange: t.software === q,
    /**
     * Can display trending hashtags.
     * @see GET /api/v1/trends
     */
    trends: l([
      t.software === U,
      t.software === A,
      t.software === R && c(t.version, "2022.12.0"),
      t.software === P,
      t.software === v,
      t.software === $,
      t.software === q,
      t.software === L,
      t.software === O && c(t.version, "0.12.0")
    ]),
    /**
     * Whether the backend allows adding users you don't follow to lists.
     * @see POST /api/v1/lists/:id/accounts
     */
    unrestrictedLists: l([
      t.software === m,
      t.software === p,
      t.software === se
    ]),
    /**
     * Can display a timeline of most recently wrenched statuses.
     * @see GET /api/v1/pleroma/timelines/wrenched
     */
    wrenchedTimeline: a.api_versions["wrenched_timeline.pleroma.pl-api"] >= 1
  };
}, Wn = (a) => {
  const s = /^([\w+.-]*)(?: \(compatible; ([\w.]*) (.*)\))?$/.exec(a.replace("/", " ")), n = s && (s[3] || s[1]), o = s ? It(n) || Dt(n, {
    loose: !0
  }) : null, b = s ? It(s[1]) || Dt(s[1]) : null;
  return s && o && b ? {
    build: o.build[0]?.split("-")[0],
    compatVersion: b.version,
    software: s[2] || v,
    version: o.version.split("-")[0]
  } : {
    build: null,
    compatVersion: "0.0.0",
    software: null,
    version: "0.0.0"
  };
}, Jn = (a) => /^([a-z][a-z\d+\-.]*:)?\/\//i.test(a), Kn = (a, t) => t ? a.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : a, ct = (a, t, s) => {
  const n = t && !Jn(a) ? Kn(t, a) : a;
  if (s && Object.entries(s).length) {
    const { url: o, query: b } = vt.parseUrl(n);
    return `${o}?${vt.stringify({ ...b, ...s }, { arrayFormat: "bracket" })}`;
  }
  return n;
}, fs = (a) => new gs(a.headers?.get("link") || void 0), Mt = (a) => fs(a).refs.find((t) => t.rel.toLocaleLowerCase() === "next")?.uri || null, Gt = (a) => fs(a).refs.find((t) => t.rel.toLocaleLowerCase() === "prev")?.uri || null, Yn = (a) => "id" in a && "retry" in a, Zn = (a) => {
  const t = a.headers.get("mastodon-async-refresh");
  if (!t)
    return null;
  const s = {};
  return t.split(/,\s*/).forEach((n) => {
    const [o, b] = n.split("=", 2);
    let g;
    o && ["id", "retry"].includes(o) && b && (b.startsWith('"') ? g = b.slice(1, -1) : g = parseInt(b), s[o] = g);
  }), Yn(s) ? s : null;
};
function bs(a, {
  body: t,
  method: s = t ? "POST" : "GET",
  params: n,
  onUploadProgress: o,
  signal: b,
  contentType: g = "application/json",
  idempotencyKey: S
} = {}) {
  a = a.toString();
  const i = ct(a, this.baseURL, n), _ = new Headers();
  return a.startsWith("/api/iceshrimp/") && this.iceshrimpAccessToken ? _.set("Authorization", `Bearer ${this.iceshrimpAccessToken}`) : this.accessToken && _.set("Authorization", `Bearer ${this.accessToken}`), g !== "" && t && _.set("Content-Type", g), S && _.set("Idempotency-Key", g), t = t && g === "" ? vs(t, { indices: !0 }) : JSON.stringify(t), o ? new Promise((u, J) => {
    const T = new XMLHttpRequest();
    T.addEventListener("progress", o), T.addEventListener("loadend", () => {
      const I = T.response;
      let N;
      if (T.getResponseHeader("content-type")?.match(/(text|application)\/json/))
        try {
          N = JSON.parse(I);
        } catch {
        }
      T.status >= 400 && J({ response: {
        status: T.status,
        statusText: T.statusText,
        url: T.responseURL,
        data: I,
        json: N
      } }), u({ status: T.status, data: I, json: N });
    }), T.open(s, i, !0), _.forEach((I, N) => T.setRequestHeader(N, I)), T.responseType = "text", T.send(t);
  }) : fetch(i, {
    method: s,
    headers: _,
    body: t,
    signal: b
  }).then(async (u) => {
    const J = await u.text();
    let T;
    if (u.headers.get("content-type")?.match(/(text|application)\/json/))
      try {
        T = JSON.parse(J);
      } catch {
      }
    const { headers: I, ok: N, redirected: k, status: z, statusText: D, type: te, url: ge } = u, K = { headers: I, ok: N, redirected: k, status: z, statusText: D, type: te, url: ge, data: J, json: T };
    if (!N)
      throw { response: K };
    return K;
  });
}
const Qn = ["favourite", "reblog", "emoji_reaction", "event_reminder", "participation_accepted", "participation_request"];
class co {
  baseURL;
  #o;
  #r;
  #s = e.parse(Et, {});
  request = bs.bind(this);
  features = Ct(this.#s);
  #a;
  #n;
  /**
   *
   * @param baseURL Mastodon API-compatible server URL
   * @param accessToken OAuth token for an authorized user
   */
  constructor(t, s, {
    instance: n,
    fetchInstance: o,
    fetchInstanceSignal: b,
    onInstanceFetchSuccess: g,
    onInstanceFetchError: S
  } = {}) {
    this.baseURL = t, this.#o = s, n && this.#d(n), o && this.instance.getInstance().then((i) => {
      b?.aborted || g?.(i);
    }).catch((i) => {
      b?.aborted || S?.(i);
    });
  }
  #e = async (t, s, n, o = !0) => {
    const b = o ? r(n) : n, g = (_) => ({
      previous: S(Gt(_)),
      next: S(Mt(_)),
      items: e.parse(b, _.json),
      partial: _.status === 206
    }), S = (_) => _ ? () => this.request(_).then(g) : null, i = await this.request(t, s);
    return g(i);
  };
  #l = async (t) => {
    const s = await this.request("/api/v1/pleroma/admin/users", { params: t }), n = e.parse(r(C), s.json?.users);
    return {
      previous: t.page ? () => this.#l({ ...t, page: t.page - 1 }) : null,
      next: s.json?.count > t.page_size * ((t.page || 1) - 1) + s.json?.users?.length ? () => this.#l({ ...t, page: (t.page || 0) + 1 }) : null,
      items: n,
      partial: s.status === 206,
      total: s.json?.count
    };
  };
  #c = async (t) => {
    const s = await this.request("/api/v1/pleroma/admin/reports", { params: t });
    return {
      previous: t.page ? () => this.#c({ ...t, page: t.page - 1 }) : null,
      next: s.json?.total > t.page_size * ((t.page || 1) - 1) + s.json?.reports?.length ? () => this.#c({ ...t, page: (t.page || 0) + 1 }) : null,
      items: e.parse(r(Z), s.json?.reports),
      partial: s.status === 206,
      total: s.json?.total
    };
  };
  #u = async (t) => {
    const s = await this.request("/api/v1/pleroma/admin/statuses", { params: t });
    return {
      previous: t.page ? () => this.#u({ ...t, page: t.page - 1 }) : null,
      next: s.json?.length ? () => this.#u({ ...t, page: (t.page || 0) + 1 }) : null,
      items: e.parse(r(f), s.json),
      partial: s.status === 206
    };
  };
  #p = async (t, s) => {
    await this.#t();
    const n = await this.request(t), o = s(n.json), b = await this.accounts.getAccounts(o), g = Gt(n), S = Mt(n);
    return {
      previous: g ? () => this.#p(g, s) : null,
      next: S ? () => this.#p(S, s) : null,
      items: b,
      partial: n.status === 206
    };
  };
  #i = ({ previous: t, next: s, items: n, ...o }, b) => {
    const g = [];
    for (const i of n) {
      let _;
      (b?.grouped_types || Qn).includes(i.type) && (_ = g.find(
        (u) => u.type === i.type && (i.type === "emoji_reaction" && u.type === "emoji_reaction" ? i.emoji === u.emoji : !0) && u.status_id === i.status?.id
      )), _ ? (_.notifications_count += 1, _.page_min_id = i.id, _.sample_account_ids.push(i.account.id)) : g.push({
        ...hs(i, ["account", "status", "target"]),
        group_key: i.id,
        notifications_count: 1,
        most_recent_notification_id: i.id,
        page_min_id: i.id,
        page_max_id: i.id,
        latest_page_notification_at: i.created_at,
        sample_account_ids: [i.account.id],
        // @ts-ignore
        status_id: i.status?.id,
        // @ts-ignore
        target_id: i.target?.id
      });
    }
    const S = {
      accounts: Object.values(n.reduce((i, _) => (i[_.account.id] = _.account, "target" in _ && (i[_.target.id] = _.target), i), {})),
      statuses: Object.values(n.reduce((i, _) => ("status" in _ && _.status && (i[_.status.id] = _.status), i), {})),
      notification_groups: g
    };
    return {
      ...o,
      previous: t ? async () => this.#i(await t(), b) : null,
      next: s ? async () => this.#i(await s(), b) : null,
      items: S
    };
  };
  /** Register client applications that can be used to obtain OAuth tokens. */
  apps = {
    /**
     * Create an application
     * Create a new application to obtain OAuth2 credentials.
     * @see {@link https://docs.joinmastodon.org/methods/apps/#create}
     */
    createApplication: async (t) => {
      const s = await this.request("/api/v1/apps", { method: "POST", body: t });
      return e.parse(sa, s.json);
    },
    /**
     * Verify your app works
     * Confirm that the app’s OAuth2 credentials work.
     * @see {@link https://docs.joinmastodon.org/methods/apps/#verify_credentials}
     */
    verifyApplication: async () => {
      const t = await this.request("/api/v1/apps/verify_credentials");
      return e.parse(Ie, t.json);
    }
  };
  oauth = {
    /**
     * Authorize a user
     * Displays an authorization form to the user. If approved, it will create and return an authorization code, then redirect to the desired `redirect_uri`, or show the authorization code if `urn:ietf:wg:oauth:2.0:oob` was requested. The authorization code can be used while requesting a token to obtain access to user-level methods.
     * @see {@link https://docs.joinmastodon.org/methods/oauth/#authorize}
     */
    authorize: async (t) => {
      const s = await this.request("/oauth/authorize", { params: t, contentType: "" });
      return e.parse(e.string(), s.json);
    },
    /**
     * Obtain a token
     * Obtain an access token, to be used during API calls that are not public.
     * @see {@link https://docs.joinmastodon.org/methods/oauth/#token}
     */
    getToken: async (t) => {
      if (this.features.version.software === E && t.grant_type === "password") {
        const s = (await this.request("/api/iceshrimp/auth/login", {
          method: "POST",
          body: {
            username: t.username,
            password: t.password
          }
        })).json;
        this.#r = s.token;
        const n = (await this.request("/api/iceshrimp/sessions/mastodon", {
          method: "POST",
          body: {
            appName: t.client_id,
            scopes: t.scope?.split(" "),
            flags: {
              supportsHtmlFormatting: !0,
              autoDetectQuotes: !1,
              isPleroma: !0,
              supportsInlineMedia: !0
            }
          }
        })).json;
        return e.parse(Te, {
          access_token: n.token,
          token_type: "Bearer",
          scope: n.scopes.join(" "),
          created_at: new Date(n.created_at).getTime(),
          id: n.id
        });
      } else {
        const s = await this.request("/oauth/token", { method: "POST", body: t, contentType: "" });
        return e.parse(Te, { scope: t.scope || "", ...s.json });
      }
    },
    /**
     * Revoke a token
     * Revoke an access token to make it no longer valid for use.
     * @see {@link https://docs.joinmastodon.org/methods/oauth/#revoke}
     */
    revokeToken: async (t) => {
      const s = await this.request("/oauth/revoke", { method: "POST", body: t, contentType: "" });
      return this.#a?.close(), s.json;
    },
    /**
     * Retrieve user information
     * Retrieves standardised OIDC claims about the currently authenticated user.
     * see {@link https://docs.joinmastodon.org/methods/oauth/#userinfo}
     */
    userinfo: async () => {
      const t = await this.request("/oauth/userinfo");
      return e.parse(_n, t.json);
    },
    authorizationServerMetadata: async () => {
      const t = await this.request("/.well-known/oauth-authorization-server");
      return e.parse(na, t.json);
    },
    /**
     * Get a new captcha
     * @see {@link https://docs.pleroma.social/backend/development/API/pleroma_api/#apiv1pleromacaptcha}
    */
    getCaptcha: async () => {
      const t = await this.request("/api/pleroma/captcha");
      return e.parse(e.intersect([e.object({
        type: e.string()
      }), e.record(e.string(), e.any())]), t.json);
    },
    mfaChallenge: async (t) => {
      const s = await this.request("/oauth/mfa/challenge", { method: "POST", body: t });
      return e.parse(Te, s.json);
    }
  };
  emails = {
    resendConfirmationEmail: async (t) => (await this.request("/api/v1/emails/confirmations", { method: "POST", body: { email: t } })).json
  };
  accounts = {
    /**
     * Get account
     * View information about a profile.
     * @see {@link https://docs.joinmastodon.org/methods/accounts/#get}
     */
    getAccount: async (t, s) => {
      const n = await this.request(`/api/v1/accounts/${t}`, { params: s });
      return e.parse(w, n.json);
    },
    /**
     * Get multiple accounts
     * View information about multiple profiles.
     *
     * Requires features{@link Features.getAccounts}.
     * @see {@link https://docs.joinmastodon.org/methods/accounts/#index}
     */
    getAccounts: async (t) => {
      const s = await this.request("/api/v1/accounts", { params: { id: t } });
      return e.parse(r(w), s.json);
    },
    /**
     * Get account’s statuses
     * Statuses posted to the given account.
     * @see {@link https://docs.joinmastodon.org/methods/accounts/#statuses}
     */
    getAccountStatuses: async (t, s) => this.#e(`/api/v1/accounts/${t}/statuses`, { params: s }, f),
    /**
     * Get account’s followers
     * Accounts which follow the given account, if network is not hidden by the account owner.
     * @see {@link https://docs.joinmastodon.org/methods/accounts/#followers}
     */
    getAccountFollowers: async (t, s) => this.#e(`/api/v1/accounts/${t}/followers`, { params: s }, w),
    /**
     * Get account’s following
     * Accounts which the given account is following, if network is not hidden by the account owner.
     * @see {@link https://docs.joinmastodon.org/methods/accounts/#following}
     */
    getAccountFollowing: async (t, s) => this.#e(`/api/v1/accounts/${t}/following`, { params: s }, w),
    /**
     * Subscriptions to the given user.
     *
     * Requires features{@link Features.subscriptions}.
     */
    getAccountSubscribers: async (t, s) => this.#e(`/api/v1/accounts/${t}/subscribers`, { params: s }, w),
    /**
     * Get account’s featured tags
     * Tags featured by this account.
     *
     * Requires features{@link Features.featuredTags}.
     * @see {@link https://docs.joinmastodon.org/methods/accounts/#featured_tags}
     */
    getAccountFeaturedTags: async (t) => {
      const s = await this.request(`/api/v1/accounts/${t}/featured_tags`);
      return e.parse(r(Ke), s.json);
    },
    /**
     * Get lists containing this account
     * User lists that you have added this account to.
     * @see {@link https://docs.joinmastodon.org/methods/accounts/#lists}
     */
    getAccountLists: async (t) => {
      const s = await this.request(`/api/v1/accounts/${t}/lists`);
      return e.parse(r(Q), s.json);
    },
    /**
     * Get antennas containing this account
     * User antennas that you have added this account to.
     * Requires features{@link Features.antennas}.
     */
    getAccountAntennas: async (t) => {
      const s = await this.request(`/api/v1/accounts/${t}/antennas`);
      return e.parse(r(ae), s.json);
    },
    /**
     * Get antennas excluding this account
     * Requires features{@link Features.antennas}.
     */
    getAccountExcludeAntennas: async (t) => {
      const s = await this.request(`/api/v1/accounts/${t}/circles`);
      return e.parse(r(de), s.json);
    },
    /**
     * Get circles including this account
     * User circles that you have added this account to.
     * Requires features{@link Features.circles}.
     */
    getAccountCircles: async (t) => {
      const s = await this.request(`/api/v1/accounts/${t}/exclude_antennas`);
      return e.parse(r(ae), s.json);
    },
    /**
     * Follow account
     * Follow the given account. Can also be used to update whether to show reblogs or enable notifications.
     * @see {@link https://docs.joinmastodon.org/methods/accounts/#follow}
     */
    followAccount: async (t, s) => {
      const n = await this.request(`/api/v1/accounts/${t}/follow`, { method: "POST", body: s });
      return e.parse(F, n.json);
    },
    /**
     * Unfollow account
     * Unfollow the given account.
     * @see {@link https://docs.joinmastodon.org/methods/accounts/#unfollow}
     */
    unfollowAccount: async (t) => {
      const s = await this.request(`/api/v1/accounts/${t}/unfollow`, { method: "POST" });
      return e.parse(F, s.json);
    },
    /**
     * Remove account from followers
     * Remove the given account from your followers.
     * @see {@link https://docs.joinmastodon.org/methods/accounts/#remove_from_followers}
     */
    removeAccountFromFollowers: async (t) => {
      const s = await this.request(`/api/v1/accounts/${t}/remove_from_followers`, { method: "POST" });
      return e.parse(F, s.json);
    },
    /**
     * Feature account on your profile
     * Add the given account to the user’s featured profiles.
     * @see {@link https://docs.joinmastodon.org/methods/accounts/#pin}
     */
    pinAccount: async (t) => {
      const s = await this.request(`/api/v1/accounts/${t}/pin`, { method: "POST" });
      return e.parse(F, s.json);
    },
    /**
     * Unfeature account from profile
     * Remove the given account from the user’s featured profiles.
     * @see {@link https://docs.joinmastodon.org/methods/accounts/#unpin}
     */
    unpinAccount: async (t) => {
      const s = await this.request(`/api/v1/accounts/${t}/unpin`, { method: "POST" });
      return e.parse(F, s.json);
    },
    /**
     * Set private note on profile
     * Sets a private note on a user.
     * @see {@link https://docs.joinmastodon.org/methods/accounts/#note}
     */
    updateAccountNote: async (t, s) => {
      const n = await this.request(`/api/v1/accounts/${t}/note`, { method: "POST", body: { comment: s } });
      return e.parse(F, n.json);
    },
    /**
     * Check relationships to other accounts
     * Find out whether a given account is followed, blocked, muted, etc.
     * @see {@link https://docs.joinmastodon.org/methods/accounts/#relationships}
     */
    getRelationships: async (t, s) => {
      const n = await this.request("/api/v1/accounts/relationships", { params: { ...s, id: t } });
      return e.parse(r(F), n.json);
    },
    /**
     * Find familiar followers
     * Obtain a list of all accounts that follow a given account, filtered for accounts you follow.
     *
     * Requires features{@link Features.familiarFollowers}.
     * @see {@link https://docs.joinmastodon.org/methods/accounts/#familiar_followers}
     */
    getFamiliarFollowers: async (t) => {
      let s;
      if (this.features.version.software === q) {
        s = [];
        for (const n of t) {
          const o = (await this.request(`/api/v1.1/accounts/mutuals/${n}`)).json;
          s.push({
            id: n,
            accounts: o
          });
        }
      } else
        s = (await this.request("/api/v1/accounts/familiar_followers", { params: { id: t } })).json;
      return e.parse(r(ma), s);
    },
    /**
     * Search for matching accounts
     * Search for matching accounts by username or display name.
     * @see {@link https://docs.joinmastodon.org/methods/accounts/#search}
     */
    searchAccounts: async (t, s, n) => {
      const o = await this.request("/api/v1/accounts/search", { ...n, params: { ...s, q: t } });
      return e.parse(r(w), o.json);
    },
    /**
         * Lookup account ID from Webfinger address
         * Quickly lookup a username to see if it is available, skipping WebFinger resolution.
    
         * Requires features{@link Features.accountLookup}.
         * @see {@link https://docs.joinmastodon.org/methods/accounts/#lookup}
         */
    lookupAccount: async (t, s) => {
      const n = await this.request("/api/v1/accounts/lookup", { ...s, params: { acct: t } });
      return e.parse(w, n.json);
    },
    /**
     * File a report
     * @see {@link https://docs.joinmastodon.org/methods/reports/#post}
     */
    reportAccount: async (t, s) => {
      const n = await this.request("/api/v1/reports", {
        method: "POST",
        body: { ...s, account_id: t }
      });
      return e.parse(wt, n.json);
    },
    /**
     * Endorsements
     * Returns endorsed accounts
     *
     * Requires features{@link Features.accountEndorsements}.
     * @see {@link https://docs.pleroma.social/backend/development/API/pleroma_api/#apiv1pleromaaccountsidendorsements}
     * @see {@link https://docs.joinmastodon.org/methods/accounts/endorsements}
     */
    getAccountEndorsements: async (t, s) => this.#e(
      `/api/v1/${[p, m].includes(this.features.version.software) ? "pleroma/" : ""}accounts/${t}/endorsements`,
      { params: s },
      w
    ),
    /**
     * Birthday reminders
     * Birthday reminders about users you follow.
     *
     * Requires features{@link Features.birthdays}.
     */
    getBirthdays: async (t, s) => {
      const n = await this.request("/api/v1/pleroma/birthdays", { params: { day: t, month: s } });
      return e.parse(r(w), n.json);
    },
    /**
     * Returns favorites timeline of any user
     *
     * Requires features{@link Features.publicFavourites}.
     * @see {@link https://docs.pleroma.social/backend/development/API/pleroma_api/#apiv1pleromaaccountsidfavourites}
     */
    getAccountFavourites: async (t, s) => this.#e(`/api/v1/pleroma/accounts/${t}/favourites`, { params: s }, f),
    /**
     * Interact with profile or status from remote account
     *
     * Requires features{@link Features.remoteInteractions}.
     * @param ap_id - Profile or status ActivityPub ID
     * @param profile - Remote profile webfinger
     * @see {@link https://docs.pleroma.social/backend/development/API/pleroma_api/#apiv1pleromaremote_interaction}
     */
    remoteInteraction: async (t, s) => {
      const n = await this.request("/api/v1/pleroma/remote_interaction", { method: "POST", body: { ap_id: t, profile: s } });
      if (n.json?.error) throw n.json.error;
      return e.parse(e.object({
        url: e.string()
      }), n.json);
    },
    /**
     * Bite the given user.
     *
     * Requires features{@link Features.bites}.
     * @see {@link https://github.com/purifetchi/Toki/blob/master/Toki/Controllers/MastodonApi/Bite/BiteController.cs}
     */
    biteAccount: async (t) => {
      let s;
      switch (this.features.version.software) {
        case E:
          s = await this.request("/api/v1/bite", { method: "POST", body: t });
          break;
        default:
          s = await this.request("/api/v1/bite", { method: "POST", params: { id: t } });
          break;
      }
      return s.json;
    },
    /**
     * Requests a list of current and recent Listen activities for an account
     *
     * Requires features{@link Features.scrobbles}
     * @see {@link https://docs.pleroma.social/backend/development/API/pleroma_api/#get-apiv1pleromaaccountsidscrobbles}
     */
    getScrobbles: async (t, s) => this.#e(`/api/v1/pleroma/accounts/${t}/scrobbles`, { params: s }, $t),
    /**
     * Creates a new Listen activity for an account
     *
     * Requires features{@link Features.scrobbles}
     * @see {@link https://docs.pleroma.social/backend/development/API/pleroma_api/#post-apiv1pleromascrobble}
     */
    createScrobble: async (t) => {
      t.external_link && (t.externalLink = t.external_link);
      const s = await this.request("/api/v1/pleroma/scrobble", { body: t });
      return e.parse($t, s.json);
    },
    /**
     * Load latest activities from outbox
     *
     * Requires features{@link Features.loadActivities}
     */
    loadActivities: async (t) => (await this.request(`/api/v1/accounts/${t}/load_activities`, { method: "POST" })).json
  };
  myAccount = {
    /**
     * View bookmarked statuses
     * Statuses the user has bookmarked.
     * @see {@link https://docs.joinmastodon.org/methods/bookmarks/#get}
     */
    getBookmarks: async (t) => this.#e(
      this.features.bookmarkFoldersMultiple && t?.folder_id ? `/api/v1/bookmark_categories/${t.folder_id}/statuses` : "/api/v1/bookmarks",
      { params: t },
      f
    ),
    /**
     * View favourited statuses
     * Statuses the user has favourited.
     * @see {@link https://docs.joinmastodon.org/methods/favourites/#get}
     */
    getFavourites: async (t) => this.#e("/api/v1/favourites", { params: t }, f),
    /**
     * View pending follow requests
     * @see {@link https://docs.joinmastodon.org/methods/follow_requests/#get}
     */
    getFollowRequests: async (t) => this.#e("/api/v1/follow_requests", { params: t }, w),
    /**
     * View outgoing follow requests
     *
     * Requires features{@link Features.outgoingFollowRequests}.
     */
    getOutgoingFollowRequests: async (t) => {
      if (this.features.version.software === E)
        return this.#p(
          "/api/iceshrimp/follow_requests/outgoing",
          (s) => s.map(({ user: n }) => n.id)
        );
      switch (this.features.version.software) {
        case d:
          return this.#e("/api/v1/follow_requests/outgoing", { params: t }, w);
        default:
          return this.#e("/api/v1/pleroma/outgoing_follow_requests", { params: t }, w);
      }
    },
    /**
     * Accept follow request
     * @see {@link https://docs.joinmastodon.org/methods/follow_requests/#accept}
     */
    acceptFollowRequest: async (t) => {
      const s = await this.request(`/api/v1/follow_requests/${t}/authorize`, { method: "POST" });
      return e.parse(F, s.json);
    },
    /**
     * Reject follow request
     * @see {@link https://docs.joinmastodon.org/methods/follow_requests/#reject}
     */
    rejectFollowRequest: async (t) => {
      const s = await this.request(`/api/v1/follow_requests/${t}/reject`, { method: "POST" });
      return e.parse(F, s.json);
    },
    /**
     * View currently featured profiles
     * Accounts that the user is currently featuring on their profile.
     * @see {@link https://docs.joinmastodon.org/methods/endorsements/#get}
     */
    getEndorsements: async (t) => this.#e("/api/v1/endorsements", { params: t }, w),
    /**
     * View your featured tags
     * List all hashtags featured on your profile.
     *
     * Requires features{@link Features.featuredTags}.
     * @see {@link https://docs.joinmastodon.org/methods/featured_tags/#get}
     */
    getFeaturedTags: async () => {
      const t = await this.request("/api/v1/featured_tags");
      return e.parse(r(Ke), t.json);
    },
    /**
     * Feature a tag
     * Promote a hashtag on your profile.
     *
     * Requires features{@link Features.featuredTags}.
     * @see {@link https://docs.joinmastodon.org/methods/featured_tags/#feature}
     */
    featureTag: async (t) => {
      const s = await this.request("/api/v1/featured_tags", {
        method: "POST",
        body: { name: t }
      });
      return e.parse(r(Ke), s.json);
    },
    /**
     * Unfeature a tag
     * Stop promoting a hashtag on your profile.
     *
     * Requires features{@link Features.featuredTags}.
     * @see {@link https://docs.joinmastodon.org/methods/featured_tags/#unfeature}
     */
    unfeatureTag: async (t) => (await this.request("/api/v1/featured_tags", {
      method: "DELETE",
      body: { name: t }
    })).json,
    /**
     * View suggested tags to feature
     * Shows up to 10 recently-used tags.
     *
     * Requires features{@link Features.featuredTags}.
     * @see {@link https://docs.joinmastodon.org/methods/featured_tags/#suggestions}
     */
    getFeaturedTagsSuggestions: async () => {
      const t = await this.request("/api/v1/featured_tags/suggestions");
      return e.parse(r(X), t.json);
    },
    /**
     * View all followed tags
     * List your followed hashtags.
     *
     * Requires features{@link Features.followHashtags}.
     * @see {@link https://docs.joinmastodon.org/methods/followed_tags/#get}
     */
    getFollowedTags: async (t) => this.#e("/api/v1/followed_tags", { params: t }, X),
    /**
     * View information about a single tag
     * Show a hashtag and its associated information
     * @see {@link https://docs.joinmastodon.org/methods/tags/#get}
     */
    getTag: async (t) => {
      const s = await this.request(`/api/v1/tags/${t}`);
      return e.parse(X, s.json);
    },
    /**
     * Follow a hashtag
     * Follow a hashtag. Posts containing a followed hashtag will be inserted into your home timeline.
     * @see {@link https://docs.joinmastodon.org/methods/tags/#follow}
     */
    followTag: async (t) => {
      const s = await this.request(`/api/v1/tags/${t}/follow`, { method: "POST" });
      return e.parse(X, s.json);
    },
    /**
     * Unfollow a hashtag
     * Unfollow a hashtag. Posts containing this hashtag will no longer be inserted into your home timeline.
     * @see {@link https://docs.joinmastodon.org/methods/tags/#unfollow}
     */
    unfollowTag: async (t) => {
      const s = await this.request(`/api/v1/tags/${t}/unfollow`, { method: "POST" });
      return e.parse(X, s.json);
    },
    /**
     * View follow suggestions
     * Accounts that are promoted by staff, or that the user has had past positive interactions with, but is not yet following.
     *
     * Requires features{@link Features.suggestions}.
     * @see {@link https://docs.joinmastodon.org/methods/suggestions/#v2}
     */
    getSuggestions: async (t) => {
      const s = await this.request(
        this.features.version.software === q ? "/api/v1.1/discover/accounts/popular" : this.features.suggestionsV2 ? "/api/v2/suggestions" : "/api/v1/suggestions",
        { params: { limit: t } }
      );
      return e.parse(r(vn), s.json);
    },
    /**
     * Remove a suggestion
     * Remove an account from follow suggestions.
     *
     * Requires features{@link Features.suggestionsDismiss}.
     * @see {@link https://docs.joinmastodon.org/methods/suggestions/#remove}
     */
    dismissSuggestions: async (t) => (await this.request(`/api/v1/suggestions/${t}`, { method: "DELETE" })).json,
    /**
     * Gets user bookmark folders
     *
     * Requires features{@link Features.bookmarkFolders}.
     * @see {@link https://docs.pleroma.social/backend/development/API/pleroma_api/#get-apiv1pleromabookmark_folders}
     */
    getBookmarkFolders: async () => {
      const t = await this.request(this.features.version.software === p ? "/api/v1/pleroma/bookmark_folders" : "/api/v1/bookmark_categories");
      return e.parse(r(pe), t.json);
    },
    /**
     * Creates a bookmark folder
     *
     * Requires features{@link Features.bookmarkFolders}.
     * Specifying folder emoji requires features{@link Features.bookmarkFolderEmojis}.
     * @see {@link https://docs.pleroma.social/backend/development/API/pleroma_api/#post-apiv1pleromabookmark_folders}
     */
    createBookmarkFolder: async (t) => {
      const s = await this.request(
        this.features.version.software === p ? "/api/v1/pleroma/bookmark_folders" : "/api/v1/bookmark_categories",
        { method: "POST", body: { title: t.name, ...t } }
      );
      return e.parse(pe, s.json);
    },
    /**
     * Updates a bookmark folder
     *
     * Requires features{@link Features.bookmarkFolders}.
     * Specifying folder emoji requires features{@link Features.bookmarkFolderEmojis}.
     * @see {@link https://docs.pleroma.social/backend/development/API/pleroma_api/#patch-apiv1pleromabookmark_foldersid}
     */
    updateBookmarkFolder: async (t, s) => {
      const n = await this.request(
        `${this.features.version.software === p ? "/api/v1/pleroma/bookmark_folders" : "/api/v1/bookmark_categories"}/${t}`,
        { method: "PATCH", body: { title: s.name, ...s } }
      );
      return e.parse(pe, n.json);
    },
    /**
     * Deletes a bookmark folder
     *
     * Requires features{@link Features.bookmarkFolders}.
     * @see {@link https://docs.pleroma.social/backend/development/API/pleroma_api/#delete-apiv1pleromabookmark_foldersid}
     */
    deleteBookmarkFolder: async (t) => {
      const s = await this.request(
        `${this.features.version.software === p ? "/api/v1/pleroma/bookmark_folders" : "/api/v1/bookmark_categories"}/${t}`,
        { method: "DELETE" }
      );
      return e.parse(pe, s.json);
    },
    /**
     * Requires features{@link Features.bookmarkFoldersMultiple}.
     */
    addBookmarkToFolder: async (t, s) => (await this.request(
      `/api/v1/bookmark_categories/${s}/statuses`,
      { method: "POST", params: { status_ids: [t] } }
    )).json,
    /**
     * Requires features{@link Features.bookmarkFoldersMultiple}.
     */
    removeBookmarkFromFolder: async (t, s) => (await this.request(
      `/api/v1/bookmark_categories/${s}/statuses`,
      { method: "DELETE", params: { status_ids: [t] } }
    )).json
  };
  settings = {
    /**
     * Register an account
     * Creates a user and account records. Returns an account access token for the app that initiated the request. The app should save this token for later, and should wait for the user to confirm their account by clicking a link in their email inbox.
     *
     * Requires features{@link Features.accountCreation}
     * @see {@link https://docs.joinmastodon.org/methods/accounts/#create}
     */
    createAccount: async (t) => {
      const s = await this.request("/api/v1/accounts", {
        method: "POST",
        body: { language: t.locale, birthday: t.date_of_birth, ...t }
      });
      return "identifier" in s.json ? e.parse(e.object({
        message: e.string(),
        identifier: e.string()
      }), s.json) : e.parse(Te, s.json);
    },
    /**
     * Verify account credentials
     * Test to make sure that the user token works.
     * @see {@link https://docs.joinmastodon.org/methods/accounts/#verify_credentials}
     */
    verifyCredentials: async () => {
      const t = await this.request("/api/v1/accounts/verify_credentials");
      return e.parse(ve, t.json);
    },
    /**
     * Update account credentials
     * Update the user’s display and preferences.
     * @see {@link https://docs.joinmastodon.org/methods/accounts/#update_credentials}
     */
    updateCredentials: async (t) => {
      t.background_image && (t.pleroma_background_image = t.background_image, delete t.background_image), t.settings_store && (t.pleroma_settings_store = t.settings_store, this.features.version.software === y && await this.request("/api/v1/settings/client_config", {
        method: "POST",
        body: t.settings_store
      }), delete t.settings_store);
      const s = await this.request("/api/v1/accounts/update_credentials", {
        method: "PATCH",
        contentType: this.features.version.software === d || t.avatar || t.header ? "" : void 0,
        body: t
      });
      return e.parse(ve, s.json);
    },
    /**
     * Delete profile avatar
     * Deletes the avatar associated with the user’s profile.
     * @see {@link https://docs.joinmastodon.org/methods/profile/#delete-profile-avatar}
     */
    deleteAvatar: async () => {
      const t = await this.request("/api/v1/profile/avatar", { method: "DELETE" });
      return e.parse(ve, t.json);
    },
    /**
     * Delete profile header
     * Deletes the header image associated with the user’s profile.
     * @see {@link https://docs.joinmastodon.org/methods/profile/#delete-profile-header}
     */
    deleteHeader: async () => {
      const t = await this.request("/api/v1/profile/header", { method: "DELETE" });
      return e.parse(ve, t.json);
    },
    /**
     * View user preferences
     * Preferences defined by the user in their account settings.
     * @see {@link https://docs.joinmastodon.org/methods/preferences/#get}
     */
    getPreferences: async () => (await this.request("/api/v1/preferences")).json,
    /**
     * Create a user backup archive
     *
     * Requires features{@link Features.accountBackups}.
     */
    createBackup: async () => {
      const t = await this.request("/api/v1/pleroma/backups", { method: "POST" });
      return e.parse(jt, t.json);
    },
    /**
     * List user backups
     *
     * Requires features{@link Features.accountBackups}.
     */
    getBackups: async () => {
      const t = await this.request("/api/v1/pleroma/backups");
      return e.parse(r(jt), t.json);
    },
    /**
     * Get aliases of the current account
     *
     * Requires features{@link Features.manageAccountAliases}.
     * @see {@link https://docs.pleroma.social/backend/development/API/pleroma_api/#get-aliases-of-the-current-account}
     */
    getAccountAliases: async () => {
      const t = await this.request("/api/pleroma/aliases");
      return e.parse(e.object({ aliases: r(e.string()) }), t.json);
    },
    /**
     * Add alias to the current account
     *
     * Requires features{@link Features.manageAccountAliases}.
     * @param alias - the nickname of the alias to add, e.g. foo@example.org.
     * @see {@link https://docs.pleroma.social/backend/development/API/pleroma_api/#add-alias-to-the-current-account}
     */
    addAccountAlias: async (t) => {
      const s = await this.request("/api/pleroma/aliases", { method: "PUT", body: { alias: t } });
      return e.parse(e.object({ status: e.literal("success") }), s.json);
    },
    /**
     * Delete alias from the current account
     *
     * Requires features{@link Features.manageAccountAliases}.
     * @param alias - the nickname of the alias to add, e.g. foo@example.org.
     * @see {@link https://docs.pleroma.social/backend/development/API/pleroma_api/#delete-alias-from-the-current-account}
     */
    deleteAccountAlias: async (t) => {
      const s = await this.request("/api/pleroma/aliases", { method: "DELETE", body: { alias: t } });
      return e.parse(e.object({ status: e.literal("success") }), s.json);
    },
    /**
     * Retrieve a list of active sessions for the user
     *
     * Requires features{@link Features.sessions}.
     * @see {@link https://docs.pleroma.social/backend/development/API/pleroma_api/#get-apioauth_tokens}
     */
    getOauthTokens: () => this.#e(
      this.features.version.software === d ? "/api/v1/tokens" : "/api/oauth_tokens",
      {},
      Wa
    ),
    /**
     * Revoke a user session by its ID
     *
     * Requires features{@link Features.sessions}.
     * @see {@link https://docs.pleroma.social/backend/development/API/pleroma_api/#delete-apioauth_tokensid}
     */
    deleteOauthToken: async (t) => {
      let s;
      switch (this.features.version.software) {
        case d:
          s = await this.request(`/api/v1/tokens/${t}/invalidate`, { method: "POST" });
          break;
        default:
          s = await this.request(`/api/oauth_tokens/${t}`, { method: "DELETE" });
          break;
      }
      return s.json;
    },
    /**
     * Change account password
     *
     * Requires features{@link Features.changePassword}.
     * @see {@link https://docs.gotosocial.org/en/latest/api/swagger}
     * @see {@link https://codeberg.org/silverpill/mitra/src/commit/f15c19527191d82bc3643f984deca43d1527525d/docs/openapi.yaml}
     * @see {@link https://git.pleroma.social/pleroma/pleroma/-/blob/develop/lib/pleroma/web/api_spec/operations/twitter_util_operation.ex?ref_type=heads#L68}
     */
    changePassword: async (t, s) => {
      let n;
      switch (this.features.version.software) {
        case d:
          n = await this.request("/api/v1/user/password_change", {
            method: "POST",
            body: {
              old_password: t,
              new_password: s
            }
          });
          break;
        case E:
          await this.#t(), n = await this.request("/api/iceshrimp/auth/change-password", {
            method: "POST",
            body: {
              oldPassword: t,
              newPassword: s
            }
          });
          break;
        case y:
          n = await this.request("/api/v1/settings/change_password", {
            method: "POST",
            body: { new_password: s }
          });
          break;
        case q:
          if (n = await this.request("/api/v1.1/accounts/change-password", {
            method: "POST",
            body: {
              current_password: t,
              new_password: s,
              confirm_password: s
            }
          }), n.redirected) throw n;
          break;
        default:
          n = await this.request("/api/pleroma/change_password", {
            method: "POST",
            body: {
              password: t,
              new_password: s,
              new_password_confirmation: s
            }
          });
      }
      return n.json;
    },
    /**
     * Request password reset e-mail
     *
     * Requires features{@link Features.resetPassword}.
     */
    resetPassword: async (t, s) => (await this.request("/auth/password", {
      method: "POST",
      body: { email: t, nickname: s }
    })).json,
    /**
     * Requires features{@link Features.changeEmail}.
     */
    changeEmail: async (t, s) => {
      let n;
      switch (this.features.version.software) {
        case d:
          n = await this.request("/api/v1/user/email_change", {
            method: "POST",
            body: {
              new_email: t,
              password: s
            }
          });
          break;
        default:
          n = await this.request("/api/pleroma/change_email", {
            method: "POST",
            body: {
              email: t,
              password: s
            }
          });
      }
      if (n.json?.error) throw n.json.error;
      return n.json;
    },
    /**
     * Requires features{@link Features.deleteAccount}.
     */
    deleteAccount: async (t) => {
      let s;
      switch (this.features.version.software) {
        case d:
          s = await this.request("/api/v1/accounts/delete", {
            method: "POST",
            body: { password: t }
          });
          break;
        default:
          s = await this.request("/api/pleroma/delete_account", {
            method: "POST",
            body: { password: t }
          });
      }
      if (s.json?.error) throw s.json.error;
      return s.json;
    },
    /**
     * Requires features{@link Features.deleteAccountWithoutPassword}.
     */
    deleteAccountWithoutPassword: async () => (await this.request("/api/v1/settings/delete_account", {
      method: "POST"
    })).json,
    /**
     * Disable an account
     *
     * Requires features{@link Features.disableAccount}.
     */
    disableAccount: async (t) => {
      const s = await this.request("/api/pleroma/disable_account", {
        method: "POST",
        body: { password: t }
      });
      if (s.json?.error) throw s.json.error;
      return s.json;
    },
    /**
     * Requires features{@link Features.accountMoving}.
     */
    moveAccount: async (t, s) => {
      const n = await this.request("/api/pleroma/move_account", {
        method: "POST",
        body: { password: s, target_account: t }
      });
      if (n.json?.error) throw n.json.error;
      return n.json;
    },
    mfa: {
      /**
       * Requires features{@link Features.manageMfa}.
       */
      getMfaSettings: async () => {
        let t;
        switch (this.features.version.software) {
          case d:
            t = await this.request("/api/v1/user").then(({ json: s }) => ({
              settings: {
                enabled: !!s?.two_factor_enabled_at,
                totp: !!s?.two_factor_enabled_at
              }
            }));
            break;
          default:
            t = (await this.request("/api/pleroma/accounts/mfa")).json;
        }
        return e.parse(e.object({
          settings: j({
            enabled: e.boolean(),
            totp: e.boolean()
          })
        }), t);
      },
      /**
       * Requires features{@link Features.manageMfa}.
       */
      getMfaBackupCodes: async () => {
        const t = await this.request("/api/pleroma/accounts/mfa/backup_codes");
        return e.parse(e.object({
          codes: e.array(e.string())
        }), t.json);
      },
      /**
       * Requires features{@link Features.manageMfa}.
       */
      getMfaSetup: async (t) => {
        let s;
        switch (this.features.version.software) {
          case d:
            s = await this.request("/api/v1/user/2fa/qruri").then(({ data: n }) => ({
              provisioning_uri: n,
              key: new URL(n).searchParams.get("secret")
            }));
            break;
          default:
            s = (await this.request(`/api/pleroma/accounts/mfa/setup/${t}`)).json;
        }
        return e.parse(e.object({
          key: e.fallback(e.string(), ""),
          provisioning_uri: e.string()
        }), s);
      },
      /**
       * Requires features{@link Features.manageMfa}.
       */
      confirmMfaSetup: async (t, s, n) => {
        let o;
        switch (this.features.version.software) {
          case d:
            o = await this.request("/api/v1/user/2fa/enable", { method: "POST", body: { code: s } });
            break;
          default:
            o = (await this.request(`/api/pleroma/accounts/mfa/confirm/${t}`, {
              method: "POST",
              body: { code: s, password: n }
            })).json;
        }
        if (o?.error) throw o.error;
        return o;
      },
      /**
       * Requires features{@link Features.manageMfa}.
       */
      disableMfa: async (t, s) => {
        let n;
        switch (this.features.version.software) {
          case d:
            n = await this.request("/api/v1/user/2fa/disable", {
              method: "POST",
              body: { password: s }
            });
            break;
          default:
            n = await this.request(`/api/pleroma/accounts/mfa/${t}`, {
              method: "DELETE",
              body: { password: s }
            });
        }
        if (n.json?.error) throw n.json.error;
        return n.json;
      }
    },
    /**
     * Imports your follows, for example from a Mastodon CSV file.
     *
     * Requires features{@link Features.importFollows}.
     * `overwrite` mode requires features{@link Features.importOverwrite}.
     * @see {@link https://docs.pleroma.social/backend/development/API/pleroma_api/#apipleromafollow_import}
     */
    importFollows: async (t, s) => {
      let n;
      switch (this.features.version.software) {
        case d:
          n = await this.request("/api/v1/import", {
            method: "POST",
            body: { data: t, type: "following", mode: s },
            contentType: ""
          });
          break;
        case y:
          n = await this.request("/api/v1/settings/import_follows", {
            method: "POST",
            body: { follows_csv: typeof t == "string" ? t : await t.text() }
          });
          break;
        default:
          n = await this.request("/api/pleroma/follow_import", {
            method: "POST",
            body: { list: t },
            contentType: ""
          });
      }
      return n.json;
    },
    /**
    * Move followers from remote alias. (experimental?)
    *
    * Requires features{@link Features.importFollowers}.
    */
    importFollowers: async (t, s) => (await this.request("/api/v1/settings/import_followers", {
      method: "POST",
      body: { from_actor_id: s, followers_csv: typeof t == "string" ? t : await t.text() }
    })).json,
    /**
     * Imports your blocks.
     *
     * Requires features{@link Features.importBlocks}.
     * `overwrite` mode requires features{@link Features.importOverwrite}.
     * @see {@link https://docs.pleroma.social/backend/development/API/pleroma_api/#apipleromablocks_import}
     */
    importBlocks: async (t, s) => {
      let n;
      switch (this.features.version.software) {
        case d:
          n = await this.request("/api/v1/import", {
            method: "POST",
            body: { data: t, type: "blocks", mode: s },
            contentType: ""
          });
          break;
        default:
          n = await this.request("/api/pleroma/blocks_import", {
            method: "POST",
            body: { list: t },
            contentType: ""
          });
      }
      return n.json;
    },
    /**
     * Imports your mutes.
     *
     * Requires features{@link Features.importMutes}.
     * `overwrite` mode requires features{@link Features.importOverwrite}.
     * @see {@link https://docs.pleroma.social/backend/development/API/pleroma_api/#apipleromamutes_import}
     */
    importMutes: async (t, s) => {
      let n;
      switch (this.features.version.software) {
        case d:
          n = await this.request("/api/v1/import", {
            method: "POST",
            body: { data: t, type: "blocks", mode: s },
            contentType: ""
          });
          break;
        default:
          n = await this.request("/api/pleroma/mutes_import", {
            method: "POST",
            body: { list: t },
            contentType: ""
          });
      }
      return n.json;
    },
    /**
     * Export followers to CSV file
     *
     * Requires features{@link Features.exportFollowers}.
     */
    exportFollowers: async () => {
      let t;
      switch (this.features.version.software) {
        case d:
          t = await this.request("/api/v1/exports/followers.csv", {
            method: "GET"
          });
          break;
        default:
          t = await this.request("/api/v1/settings/export_followers", {
            method: "GET"
          });
      }
      return t.data;
    },
    /**
     * Export follows to CSV file
     *
     * Requires features{@link Features.exportFollows}.
     */
    exportFollows: async () => {
      let t;
      switch (this.features.version.software) {
        case d:
          t = await this.request("/api/v1/exports/following.csv", {
            method: "GET"
          });
          break;
        default:
          t = await this.request("/api/v1/settings/export_follows", {
            method: "GET"
          });
      }
      return t.data;
    },
    /**
      * Export lists to CSV file
      *
      * Requires features{@link Features.exportLists}.
      */
    exportLists: async () => (await this.request("/api/v1/exports/lists.csv", {
      method: "GET"
    })).data,
    /**
      * Export blocks to CSV file
      *
      * Requires features{@link Features.exportBlocks}.
      */
    exportBlocks: async () => (await this.request("/api/v1/exports/blocks.csv", {
      method: "GET"
    })).data,
    /**
      * Export mutes to CSV file
      *
      * Requires features{@link Features.exportMutes}.
      */
    exportMutes: async () => (await this.request("/api/v1/exports/mutes.csv", {
      method: "GET"
    })).data,
    /**
     * Updates user notification settings
     *
     * Requires features{@link Features.muteStrangers}.
     * @see {@link https://docs.pleroma.social/backend/development/API/pleroma_api/#apipleromanotification_settings}
     */
    updateNotificationSettings: async (t) => {
      const s = await this.request("/api/pleroma/notification_settings", { method: "PUT", body: t });
      if (s.json?.error) throw s.json.error;
      return e.parse(e.object({ status: e.string() }), s.json);
    },
    /**
     * Get default interaction policies for new statuses created by you.
     *
     * Requires features{@link Features.interactionRequests}.
     * @see {@link https://docs.gotosocial.org/en/latest/api/swagger/}
     */
    getInteractionPolicies: async () => {
      const t = await this.request("/api/v1/interaction_policies/defaults");
      return e.parse(yt, t.json);
    },
    /**
     * Update default interaction policies per visibility level for new statuses created by you.
     *
     * Requires features{@link Features.interactionRequests}.
     * @see {@link https://docs.gotosocial.org/en/latest/api/swagger/}
     */
    updateInteractionPolicies: async (t) => {
      const s = await this.request("/api/v1/interaction_policies/defaults", { method: "PATCH", body: t });
      return e.parse(yt, s.json);
    },
    /**
     * List frontend setting profiles
     *
     * Requires features{@link Features.preferredFrontends}.
     */
    getAvailableFrontends: async () => {
      const t = await this.request("/api/v1/akkoma/preferred_frontend/available");
      return e.parse(e.array(e.string()), t.json);
    },
    /**
     * Update preferred frontend setting
     *
     * Store preferred frontend in cookies
     *
     * Requires features{@link Features.preferredFrontends}.
     */
    setPreferredFrontend: async (t) => {
      const s = await this.request("/api/v1/akkoma/preferred_frontend", { method: "PUT", body: { frontend_name: t } });
      return e.parse(e.object({ frontend_name: e.string() }), s.json);
    },
    authorizeIceshrimp: async () => (await this.request("/api/v1/accounts/authorize_iceshrimp", { method: "POST" })).json
  };
  filtering = {
    /**
     * Block account
     * Block the given account. Clients should filter statuses from this account if received (e.g. due to a boost in the Home timeline)
     * @see {@link https://docs.joinmastodon.org/methods/accounts/#block}
     * `duration` parameter requires features{@link Features.blocksDuration}.
     */
    blockAccount: async (t, s) => {
      const n = await this.request(`/api/v1/accounts/${t}/block`, { method: "POST", body: s });
      return e.parse(F, n.json);
    },
    /**
     * Unblock account
     * Unblock the given account.
     * @see {@link https://docs.joinmastodon.org/methods/accounts/#unblock}
     */
    unblockAccount: async (t) => {
      const s = await this.request(`/api/v1/accounts/${t}/unblock`, { method: "POST" });
      return e.parse(F, s.json);
    },
    /**
     * Mute account
     * Mute the given account. Clients should filter statuses and notifications from this account, if received (e.g. due to a boost in the Home timeline).
     *
     * Requires features{@link Features.mutes}.
     * @see {@link https://docs.joinmastodon.org/methods/accounts/#mute}
     */
    muteAccount: async (t, s) => {
      const n = await this.request(`/api/v1/accounts/${t}/mute`, { method: "POST", body: s });
      return e.parse(F, n.json);
    },
    /**
     * Unmute account
     * Unmute the given account.
     *
     * Requires features{@link Features.mutes}.
     * @see {@link https://docs.joinmastodon.org/methods/accounts/#unmute}
     */
    unmuteAccount: async (t) => {
      const s = await this.request(`/api/v1/accounts/${t}/unmute`, { method: "POST" });
      return e.parse(F, s.json);
    },
    /**
     * View muted accounts
     * Accounts the user has muted.
     *
     * Requires features{@link Features.mutes}.
     * @see {@link https://docs.joinmastodon.org/methods/mutes/#get}
     */
    getMutes: async (t) => this.#e("/api/v1/mutes", { params: t }, As),
    /**
     * View blocked users
     * @see {@link https://docs.joinmastodon.org/methods/blocks/#get}
     */
    getBlocks: async (t) => this.#e("/api/v1/blocks", { params: t }, w),
    /**
     * Get domain blocks
     * View domains the user has blocked.
     * @see {@link https://docs.joinmastodon.org/methods/domain_blocks/#get}
     */
    getDomainBlocks: async (t) => this.#e("/api/v1/domain_blocks", { params: t }, e.string()),
    /**
     * Block a domain
     * Block a domain to:
     * - hide all public posts from it
     * - hide all notifications from it
     * - remove all followers from it
     * - prevent following new users from it (but does not remove existing follows)
     * @see {@link https://docs.joinmastodon.org/methods/domain_blocks/#block}
     */
    blockDomain: async (t) => (await this.request("/api/v1/domain_blocks", { method: "POST", body: { domain: t } })).json,
    /**
     * Unblock a domain
     * Remove a domain block, if it exists in the user’s array of blocked domains.
     * @see {@link https://docs.joinmastodon.org/methods/domain_blocks/#unblock}
     */
    unblockDomain: async (t) => (await this.request("/api/v1/domain_blocks", {
      method: "DELETE",
      body: { domain: t }
    })).json,
    /**
     * View all filters
     * Obtain a list of all filter groups for the current user.
     *
     * Requires features{@link Features.filters} or features{@link Features['filtersV2']}.
     * @see {@link https://docs.joinmastodon.org/methods/filters/#get}
     */
    getFilters: async () => {
      const t = await this.request(this.features.filtersV2 ? "/api/v2/filters" : "/api/v1/filters");
      return e.parse(r(Se), t.json);
    },
    /**
     * View a specific filter
     * Obtain a single filter group owned by the current user.
     *
     * Requires features{@link Features.filters} or features{@link Features['filtersV2']}.
     * @see {@link https://docs.joinmastodon.org/methods/filters/#get-one}
     */
    getFilter: async (t) => {
      const s = await this.request(
        this.features.filtersV2 ? `/api/v2/filters/${t}` : `/api/v1/filters/${t}`
      );
      return e.parse(Se, s.json);
    },
    /**
     * Create a filter
     * Create a filter group with the given parameters.
     *
     * Requires features{@link Features.filters} or features{@link Features['filtersV2']}.
     * @see {@link https://docs.joinmastodon.org/methods/filters/#create}
     */
    createFilter: async (t) => {
      const { filtersV2: s } = this.features, n = await this.request(
        s ? "/api/v2/filters" : "/api/v1/filters",
        {
          method: "POST",
          body: s ? t : {
            phrase: t.keywords_attributes[0]?.keyword,
            context: t.context,
            irreversible: t.filter_action === "hide",
            whole_word: t.keywords_attributes[0]?.whole_word,
            expires_in: t.expires_in
          }
        }
      );
      return e.parse(Se, n.json);
    },
    /**
     * Update a filter
     * Update a filter group with the given parameters.
     *
     * Requires features{@link Features.filters} or features{@link Features['filtersV2']}.
     * @see {@link https://docs.joinmastodon.org/methods/filters/#update}
     */
    updateFilter: async (t, s) => {
      const { filtersV2: n } = this.features, o = await this.request(
        n ? `/api/v2/filters/${t}` : `/api/v1/filters/${t}`,
        {
          method: "PUT",
          body: n ? s : {
            phrase: s.keywords_attributes?.[0]?.keyword,
            context: s.context,
            irreversible: s.filter_action === "hide",
            whole_word: s.keywords_attributes?.[0]?.whole_word,
            expires_in: s.expires_in
          }
        }
      );
      return e.parse(Se, o.json);
    },
    /**
     * Delete a filter
     * Delete a filter group with the given id.
     *
     * Requires features{@link Features.filters} or features{@link Features['filtersV2']}.
     * @see {@link https://docs.joinmastodon.org/methods/filters/#delete}
     */
    deleteFilter: async (t) => (await this.request(
      this.features.filtersV2 ? `/api/v2/filters/${t}` : `/api/v1/filters/${t}`,
      { method: "DELETE" }
    )).json,
    /**
     * View keywords added to a filter
     * List all keywords attached to the current filter group.
     *
     * Requires features{@link Features['filtersV2']}.
     * @see {@link https://docs.joinmastodon.org/methods/filters/#keywords-get}
     */
    getFilterKeywords: async (t) => {
      const s = await this.request(`/api/v2/filters/${t}/keywords`);
      return e.parse(r(fe), s.json);
    },
    /**
     * Add a keyword to a filter
     * Add the given keyword to the specified filter group
     *
     * Requires features{@link Features['filtersV2']}.
     * @see {@link https://docs.joinmastodon.org/methods/filters/#keywords-create}
     */
    addFilterKeyword: async (t, s, n) => {
      const o = await this.request(`/api/v2/filters/${t}/keywords`, {
        method: "POST",
        body: { keyword: s, whole_word: n }
      });
      return e.parse(fe, o.json);
    },
    /**
     * View a single keyword
     * Get one filter keyword by the given id.
     *
     * Requires features{@link Features['filtersV2']}.
     * @see {@link https://docs.joinmastodon.org/methods/filters/#keywords-get-one}
     */
    getFilterKeyword: async (t) => {
      const s = await this.request(`/api/v2/filters/keywords/${t}`);
      return e.parse(fe, s.json);
    },
    /**
     * Edit a keyword within a filter
     * Update the given filter keyword.
     *
     * Requires features{@link Features['filtersV2']}.
     * @see {@link https://docs.joinmastodon.org/methods/filters/#keywords-update}
     */
    updateFilterKeyword: async (t, s, n) => {
      const o = await this.request(`/api/v2/filters/keywords/${t}`, {
        method: "PUT",
        body: { keyword: s, whole_word: n }
      });
      return e.parse(fe, o.json);
    },
    /**
     * Remove keywords from a filter
     * Deletes the given filter keyword.
     *
     * Requires features{@link Features['filtersV2']}.
     * @see {@link https://docs.joinmastodon.org/methods/filters/#keywords-delete}
     */
    deleteFilterKeyword: async (t) => (await this.request(`/api/v2/filters/keywords/${t}`, { method: "DELETE" })).json,
    /**
     * View all status filters
     * Obtain a list of all status filters within this filter group.
     *
     * Requires features{@link Features['filtersV2']}.
     * @see {@link https://docs.joinmastodon.org/methods/filters/#statuses-get}
     */
    getFilterStatuses: async (t) => {
      const s = await this.request(`/api/v2/filters/${t}/statuses`);
      return e.parse(r(Ne), s.json);
    },
    /**
     * Add a status to a filter group
     * Add a status filter to the current filter group.
     *
     * Requires features{@link Features['filtersV2']}.
     * @see {@link https://docs.joinmastodon.org/methods/filters/#statuses-add}
     */
    addFilterStatus: async (t, s) => {
      const n = await this.request(`/api/v2/filters/${t}/statuses`, {
        method: "POST",
        body: { status_id: s }
      });
      return e.parse(Ne, n.json);
    },
    /**
     * View a single status filter
     * Obtain a single status filter.
     *
     * Requires features{@link Features['filtersV2']}.
     * @see {@link https://docs.joinmastodon.org/methods/filters/#statuses-get-one}
     */
    getFilterStatus: async (t) => {
      const s = await this.request(`/api/v2/filters/statuses/${t}`);
      return e.parse(Ne, s.json);
    },
    /**
     * Remove a status from a filter group
     * Remove a status filter from the current filter group.
     *
     * Requires features{@link Features['filtersV2']}.
     * @see {@link https://docs.joinmastodon.org/methods/filters/#statuses-remove}
     */
    deleteFilterStatus: async (t) => (await this.request(`/api/v2/filters/statuses/${t}`, { method: "DELETE" })).json
  };
  statuses = {
    /**
     * Post a new status
     * Publish a status with the given parameters.
     * @see {@link https://docs.joinmastodon.org/methods/statuses/#create}
     */
    createStatus: async (t) => {
      const s = t;
      t.content_type === "text/markdown" && this.#s.api_versions["kmyblue_markdown.fedibird.pl-api"] >= 1 && (s.markdown = !0), t.visibility?.startsWith("api/v1/bookmark_categories") && (s.circle_id = t.visibility.slice(7), s.visibility = "circle"), t.quote_id && this.#s.api_versions.mastodon >= 7 ? t.quoted_status_id = t.quote_id : t.quoted_status_id && (this.#s.api_versions.mastodon || 0) < 7 && (t.quote_id = t.quoted_status_id);
      const n = t.preview && this.features.version.software === y ? "/api/v1/statuses/preview" : "/api/v1/statuses", o = await this.request(n, {
        method: "POST",
        body: s
      });
      return o.json?.scheduled_at ? e.parse(qe, o.json) : e.parse(f, o.json);
    },
    /**
     * Requires features{@link Features.createStatusPreview}.
     */
    previewStatus: async (t) => {
      const s = this.features.version.software === p || this.features.version.software === m ? "/api/v1/statuses" : "/api/v1/statuses/preview";
      (this.features.version.software === p || this.features.version.software === m) && (t.preview = !0);
      const n = await this.request(s, {
        method: "POST",
        body: t
      });
      return e.parse(e.partial(Qs), n.json);
    },
    /**
     * View a single status
     * Obtain information about a status.
     * @see {@link https://docs.joinmastodon.org/methods/statuses/#get}
     */
    getStatus: async (t, s) => {
      const n = await this.request(`/api/v1/statuses/${t}`, { params: s });
      return e.parse(f, n.json);
    },
    /**
     * View multiple statuses
     * Obtain information about multiple statuses.
     *
     * Requires features{@link Features.getStatuses}.
     * @see {@link https://docs.joinmastodon.org/methods/statuses/#index}
    */
    getStatuses: async (t, s) => {
      const n = await this.request("/api/v1/statuses", { params: { ...s, id: t } });
      return e.parse(r(f), n.json);
    },
    /**
     * Delete a status
     * Delete one of your own statuses.
     *
     * `delete_media` parameter requires features{@link Features.deleteMedia}.
     * @see {@link https://docs.joinmastodon.org/methods/statuses/#delete}
     */
    deleteStatus: async (t, s) => {
      const n = await this.request(`/api/v1/statuses/${t}`, { method: "DELETE", params: { delete_media: s } });
      return e.parse(Ye, n.json);
    },
    /**
     * Get parent and child statuses in context
     * View statuses above and below this status in the thread.
     * @see {@link https://docs.joinmastodon.org/methods/statuses/#context}
     */
    getContext: async (t, s) => {
      const n = await this.request(`/api/v1/statuses/${t}/context`, { params: s });
      return { asyncRefreshHeader: Zn(n), ...e.parse(oa, n.json) };
    },
    /**
     * Translate a status
     * Translate the status content into some language.
     * @see {@link https://docs.joinmastodon.org/methods/statuses/#translate}
     */
    translateStatus: async (t, s) => {
      let n;
      return this.features.version.software === m ? n = await this.request(`/api/v1/statuses/${t}/translations/${s}`) : n = await this.request(`/api/v1/statuses/${t}/translate`, { method: "POST", body: { lang: s } }), e.parse(nt, n.json);
    },
    /**
     * Translate multiple statuses into given language.
     *
     * Requires features{@link Features.lazyTranslations}.
     */
    translateStatuses: async (t, s) => {
      const n = await this.request("/api/v1/pl/statuses/translate", { method: "POST", body: { ids: t, lang: s } });
      return e.parse(r(nt), n.json);
    },
    /**
     * See who boosted a status
     * View who boosted a given status.
     * @see {@link https://docs.joinmastodon.org/methods/statuses/#reblogged_by}
     */
    getRebloggedBy: async (t, s) => this.#e(`/api/v1/statuses/${t}/reblogged_by`, { params: s }, w),
    /**
     * See who favourited a status
     * View who favourited a given status.
     * @see {@link https://docs.joinmastodon.org/methods/statuses/#favourited_by}
     */
    getFavouritedBy: async (t, s) => this.#e(`/api/v1/statuses/${t}/favourited_by`, { params: s }, w),
    /**
     * Favourite a status
     * Add a status to your favourites list.
     * @see {@link https://docs.joinmastodon.org/methods/statuses/#favourite}
     */
    favouriteStatus: async (t) => {
      const s = await this.request(`/api/v1/statuses/${t}/favourite`, { method: "POST" });
      return e.parse(f, s.json);
    },
    /**
     * Undo favourite of a status
     * Remove a status from your favourites list.
     * @see {@link https://docs.joinmastodon.org/methods/statuses/#unfavourite}
     */
    unfavouriteStatus: async (t) => {
      const s = await this.request(`/api/v1/statuses/${t}/unfavourite`, { method: "POST" });
      return e.parse(f, s.json);
    },
    /**
     * Boost a status
     * Reshare a status on your own profile.
     * @see {@link https://docs.joinmastodon.org/methods/statuses/#reblog}
     *
     * Specifying reblog visibility requires features{@link Features.reblogVisibility}.
     */
    reblogStatus: async (t, s) => {
      const n = await this.request(`/api/v1/statuses/${t}/reblog`, { method: "POST", body: { visibility: s } });
      return e.parse(f, n.json);
    },
    /**
     * Undo boost of a status
     * Undo a reshare of a status.
     * @see {@link https://docs.joinmastodon.org/methods/statuses/#unreblog}
     */
    unreblogStatus: async (t) => {
      const s = await this.request(`/api/v1/statuses/${t}/unreblog`, { method: "POST" });
      return e.parse(f, s.json);
    },
    /**
     * Bookmark a status
     * Privately bookmark a status.
     * @see {@link https://docs.joinmastodon.org/methods/statuses/#bookmark}
     */
    bookmarkStatus: async (t, s) => {
      const n = await this.request(`/api/v1/statuses/${t}/bookmark`, { method: "POST", body: { folder_id: s } });
      return s && this.features.bookmarkFoldersMultiple && await this.request(`/api/v1/bookmark_categories/${s}/statuses`, { method: "POST", params: { status_ids: [t] } }), e.parse(f, n.json);
    },
    /**
     * Undo bookmark of a status
     * Remove a status from your private bookmarks.
     * @see {@link https://docs.joinmastodon.org/methods/statuses/#unbookmark}
     */
    unbookmarkStatus: async (t) => {
      const s = await this.request(`/api/v1/statuses/${t}/unbookmark`, { method: "POST" });
      return e.parse(f, s.json);
    },
    /**
     * Revoke a quote post
     * Revoke quote authorization of status `quoting_status_id`, detaching status `id`.
     * @see {@link https://docs.joinmastodon.org/methods/statuses/#revoke_quote}
     */
    revokeQuote: async (t, s) => {
      const n = await this.request(`/api/v1/statuses/${t}/quotes/${s}/revoke`, { method: "POST" });
      return e.parse(f, n.json);
    },
    /**
     * Mute a conversation
     * Do not receive notifications for the thread that this status is part of. Must be a thread in which you are a participant.
     * @see {@link https://docs.joinmastodon.org/methods/statuses/#mute}
     */
    muteStatus: async (t) => {
      const s = await this.request(`/api/v1/statuses/${t}/mute`, { method: "POST" });
      return e.parse(f, s.json);
    },
    /**
     * Unmute a conversation
     * Start receiving notifications again for the thread that this status is part of.
     * @see {@link https://docs.joinmastodon.org/methods/statuses/#unmute}
     */
    unmuteStatus: async (t) => {
      const s = await this.request(`/api/v1/statuses/${t}/unmute`, { method: "POST" });
      return e.parse(f, s.json);
    },
    /**
     * Pin status to profile
     * Feature one of your own public statuses at the top of your profile.
     * @see {@link https://docs.joinmastodon.org/methods/statuses/#pin}
     */
    pinStatus: async (t) => {
      const s = await this.request(`/api/v1/statuses/${t}/pin`, { method: "POST" });
      return e.parse(f, s.json);
    },
    /**
     * Unpin status from profile
     * Unfeature a status from the top of your profile.
     * @see {@link https://docs.joinmastodon.org/methods/statuses/#unpin}
     */
    unpinStatus: async (t) => {
      const s = await this.request(`/api/v1/statuses/${t}/unpin`, { method: "POST" });
      return e.parse(f, s.json);
    },
    /**
     * Edit a status
     * Edit a given status to change its text, sensitivity, media attachments, or poll. Note that editing a poll’s options will reset the votes.
     * @see {@link https://docs.joinmastodon.org/methods/statuses/#unpin}
     */
    editStatus: async (t, s) => {
      const n = s;
      s.content_type === "text/markdown" && this.#s.api_versions["kmyblue_markdown.fedibird.pl-api"] >= 1 && (n.markdown = !0);
      const o = await this.request(`/api/v1/statuses/${t}`, { method: "PUT", body: s });
      return e.parse(f, o.json);
    },
    /**
     * Edit a status' interaction policies
     * Edit a given status to change its interaction policies. Currently, this means changing its quote approval policy.
     * @see {@link https://docs.joinmastodon.org/methods/statuses/#edit_interaction_policy}
     */
    editInteractionPolicy: async (t, s) => {
      const n = await this.request(`/api/v1/statuses/${t}`, { method: "PUT", body: s });
      return e.parse(f, n.json);
    },
    /**
     * View edit history of a status
     * Get all known versions of a status, including the initial and current states.
     * @see {@link https://docs.joinmastodon.org/methods/statuses/#history}
     */
    getStatusHistory: async (t) => {
      const s = await this.request(`/api/v1/statuses/${t}/history`);
      return e.parse(r(Ya), s.json);
    },
    /**
     * View status source
     * Obtain the source properties for a status so that it can be edited.
     * @see {@link https://docs.joinmastodon.org/methods/statuses/#source}
     */
    getStatusSource: async (t) => {
      const s = await this.request(`/api/v1/statuses/${t}/source`);
      return e.parse(Ye, s.json);
    },
    /**
     * Get an object of emoji to account mappings with accounts that reacted to the post
     *
     * Requires features{@link Features.emojiReactsList}.
     * @see {@link https://docs.pleroma.social/backend/development/API/pleroma_api/#get-apiv1pleromastatusesidreactions}
     * @see {@link https://docs.pleroma.social/backend/development/API/pleroma_api/#get-apiv1pleromastatusesidreactionsemoji}
     */
    getStatusReactions: async (t, s) => {
      const n = this.#s.api_versions;
      let o;
      return n["emoji_reactions.pleroma.pl-api"] >= 1 || this.features.version.software === E ? o = await this.request(`/api/v1/pleroma/statuses/${t}/reactions${s ? `/${s}` : ""}`) : (n["emoji_reaction.fedibird.pl-api"] >= 1 ? o = await this.request(`/api/v1/statuses/${t}/emoji_reactioned_by`) : o = await this.request(`/api/v1/statuses/${t}/reactions`, { params: { emoji: s } }), o.json = o.json?.reduce((b, g) => {
        if (s && g.name !== s) return b;
        const S = b.find((i) => i.name === g.name);
        return S ? (S.accounts.push(g.account), S.account_ids.push(g.account.id), S.count += 1) : b.push({ count: 1, accounts: [g.account], account_ids: [g.account.id], ...g }), b;
      }, [])), e.parse(r(mt), o?.json || []);
    },
    /**
     * React to a post with a unicode emoji
     *
     * Requires features{@link Features.emojiReacts}.
     * Using custom emojis requires features{@link Features.customEmojiReacts}.
     * @see {@link https://docs.pleroma.social/backend/development/API/pleroma_api/#put-apiv1pleromastatusesidreactionsemoji}
     */
    createStatusReaction: async (t, s) => {
      const n = this.#s.api_versions;
      let o;
      return n["emoji_reactions.pleroma.pl-api"] >= 1 || this.features.version.software === y ? o = await this.request(`/api/v1/pleroma/statuses/${t}/reactions/${encodeURIComponent(s)}`, { method: "PUT" }) : o = await this.request(`/api/v1/statuses/${t}/react/${encodeURIComponent(s)}`, { method: "POST" }), e.parse(f, o.json);
    },
    /**
     * Remove a reaction to a post with a unicode emoji
     *
     * Requires features{@link Features.emojiReacts}.
     * @see {@link https://docs.pleroma.social/backend/development/API/pleroma_api/#delete-apiv1pleromastatusesidreactionsemoji}
     */
    deleteStatusReaction: async (t, s) => {
      const n = this.#s.api_versions;
      let o;
      return n["emoji_reactions.pleroma.pl-api"] >= 1 || this.features.version.software === y ? o = await this.request(`/api/v1/pleroma/statuses/${t}/reactions/${s}`, { method: "DELETE" }) : o = await this.request(`/api/v1/statuses/${t}/unreact/${encodeURIComponent(s)}`, { method: "POST" }), e.parse(f, o.json);
    },
    /**
     * View quotes for a given status
     *
     * Requires features{@link Features.quotePosts}.
     * @see {@link https://docs.joinmastodon.org/methods/statuses/#quotes}
     */
    getStatusQuotes: async (t, s) => this.#e(
      this.#s.api_versions.mastodon >= 7 ? `/api/v1/statuses/${t}/quotes` : `/api/v1/pleroma/statuses/${t}/quotes`,
      { params: s },
      f
    ),
    /**
     * Returns the list of accounts that have disliked the status as known by the current server
     *
     * Requires features{@link Features.statusDislikes}.
     * @see {@link https://github.com/friendica/friendica/blob/2024.06-rc/doc/API-Friendica.md#get-apifriendicastatusesiddisliked_by}
     */
    getDislikedBy: async (t) => this.#e(`/api/v1/statuses/${t}/disliked_by`, {}, w),
    /**
     * Marks the given status as disliked by this user
     * @see {@link https://github.com/friendica/friendica/blob/2024.06-rc/doc/API-Friendica.md#post-apifriendicastatusesiddislike}
     */
    dislikeStatus: async (t) => {
      const s = await this.request(`/api/friendica/statuses/${t}/dislike`, { method: "POST" });
      return e.parse(f, s.json);
    },
    /**
     * Removes the dislike mark (if it exists) on this status for this user
     * @see {@link https://github.com/friendica/friendica/blob/2024.06-rc/doc/API-Friendica.md#post-apifriendicastatusesidundislike}
     */
    undislikeStatus: async (t) => {
      const s = await this.request(`/api/friendica/statuses/${t}/undislike`, { method: "POST" });
      return e.parse(f, s.json);
    },
    getStatusReferences: async (t, s) => this.#e(`/api/v1/statuses/${t}/referred_by`, { params: s }, f),
    getStatusMentionedUsers: async (t, s) => this.#e(`/api/v1/statuses/${t}/mentioned_by`, { params: s }, w),
    /**
     * Load conversation from a remote server.
     *
     * Requires features{@link Features.loadConversation}.
     */
    loadConversation: async (t) => (await this.request(`/api/v1/statuses/${t}/load_conversation`, { method: "POST" })).json,
    /**
     * Requires features{@link Features.bookmarkFoldersMultiple}.
     */
    getStatusBookmarkFolders: async (t) => {
      const s = await this.request(`/api/v1/statuses/${t}/bookmark_categories`, { method: "GET" });
      return e.parse(r(pe), s.json);
    }
  };
  media = {
    /**
     * Upload media as an attachment
     * Creates a media attachment to be used with a new status. The full sized media will be processed asynchronously in the background for large uploads.
     * @see {@link https://docs.joinmastodon.org/methods/media/#v2}
     */
    uploadMedia: async (t, s) => {
      const n = await this.request(
        this.features.mediaV2 ? "/api/v2/media" : "/api/v1/media",
        { ...s, method: "POST", body: t, contentType: "" }
      );
      return e.parse(re, n.json);
    },
    /**
     * Get media attachment
     * Get a media attachment, before it is attached to a status and posted, but after it is accepted for processing. Use this method to check that the full-sized media has finished processing.
     * @see {@link https://docs.joinmastodon.org/methods/media/#get}
     */
    getMedia: async (t) => {
      const s = await this.request(`/api/v1/media/${t}`);
      return e.parse(re, s.json);
    },
    /**
     * Update media attachment
     * Update a MediaAttachment’s parameters, before it is attached to a status and posted.
     * @see {@link https://docs.joinmastodon.org/methods/media/#update}
     */
    updateMedia: async (t, s) => {
      const n = await this.request(`/api/v1/media/${t}`, {
        method: "PUT",
        body: s,
        contentType: s.thumbnail ? "" : void 0
      });
      return e.parse(re, n.json);
    },
    /**
     * Update media attachment
     * Update a MediaAttachment’s parameters, before it is attached to a status and posted.
     *
     * Requires features{@link Features.deleteMedia}.
     * @see {@link https://docs.joinmastodon.org/methods/media/delete}
     */
    deleteMedia: async (t) => (await this.request(`/api/v1/media/${t}`, {
      method: "DELETE"
    })).json
  };
  polls = {
    /**
     * View a poll
     * View a poll attached to a status.
     * @see {@link https://docs.joinmastodon.org/methods/polls/#get}
     */
    getPoll: async (t) => {
      const s = await this.request(`/api/v1/polls/${t}`);
      return e.parse(st, s.json);
    },
    /**
     * Vote on a poll
     * Vote on a poll attached to a status.
     * @see {@link https://docs.joinmastodon.org/methods/polls/#vote}
     */
    vote: async (t, s) => {
      const n = await this.request(`/api/v1/polls/${t}/votes`, { method: "POST", body: { choices: s } });
      return e.parse(st, n.json);
    }
  };
  scheduledStatuses = {
    /**
     * View scheduled statuses
     * @see {@link https://docs.joinmastodon.org/methods/scheduled_statuses/#get}
     */
    getScheduledStatuses: async (t) => this.#e("/api/v1/scheduled_statuses", { params: t }, qe),
    /**
     * View a single scheduled status
     * @see {@link https://docs.joinmastodon.org/methods/scheduled_statuses/#get-one}
     */
    getScheduledStatus: async (t) => {
      const s = await this.request(`/api/v1/scheduled_statuses/${t}`);
      return e.parse(qe, s.json);
    },
    /**
     * Update a scheduled status’s publishing date
     * @see {@link https://docs.joinmastodon.org/methods/scheduled_statuses/#update}
     */
    updateScheduledStatus: async (t, s) => {
      const n = await this.request(`/api/v1/scheduled_statuses/${t}`, {
        method: "PUT",
        body: { scheduled_at: s }
      });
      return e.parse(qe, n.json);
    },
    /**
     * Cancel a scheduled status
     * @see {@link https://docs.joinmastodon.org/methods/scheduled_statuses/#cancel}
     */
    cancelScheduledStatus: async (t) => (await this.request(`/api/v1/scheduled_statuses/${t}`, { method: "DELETE" })).json
  };
  timelines = {
    /**
     * View public timeline
     * View public statuses.
     * @see {@link https://docs.joinmastodon.org/methods/timelines/#public}
     */
    publicTimeline: (t) => this.#e("/api/v1/timelines/public", { params: t }, f),
    /**
     * View hashtag timeline
     * View public statuses containing the given hashtag.
     * @see {@link https://docs.joinmastodon.org/methods/timelines/#tag}
     */
    hashtagTimeline: (t, s) => this.#e(`/api/v1/timelines/tag/${t}`, { params: s }, f),
    /**
     * View home timeline
     * View statuses from followed users and hashtags.
     * @see {@link https://docs.joinmastodon.org/methods/timelines/#home}
     */
    homeTimeline: (t) => this.#e("/api/v1/timelines/home", { params: t }, f),
    /**
     * View link timeline
     * View public statuses containing a link to the specified currently-trending article. This only lists statuses from people who have opted in to discoverability features.
     * @see {@link https://docs.joinmastodon.org/methods/timelines/#link}
     */
    linkTimeline: (t, s) => this.#e("/api/v1/timelines/link", { params: { ...s, url: t } }, f),
    /**
     * View list timeline
     * View statuses in the given list timeline.
     * @see {@link https://docs.joinmastodon.org/methods/timelines/#list}
     */
    listTimeline: (t, s) => this.#e(`/api/v1/timelines/list/${t}`, { params: s }, f),
    /**
     * View all conversations
     * @see {@link https://docs.joinmastodon.org/methods/conversations/#get}
     */
    getConversations: (t) => this.#e("/api/v1/conversations", { params: t }, ot),
    /**
     * Remove a conversation
     * Removes a conversation from your list of conversations.
     * @see {@link https://docs.joinmastodon.org/methods/conversations/#delete}
     */
    deleteConversation: async (t) => (await this.request(`/api/v1/conversations/${t}`, { method: "DELETE" })).json,
    /**
     * Mark a conversation as read
     * @see {@link https://docs.joinmastodon.org/methods/conversations/#read}
     */
    markConversationRead: async (t) => {
      const s = await this.request(`/api/v1/conversations/${t}/read`, { method: "POST" });
      return e.parse(ot, s.json);
    },
    /**
     * Get saved timeline positions
     * Get current positions in timelines.
     * @see {@link https://docs.joinmastodon.org/methods/markers/#get}
     */
    getMarkers: async (t) => {
      const s = await this.request("/api/v1/markers", { params: { timeline: t } });
      return e.parse(rt, s.json);
    },
    /**
     * Save your position in a timeline
     * Save current position in timeline.
     * @see {@link https://docs.joinmastodon.org/methods/markers/#create}
     */
    saveMarkers: async (t) => {
      const s = await this.request("/api/v1/markers", { method: "POST", body: t });
      return e.parse(rt, s.json);
    },
    /**
     * Requires features{@link Features.groups}.
     */
    groupTimeline: async (t, s) => this.#e(
      this.features.version.software === q ? `/api/v0/groups/${t}/feed` : `/api/v1/timelines/group/${t}`,
      { params: s },
      f
    ),
    /**
     * Requires features{@link Features.bubbleTimeline}.
     */
    bubbleTimeline: async (t) => this.#e("/api/v1/timelines/bubble", { params: t }, f),
    /**
     * View antenna timeline
     * Requires features{@link Features.antennas}.
     */
    antennaTimeline: (t, s) => this.#e(`/api/v1/timelines/antenna/${t}`, { params: s }, f),
    /**
     * Requires features{@link Features.wrenchedTimeline}.
     */
    wrenchedTimeline: async (t) => this.#e("/api/v1/pleroma/timelines/wrenched", { params: t }, f)
  };
  lists = {
    /**
     * View your lists
     * Fetch all lists that the user owns.
     * @see {@link https://docs.joinmastodon.org/methods/lists/#get}
     */
    getLists: async () => {
      const t = await this.request("/api/v1/lists");
      return e.parse(r(Q), t.json);
    },
    /**
     * Show a single list
     * Fetch the list with the given ID. Used for verifying the title of a list, and which replies to show within that list.
     * @see {@link https://docs.joinmastodon.org/methods/lists/#get-one}
     */
    getList: async (t) => {
      const s = await this.request(`/api/v1/lists/${t}`);
      return e.parse(Q, s.json);
    },
    /**
     * Create a list
     * Create a new list.
     * @see {@link https://docs.joinmastodon.org/methods/lists/#create}
     */
    createList: async (t) => {
      const s = await this.request("/api/v1/lists", { method: "POST", body: t });
      return e.parse(Q, s.json);
    },
    /**
     * Update a list
     * Change the title of a list, or which replies to show.
     * @see {@link https://docs.joinmastodon.org/methods/lists/#update}
     */
    updateList: async (t, s) => {
      const n = await this.request(`/api/v1/lists/${t}`, { method: "PUT", body: s });
      return e.parse(Q, n.json);
    },
    /**
     * Delete a list
     * @see {@link https://docs.joinmastodon.org/methods/lists/#delete}
     */
    deleteList: async (t) => (await this.request(`/api/v1/lists/${t}`, { method: "DELETE" })).json,
    /**
     * View accounts in a list
     * @see {@link https://docs.joinmastodon.org/methods/lists/#accounts}
     */
    getListAccounts: async (t, s) => this.#e(`/api/v1/lists/${t}/accounts`, { params: s }, w),
    /**
     * Add accounts to a list
     * Add accounts to the given list. Note that the user must be following these accounts.
     * @see {@link https://docs.joinmastodon.org/methods/lists/#accounts-add}
     */
    addListAccounts: async (t, s) => (await this.request(`/api/v1/lists/${t}/accounts`, {
      method: "POST",
      body: { account_ids: s }
    })).json,
    /**
     * Remove accounts from list
     * Remove accounts from the given list.
     * @see {@link https://docs.joinmastodon.org/methods/lists/#accounts-remove}
     */
    deleteListAccounts: async (t, s) => (await this.request(`/api/v1/lists/${t}/accounts`, {
      method: "DELETE",
      body: { account_ids: s }
    })).json,
    /**
     * Add a list to favourites
     *
     * Requires features{@link Features.listsFavourite}.
     */
    favouriteList: async (t) => {
      const s = await this.request(`/api/v1/lists/${t}/favourite`, { method: "POST" });
      return e.parse(Q, s.json);
    },
    /**
     * Remove a list from favourites
     *
     * Requires features{@link Features.listsFavourite}.
     */
    unfavouriteList: async (t) => {
      const s = await this.request(`/api/v1/lists/${t}/unfavourite`, { method: "POST" });
      return e.parse(Q, s.json);
    }
  };
  streaming = {
    /**
     * Check if the server is alive
     * Verify that the streaming service is alive before connecting to it
     * @see {@link https://docs.joinmastodon.org/methods/streaming/#health}
     */
    health: async () => {
      const t = await this.request("/api/v1/streaming/health");
      return e.parse(e.literal("OK"), t.json);
    },
    /**
     * Establishing a WebSocket connection
     * Open a multiplexed WebSocket connection to receive events.
     * @see {@link https://docs.joinmastodon.org/methods/streaming/#websocket}
     */
    connect: () => {
      if (this.#a) return this.#a;
      const t = ct("/api/v1/streaming", this.#s?.configuration.urls.streaming, { access_token: this.accessToken }), s = new Ue(t, this.accessToken);
      let n = [];
      const o = [], b = (g) => s.readyState === Ue.CONNECTING ? o.push(g) : g();
      return s.onmessage = (g) => {
        const S = e.parse(wn, JSON.parse(g.data));
        n.filter(({ listener: i, stream: _ }) => (!_ || S.stream.includes(_)) && i(S));
      }, s.onopen = () => {
        o.forEach((g) => g());
      }, this.#a = {
        listen: (g, S) => n.push({ listener: g, stream: S }),
        unlisten: (g) => n = n.filter((S) => S.listener !== g),
        subscribe: (g, { list: S, tag: i } = {}) => b(() => s.send(JSON.stringify({ type: "subscribe", stream: g, list: S, tag: i }))),
        unsubscribe: (g, { list: S, tag: i } = {}) => b(() => s.send(JSON.stringify({ type: "unsubscribe", stream: g, list: S, tag: i }))),
        close: () => {
          s.close(), this.#a = void 0;
        }
      }, this.#a;
    }
  };
  notifications = {
    /**
     * Get all notifications
     * Notifications concerning the user. This API returns Link headers containing links to the next/previous page. However, the links can also be constructed dynamically using query params and `id` values.
     * @see {@link https://docs.joinmastodon.org/methods/notifications/#get}
     */
    getNotifications: async (t, s) => {
      const n = [
        "chat_mention",
        "emoji_reaction",
        "report",
        "participation_accepted",
        "participation_request",
        "event_reminder",
        "event_update"
      ];
      return t?.types && (t.types = [
        ...t.types,
        ...t.types.filter((o) => n.includes(o)).map((o) => `pleroma:${o}`)
      ]), t?.exclude_types && (t.exclude_types = [
        ...t.exclude_types,
        ...t.exclude_types.filter((o) => n.includes(o)).map((o) => `pleroma:${o}`)
      ]), this.#e("/api/v1/notifications", { ...s, params: t }, it);
    },
    /**
     * Get a single notification
     * View information about a notification with a given ID.
     * @see {@link https://docs.joinmastodon.org/methods/notifications/#get-one}
     */
    getNotification: async (t) => {
      const s = await this.request(`/api/v1/notifications/${t}`);
      return e.parse(it, s.json);
    },
    /**
     * Dismiss all notifications
     * Clear all notifications from the server.
     * @see {@link https://docs.joinmastodon.org/methods/notifications/#clear}
     */
    dismissNotifications: async () => (await this.request("/api/v1/notifications/clear", { method: "POST" })).json,
    /**
     * Dismiss a single notification
     * Dismiss a single notification from the server.
     * @see {@link https://docs.joinmastodon.org/methods/notifications/#dismiss}
     */
    dismissNotification: async (t) => (await this.request(`/api/v1/notifications/${t}/dismiss`, { method: "POST" })).json,
    /**
     * Get the number of unread notification
     * Get the (capped) number of unread notifications for the current user.
     *
     * Requires features{@link Features.notificationsGetUnreadCount}.
     * @see {@link https://docs.joinmastodon.org/methods/notifications/#unread-count}
     */
    getUnreadNotificationCount: async (t) => {
      const s = await this.request("/api/v1/notifications/unread_count", { params: t });
      return e.parse(e.object({
        count: e.number()
      }), s.json);
    },
    /**
     * Get the filtering policy for notifications
     * Notifications filtering policy for the user.
     *
     * Requires features{@link Features.notificationsPolicy}.
     * @see {@link https://docs.joinmastodon.org/methods/notifications/#get-policy}
     */
    getNotificationPolicy: async () => {
      const t = await this.request("/api/v2/notifications/policy");
      return e.parse(qt, t.json);
    },
    /**
     * Update the filtering policy for notifications
     * Update the user’s notifications filtering policy.
     *
     * Requires features{@link Features.notificationsPolicy}.
     * @see {@link https://docs.joinmastodon.org/methods/notifications/#update-the-filtering-policy-for-notifications}
     */
    updateNotificationPolicy: async (t) => {
      const s = await this.request("/api/v2/notifications/policy", { method: "PATCH", body: t });
      return e.parse(qt, s.json);
    },
    /**
     * Get all notification requests
     * Notification requests for notifications filtered by the user’s policy. This API returns Link headers containing links to the next/previous page.
     * @see {@link https://docs.joinmastodon.org/methods/notifications/#get-requests}
     */
    getNotificationRequests: async (t) => this.#e("/api/v1/notifications/requests", { params: t }, Tt),
    /**
     * Get a single notification request
     * View information about a notification request with a given ID.
     * @see {@link https://docs.joinmastodon.org/methods/notifications/#get-one-request}
     */
    getNotificationRequest: async (t) => {
      const s = await this.request(`/api/v1/notifications/requests/${t}`);
      return e.parse(Tt, s.json);
    },
    /**
     * Accept a single notification request
     * Accept a notification request, which merges the filtered notifications from that user back into the main notification and accepts any future notification from them.
     * @see {@link https://docs.joinmastodon.org/methods/notifications/#accept-request}
     */
    acceptNotificationRequest: async (t) => (await this.request(`/api/v1/notifications/requests/${t}/dismiss`, { method: "POST" })).json,
    /**
     * Dismiss a single notification request
     * Dismiss a notification request, which hides it and prevent it from contributing to the pending notification requests count.
     * @see {@link https://docs.joinmastodon.org/methods/notifications/#dismiss-request}
     */
    dismissNotificationRequest: async (t) => (await this.request(`/api/v1/notifications/requests/${t}/dismiss`, { method: "POST" })).json,
    /**
     * Accept multiple notification requests
     * Accepts multiple notification requests, which merges the filtered notifications from those users back into the main notifications and accepts any future notification from them.
     * @see {@link https://docs.joinmastodon.org/methods/notifications/#accept-multiple-requests}
     * Requires features{@link Features.notificationsRequestsAcceptMultiple}.
     */
    acceptMultipleNotificationRequests: async (t) => (await this.request("/api/v1/notifications/requests/accept", { method: "POST", body: { id: t } })).json,
    /**
     * Dismiss multiple notification requests
     * Dismiss multiple notification requests, which hides them and prevent them from contributing to the pending notification requests count.
     * @see {@link https://docs.joinmastodon.org/methods/notifications/#dismiss-multiple-requests}
     * Requires features{@link Features.notificationsRequestsAcceptMultiple}.
     */
    dismissMultipleNotificationRequests: async (t) => (await this.request("/api/v1/notifications/requests/dismiss", { method: "POST", body: { id: t } })).json,
    /**
     * Check if accepted notification requests have been merged
     * Check whether accepted notification requests have been merged. Accepting notification requests schedules a background job to merge the filtered notifications back into the normal notification list. When that process has finished, the client should refresh the notifications list at its earliest convenience. This is communicated by the `notifications_merged` streaming event but can also be polled using this endpoint.
     * @see {@link https://docs.joinmastodon.org/methods/notifications/#requests-merged}
     * Requires features{@link Features.notificationsRequestsAcceptMultiple}.
     */
    checkNotificationRequestsMerged: async () => {
      const t = await this.request("/api/v1/notifications/requests/merged");
      return e.parse(e.object({
        merged: e.boolean()
      }), t.json);
    },
    /**
     * An endpoint to delete multiple statuses by IDs.
     *
     * Requires features{@link Features.notificationsDismissMultiple}.
     * @see {@link https://docs.pleroma.social/backend/development/API/differences_in_mastoapi_responses/#delete-apiv1notificationsdestroy_multiple}
     */
    dismissMultipleNotifications: async (t) => (await this.request("/api/v1/notifications/destroy_multiple", {
      params: { ids: t },
      method: "DELETE"
    })).json
  };
  /**
   * It is recommended to only use this with features{@link Features.groupedNotifications} available. However, there is a fallback that groups the notifications client-side.
   */
  groupedNotifications = {
    /**
     * Get all grouped notifications
     * Return grouped notifications concerning the user. This API returns Link headers containing links to the next/previous page. However, the links can also be constructed dynamically using query params and `id` values.
     *
     * Requires features{@link Features.groupedNotifications}.
     * @see {@link https://docs.joinmastodon.org/methods/grouped_notifications/#get-grouped}
     */
    getGroupedNotifications: async (t, s) => {
      if (this.features.groupedNotifications)
        return this.#e("/api/v2/notifications", { ...s, params: t }, St, !1);
      {
        const n = await this.notifications.getNotifications(
          M(t, ["max_id", "since_id", "limit", "min_id", "types", "exclude_types", "account_id", "include_filtered"])
        );
        return this.#i(n, t);
      }
    },
    /**
     * Get a single notification group
     * View information about a specific notification group with a given group key.
     *
     * Requires features{@link Features.groupedNotifications}.
     * @see {@link https://docs.joinmastodon.org/methods/grouped_notifications/#get-notification-group}
     */
    getNotificationGroup: async (t) => {
      if (this.features.groupedNotifications) {
        const s = await this.request(`/api/v2/notifications/${t}`);
        return e.parse(St, s.json);
      } else {
        const s = await this.request(`/api/v1/notifications/${t}`);
        return this.#i({
          previous: null,
          next: null,
          items: [s.json],
          partial: !1
        }).items;
      }
    },
    /**
     * Dismiss a single notification group
     * Dismiss a single notification group from the server.
     *
     * Requires features{@link Features.groupedNotifications}.
     * @see {@link https://docs.joinmastodon.org/methods/grouped_notifications/#dismiss-group}
     */
    dismissNotificationGroup: async (t) => this.features.groupedNotifications ? (await this.request(`/api/v2/notifications/${t}/dismiss`, { method: "POST" })).json : this.notifications.dismissNotification(t),
    /**
     * Get accounts of all notifications in a notification group
     *
     * Requires features{@link Features.groupedNotifications}.
     * @see {@link https://docs.joinmastodon.org/methods/grouped_notifications/#get-group-accounts}
     */
    getNotificationGroupAccounts: async (t) => {
      if (this.features.groupedNotifications) {
        const s = await this.request(`/api/v2/notifications/${t}/accounts`);
        return e.parse(r(w), s.json);
      } else
        return (await this.groupedNotifications.getNotificationGroup(t)).accounts;
    },
    /**
     * Get the number of unread notifications
     * Get the (capped) number of unread notification groups for the current user. A notification is considered unread if it is more recent than the notifications read marker. Because the count is dependant on the parameters, it is computed every time and is thus a relatively slow operation (although faster than getting the full corresponding notifications), therefore the number of returned notifications is capped.
     *
     * Requires features{@link Features.groupedNotifications}.
     * @see {@link https://docs.joinmastodon.org/methods/grouped_notifications/#unread-group-count}
     */
    getUnreadNotificationGroupCount: async (t) => {
      if (this.features.groupedNotifications) {
        const s = await this.request("/api/v2/notifications/unread_count", { params: t });
        return e.parse(e.object({
          count: e.number()
        }), s.json);
      } else
        return this.notifications.getUnreadNotificationCount(
          M(t || {}, ["max_id", "since_id", "limit", "min_id", "types", "exclude_types", "account_id"])
        );
    }
  };
  pushNotifications = {
    /**
     * Subscribe to push notifications
     * Add a Web Push API subscription to receive notifications. Each access token can have one push subscription. If you create a new subscription, the old subscription is deleted.
     * @see {@link https://docs.joinmastodon.org/methods/push/#create}
     */
    createSubscription: async (t) => {
      const s = await this.request("/api/v1/push/subscription", { method: "POST", body: t });
      return e.parse(Qe, s.json);
    },
    /**
     * Get current subscription
     * View the PushSubscription currently associated with this access token.
     * @see {@link https://docs.joinmastodon.org/methods/push/#get}
     */
    getSubscription: async () => {
      const t = await this.request("/api/v1/push/subscription");
      return e.parse(Qe, t.json);
    },
    /**
     * Change types of notifications
     * Updates the current push subscription. Only the data part can be updated. To change fundamentals, a new subscription must be created instead.
     * @see {@link https://docs.joinmastodon.org/methods/push/#update}
     */
    updateSubscription: async (t) => {
      const s = await this.request("/api/v1/push/subscription", { method: "PUT", body: t });
      return e.parse(Qe, s.json);
    },
    /**
     * Remove current subscription
     * Removes the current Web Push API subscription.
     * @see {@link https://docs.joinmastodon.org/methods/push/#delete}
     */
    deleteSubscription: async () => (await this.request("/api/v1/push/subscription", { method: "DELETE" })).json
  };
  search = {
    /**
     * Perform a search
     * @see {@link https://docs.joinmastodon.org/methods/search/#v2}
     */
    search: async (t, s, n) => {
      const o = await this.request("/api/v2/search", { ...n, params: { ...s, q: t } });
      return e.parse(Ka, o.json);
    },
    /**
     * Searches for locations
     *
     * Requires features{@link Features.events}.
     * @see {@link https://github.com/mkljczk/pl/blob/fork/docs/development/API/pleroma_api.md#apiv1pleromasearchlocation}
     */
    searchLocation: async (t, s) => {
      const n = await this.request("/api/v1/pleroma/search/location", { ...s, params: { q: t } });
      return e.parse(r(is), n.json);
    }
  };
  instance = {
    /**
     * View server information
     * Obtain general information about the server.
     * @see {@link https://docs.joinmastodon.org/methods/instance/#v2}
     */
    getInstance: async () => {
      let t;
      try {
        t = await this.request("/api/v2/instance");
      } catch {
        t = await this.request("/api/v1/instance");
      }
      const s = e.parse(e.pipe(Et, e.readonly()), t.json);
      return this.#d(s), s;
    },
    /**
     * List of connected domains
     * Domains that this instance is aware of.
     * @see {@link https://docs.joinmastodon.org/methods/instance/#peers}
     */
    getInstancePeers: async () => {
      const t = await this.request("/api/v1/instance/peers");
      return e.parse(e.array(e.string()), t.json);
    },
    /**
     * Weekly activity
     * Instance activity over the last 3 months, binned weekly.
     * @see {@link https://docs.joinmastodon.org/methods/instance/#activity}
     */
    getInstanceActivity: async () => {
      const t = await this.request("/api/v1/instance/activity");
      return e.parse(e.array(e.object({
        week: e.string(),
        statuses: e.pipe(e.unknown(), e.transform(String)),
        logins: e.pipe(e.unknown(), e.transform(String)),
        registrations: e.pipe(e.unknown(), e.transform(String))
      })), t.json);
    },
    /**
     * List of rules
     * Rules that the users of this service should follow.
     * @see {@link https://docs.joinmastodon.org/methods/instance/#rules}
     */
    getInstanceRules: async () => {
      const t = await this.request("/api/v1/instance/rules");
      return e.parse(r(Me), t.json);
    },
    /**
     * View moderated servers
     * Obtain a list of domains that have been blocked.
     * @see {@link https://docs.joinmastodon.org/methods/instance/#domain_blocks}
     */
    getInstanceDomainBlocks: async () => {
      const t = await this.request("/api/v1/instance/rules");
      return e.parse(r(ua), t.json);
    },
    /**
     * View extended description
     * Obtain an extended description of this server
     * @see {@link https://docs.joinmastodon.org/methods/instance/#extended_description}
     */
    getInstanceExtendedDescription: async () => {
      const t = await this.request("/api/v1/instance/extended_description");
      return e.parse(da, t.json);
    },
    /**
     * View translation languages
     * Translation language pairs supported by the translation engine used by the server.
     * @see {@link https://docs.joinmastodon.org/methods/instance/#translation_languages}
     */
    getInstanceTranslationLanguages: async () => {
      if (this.features.version.software === m) {
        const s = await this.request("/api/v1/akkoma/translation/languages");
        return Object.fromEntries(s.json.source.map((n) => [
          n.code.toLocaleLowerCase(),
          s.json.target.map((o) => o.code).filter((o) => o !== n.code).map((o) => o.toLocaleLowerCase())
        ]));
      }
      const t = await this.request("/api/v1/instance/translation_languages");
      return e.parse(e.record(e.string(), e.array(e.string())), t.json);
    },
    /**
     * View profile directory
     * List accounts visible in the directory.
     * @see {@link https://docs.joinmastodon.org/methods/directory/#get}
     */
    profileDirectory: async (t) => {
      const s = await this.request("/api/v1/directory", { params: t });
      return e.parse(r(w), s.json);
    },
    /**
     * View all custom emoji
     * Returns custom emojis that are available on the server.
     * @see {@link https://docs.joinmastodon.org/methods/custom_emojis/#get}
     */
    getCustomEmojis: async () => {
      const t = await this.request("/api/v1/custom_emojis");
      return e.parse(r(ee), t.json);
    },
    /**
     * Dump frontend configurations
     *
     * Requires features{@link Features.frontendConfigurations}.
     */
    getFrontendConfigurations: async () => {
      let t;
      switch (this.features.version.software) {
        case y:
          t = (await this.request("/api/v1/accounts/verify_credentials")).json?.client_config;
          break;
        default:
          t = (await this.request("/api/pleroma/frontend_configurations")).json;
      }
      return e.parse(e.fallback(e.record(e.string(), e.record(e.string(), e.any())), {}), t);
    },
    /**
     * View privacy policy
     * Obtain the contents of this server's privacy policy.
     * @see {@link https://docs.joinmastodon.org/methods/instance/privacy_policy}
     */
    getInstancePrivacyPolicy: async () => {
      const t = await this.request("/api/v1/instance/privacy_policy");
      return e.parse(Ja, t.json);
    },
    /**
     * View terms of service
     * Obtain the contents of this server's terms of service, if configured.
     * @see {@link https://docs.joinmastodon.org/methods/instance/terms_of_service}
     */
    getInstanceTermsOfService: async () => {
      const t = await this.request("/api/v1/instance/terms_of_service");
      return e.parse(At, t.json);
    },
    /**
      * View a specific version of the terms of service
      * Obtain the contents of this server's terms of service, for a specified date, if configured.
      * @see {@link https://docs.joinmastodon.org/methods/instance/terms_of_service_date}
      */
    getInstanceTermsOfServiceForDate: async (t) => {
      const s = await this.request(`/api/v1/instance/terms_of_service/${t}`);
      return e.parse(At, s.json);
    }
  };
  trends = {
    /**
     * View trending tags
     * Tags that are being used more frequently within the past week.
     * @see {@link https://docs.joinmastodon.org/methods/trends/#tags}
     */
    getTrendingTags: async (t) => {
      const s = await this.request(
        this.features.version.software === q ? "/api/v1.1/discover/posts/hashtags" : "/api/v1/trends/tags",
        { params: t }
      );
      return e.parse(r(X), s.json);
    },
    /**
     * View trending statuses
     * Statuses that have been interacted with more than others.
     * @see {@link https://docs.joinmastodon.org/methods/trends/#statuses}
     */
    getTrendingStatuses: async (t) => {
      const s = await this.request(
        this.features.version.software === q ? "/api/pixelfed/v2/discover/posts/trending" : "/api/v1/trends/statuses",
        { params: t }
      );
      return e.parse(r(f), s.json);
    },
    /**
     * View trending links
     * Links that have been shared more than others.
     * @see {@link https://docs.joinmastodon.org/methods/trends/#links}
     */
    getTrendingLinks: async (t) => {
      const s = await this.request("/api/v1/trends/links", { params: t });
      return e.parse(r(Rt), s.json);
    }
  };
  announcements = {
    /**
     * View all announcements
     * See all currently active announcements set by admins.
     * @see {@link https://docs.joinmastodon.org/methods/announcements/#get}
     */
    getAnnouncements: async () => {
      const t = await this.request("/api/v1/announcements");
      return e.parse(r(dt), t.json);
    },
    /**
     * Dismiss an announcement
     * Allows a user to mark the announcement as read.
     * @see {@link https://docs.joinmastodon.org/methods/announcements/#dismiss}
     */
    dismissAnnouncements: async (t) => (await this.request(`/api/v1/announcements/${t}`, { method: "POST" })).json,
    /**
     * Add a reaction to an announcement
     * React to an announcement with an emoji.
     * @see {@link https://docs.joinmastodon.org/methods/announcements/#put-reactions}
     */
    addAnnouncementReaction: async (t, s) => (await this.request(`/api/v1/announcements/${t}/reactions/${s}`, { method: "PUT" })).json,
    /**
     * Remove a reaction from an announcement
     * Undo a react emoji to an announcement.
     * @see {@link https://docs.joinmastodon.org/methods/announcements/#delete-reactions}
     */
    deleteAnnouncementReaction: async (t, s) => (await this.request(`/api/v1/announcements/${t}/reactions/${s}`, { method: "DELETE" })).json
  };
  /** Experimental async refreshes API methods */
  asyncRefreshes = {
    /**
     * Get Status of Async Refresh
     * @see {@link https://docs.joinmastodon.org/methods/async_refreshes/#show}
     */
    show: async (t) => {
      const s = await this.request(`/api/v1_alpha/async_refreshes/${t}`);
      return e.parse(aa, s.json);
    }
  };
  admin = {
    /** Perform moderation actions with accounts. */
    accounts: {
      /**
       * View accounts
       * View all accounts, optionally matching certain criteria for filtering, up to 100 at a time.
       * @see {@link https://docs.joinmastodon.org/methods/admin/accounts/#v2}
       */
      getAccounts: async (t) => this.features.mastodonAdminV2 ? this.#e("/api/v2/admin/accounts", { params: t }, C) : this.#l(t ? {
        query: t.username,
        name: t.display_name,
        email: t.email,
        filters: [
          t.origin === "local" && "local",
          t.origin === "remote" && "external",
          t.status === "active" && "active",
          t.status === "pending" && "need_approval",
          t.status === "disabled" && "deactivated",
          t.permissions === "staff" && "is_admin",
          t.permissions === "staff" && "is_moderator"
        ].filter((s) => s).join(","),
        page_size: 100
      } : { page_size: 100 }),
      /**
       * View a specific account
       * View admin-level information about the given account.
       * @see {@link https://docs.joinmastodon.org/methods/admin/accounts/#get-one}
       */
      getAccount: async (t) => {
        let s;
        return this.features.mastodonAdmin ? s = await this.request(`/api/v1/admin/accounts/${t}`) : s = await this.request(`/api/v1/pleroma/admin/users/${t}`), e.parse(C, s.json);
      },
      /**
       * Approve a pending account
       * Approve the given local account if it is currently pending approval.
       * @see {@link https://docs.joinmastodon.org/methods/admin/accounts/#approve}
       */
      approveAccount: async (t) => {
        let s;
        if (this.features.mastodonAdmin)
          s = await this.request(`/api/v1/admin/accounts/${t}/approve`, { method: "POST" });
        else {
          const n = await this.admin.accounts.getAccount(t);
          s = await this.request("/api/v1/pleroma/admin/users/approve", { method: "PATCH", body: { nicknames: [n.username] } }), s.json = s.json?.users?.[0];
        }
        return e.parse(C, s.json);
      },
      /**
       * Reject a pending account
       * Reject the given local account if it is currently pending approval.
       * @see {@link https://docs.joinmastodon.org/methods/admin/accounts/#reject}
       */
      rejectAccount: async (t) => {
        let s;
        if (this.features.mastodonAdmin)
          s = await this.request(`/api/v1/admin/accounts/${t}/reject`, { method: "POST" });
        else {
          const n = await this.admin.accounts.getAccount(t);
          s = await this.request("/api/v1/pleroma/admin/users", { method: "DELETE", body: {
            nicknames: [n.username]
          } });
        }
        return e.safeParse(C, s.json).output || {};
      },
      /**
       * Requires features{@link Features.pleromaAdminAccounts}.
       */
      createAccount: async (t) => {
        const s = await this.request("/api/v1/pleroma/admin/users", { method: "POST", body: { users: [t] } });
        return e.parse(e.object({
          nickname: e.string(),
          email: e.string()
        }), s.json[0]?.data);
      },
      /**
       * Delete an account
       * Permanently delete data for a suspended accountusers
       * @see {@link https://docs.joinmastodon.org/methods/admin/accounts/#delete}
       */
      deleteAccount: async (t) => {
        let s;
        if (this.features.mastodonAdmin || this.features.version.software === y)
          s = await this.request(`/api/v1/admin/accounts/${t}`, { method: "DELETE" });
        else {
          const n = await this.admin.accounts.getAccount(t);
          s = await this.request("/api/v1/pleroma/admin/users", { method: "DELETE", body: {
            nicknames: [n.username]
          } });
        }
        return e.safeParse(C, s.json).output || {};
      },
      /**
       * Perform an action against an account
       * Perform an action against an account and log this action in the moderation history. Also resolves any open reports against this account.
       * @see {@link https://docs.joinmastodon.org/methods/admin/accounts/#action}
       */
      performAccountAction: async (t, s, n) => {
        let o;
        if (this.features.mastodonAdmin)
          o = await this.request(`/api/v1/admin/accounts/${t}/action`, { body: { ...n, type: s } });
        else {
          const b = await this.admin.accounts.getAccount(t);
          switch (s) {
            case "disable":
            case "suspend":
              o = await this.request("/api/v1/pleroma/admin/users/deactivate", { body: { nicknames: [b.username] } });
              break;
            default:
              o = { json: {} };
              break;
          }
          n?.report_id && await this.admin.reports.resolveReport(n.report_id);
        }
        return o.json;
      },
      /**
       * Enable a currently disabled account
       * Re-enable a local account whose login is currently disabled.
       * @see {@link https://docs.joinmastodon.org/methods/admin/accounts/#enable}
       */
      enableAccount: async (t) => {
        let s;
        if (this.features.mastodonAdmin)
          s = await this.request(`/api/v1/admin/accounts/${t}/enable`, { method: "POST" });
        else {
          const n = await this.admin.accounts.getAccount(t);
          s = await this.request("/api/v1/pleroma/admin/users/activate", { method: "PATCH", body: { nicknames: [n.username] } }), s.json = s.json?.users?.[0];
        }
        return e.parse(C, s.json);
      },
      /**
       * Unsilence an account
       * Unsilence an account if it is currently silenced.
       * @see {@link https://docs.joinmastodon.org/methods/admin/accounts/#unsilence}
       */
      unsilenceAccount: async (t) => {
        const s = await this.request(`/api/v1/admin/accounts/${t}/unsilence`, { method: "POST" });
        return e.parse(C, s.json);
      },
      /**
       * Unsuspend an account
       * Unsuspend a currently suspended account.
       * @see {@link https://docs.joinmastodon.org/methods/admin/accounts/#unsuspend}
       */
      unsuspendAccount: async (t) => {
        let s;
        if (this.features.mastodonAdmin)
          s = await this.request(`/api/v1/admin/accounts/${t}/unsuspend`, { method: "POST" });
        else {
          const { account: n } = await this.admin.accounts.getAccount(t);
          s = await this.request("/api/v1/pleroma/admin/users/activate", { method: "PATCH", body: { nicknames: [n.acct] } }), s.json = s.json?.users?.[0];
        }
        return e.parse(C, s.json);
      },
      /**
       * Unmark an account as sensitive
       * Stops marking an account’s posts as sensitive, if it was previously flagged as sensitive.
       * @see {@link https://docs.joinmastodon.org/methods/admin/accounts/#unsensitive}
       */
      unsensitiveAccount: async (t) => {
        const s = await this.request(`/api/v1/admin/accounts/${t}/unsensitive`, { method: "POST" });
        return e.parse(C, s.json);
      },
      /**
       * Requires features{@link Features.pleromaAdminAccounts}.
       */
      promoteToAdmin: async (t) => {
        const { account: s } = await this.admin.accounts.getAccount(t);
        return await this.request("/api/v1/pleroma/admin/users/permission_group/moderator", {
          method: "DELETE",
          body: { nicknames: [s.acct] }
        }), (await this.request("/api/v1/pleroma/admin/users/permission_group/admin", {
          method: "POST",
          body: { nicknames: [s.acct] }
        })).json;
      },
      /**
       * Requires features{@link Features.pleromaAdminAccounts}.
       */
      promoteToModerator: async (t) => {
        const { account: s } = await this.admin.accounts.getAccount(t);
        return await this.request("/api/v1/pleroma/admin/users/permission_group/admin", {
          method: "DELETE",
          body: { nicknames: [s.acct] }
        }), (await this.request("/api/v1/pleroma/admin/users/permission_group/moderator", {
          method: "POST",
          body: { nicknames: [s.acct] }
        })).json;
      },
      /**
       * Requires features{@link Features.pleromaAdminAccounts}.
       */
      demoteToUser: async (t) => {
        const { account: s } = await this.admin.accounts.getAccount(t);
        return await this.request("/api/v1/pleroma/admin/users/permission_group/moderator", {
          method: "DELETE",
          body: { nicknames: [s.acct] }
        }), (await this.request("/api/v1/pleroma/admin/users/permission_group/admin", {
          method: "DELETE",
          body: { nicknames: [s.acct] }
        })).json;
      },
      /**
       * Tag a user.
       *
       * Requires features{@link Features.pleromaAdminAccounts}.
       * @see {@link https://docs.pleroma.social/backend/development/API/admin_api/#patch-apiv1pleromaadminuserssuggest}
       */
      suggestUser: async (t) => {
        const { account: s } = await this.admin.accounts.getAccount(t);
        return (await this.request("/api/v1/pleroma/admin/users/suggest", {
          method: "PATCH",
          body: { nicknames: [s.acct] }
        })).json;
      },
      /**
       * Untag a user.
       *
       * Requires features{@link Features.pleromaAdminAccounts}.
       * @see {@link https://docs.pleroma.social/backend/development/API/admin_api/#patch-apiv1pleromaadminusersunsuggest}
       */
      unsuggestUser: async (t) => {
        const { account: s } = await this.admin.accounts.getAccount(t);
        return (await this.request("/api/v1/pleroma/admin/users/unsuggest", {
          method: "PATCH",
          body: { nicknames: [s.acct] }
        })).json;
      },
      /**
       * Tag a user.
       *
       * Requires features{@link Features.pleromaAdminAccounts}.
       * @see {@link https://docs.pleroma.social/backend/development/API/admin_api/#put-apiv1pleromaadminuserstag}
       */
      tagUser: async (t, s) => {
        const { account: n } = await this.admin.accounts.getAccount(t);
        return (await this.request("/api/v1/pleroma/admin/users/tag", {
          method: "PUT",
          body: { nicknames: [n.acct], tags: s }
        })).json;
      },
      /**
       * Untag a user.
       *
       * Requires features{@link Features.pleromaAdminAccounts}.
       * @see {@link https://docs.pleroma.social/backend/development/API/admin_api/#delete-apiv1pleromaadminuserstag}
       */
      untagUser: async (t, s) => {
        const { account: n } = await this.admin.accounts.getAccount(t);
        return (await this.request("/api/v1/pleroma/admin/users/tag", {
          method: "DELETE",
          body: { nicknames: [n.acct], tags: s }
        })).json;
      }
    },
    /** Disallow certain domains to federate. */
    domainBlocks: {
      /**
       * List all blocked domains
       * Show information about all blocked domains.
       * @see {@link https://docs.joinmastodon.org/methods/admin/domain_blocks/#get}
       */
      getDomainBlocks: (t) => this.#e("/api/v1/admin/domain_blocks", { params: t }, ye),
      /**
       * Get a single blocked domain
       * Show information about a single blocked domain.
       * @see {@link https://docs.joinmastodon.org/methods/admin/domain_blocks/#get-one}
       */
      getDomainBlock: async (t) => {
        const s = await this.request(`/api/v1/admin/domain_blocks/${t}`);
        return e.parse(ye, s.json);
      },
      /**
       * Block a domain from federating
       * Add a domain to the list of domains blocked from federating.
       * @see {@link https://docs.joinmastodon.org/methods/admin/domain_blocks/#create}
       */
      createDomainBlock: async (t, s) => {
        const n = await this.request("/api/v1/admin/domain_blocks", {
          method: "POST",
          body: { ...s, domain: t }
        });
        return e.parse(ye, n.json);
      },
      /**
       * Update a domain block
       * Change parameters for an existing domain block.
       * @see {@link https://docs.joinmastodon.org/methods/admin/domain_blocks/#update}
       */
      updateDomainBlock: async (t, s) => {
        const n = await this.request(`/api/v1/admin/domain_blocks/${t}`, {
          method: "PUT",
          body: s
        });
        return e.parse(ye, n.json);
      },
      /**
       * Remove a domain block
       * Lift a block against a domain.
       * @see {@link https://docs.joinmastodon.org/methods/admin/domain_blocks/#delete}
       */
      deleteDomainBlock: async (t) => (await this.request(`/api/v1/admin/domain_blocks/${t}`, {
        method: "DELETE"
      })).json
    },
    /** Perform moderation actions with reports. */
    reports: {
      /**
       * View all reports
       * View information about all reports.
       * @see {@link https://docs.joinmastodon.org/methods/admin/reports/#get}
       */
      getReports: async (t) => this.features.mastodonAdmin ? (t?.resolved === void 0 && (this.features.version.software === d || this.features.version.software === p) && (t || (t = {}), t.resolved = !1), this.#e("/api/v1/admin/reports", { params: t }, Z)) : this.#c({
        state: t?.resolved === !0 ? "resolved" : "open",
        page_size: t?.limit || 100
      }),
      /**
       * View a single report
       * @see {@link https://docs.joinmastodon.org/methods/admin/reports/#get-one}
       */
      getReport: async (t) => {
        let s;
        return this.features.mastodonAdmin ? s = await this.request(`/api/v1/admin/reports/${t}`) : s = await this.request(`/api/v1/pleroma/admin/reports/${t}`), e.parse(Z, s.json);
      },
      /**
       * Update a report
       * Change metadata for a report.
       * @see {@link https://docs.joinmastodon.org/methods/admin/reports/#update}
       */
      updateReport: async (t, s) => {
        const n = await this.request(`/api/v1/admin/reports/${t}`, { method: "PUT", body: s });
        return e.parse(Z, n.json);
      },
      /**
       * Assign report to self
       * Claim the handling of this report to yourself.
       * @see {@link https://docs.joinmastodon.org/methods/admin/reports/#assign_to_self}
       */
      assignReportToSelf: async (t) => {
        const s = await this.request(`/api/v1/admin/reports/${t}/assign_to_self`, { method: "POST" });
        return e.parse(Z, s.json);
      },
      /**
       * Unassign report
       * Unassign a report so that someone else can claim it.
       * @see {@link https://docs.joinmastodon.org/methods/admin/reports/#unassign}
       */
      unassignReport: async (t) => {
        const s = await this.request(`/api/v1/admin/reports/${t}/unassign`, { method: "POST" });
        return e.parse(Z, s.json);
      },
      /**
       * Mark report as resolved
       *
       * Mark a report as resolved with no further action taken.
       *
       * `action_taken_comment` param requires features{@link Features.mastodonAdminResolveReportWithComment}.
       * @param action_taken_comment Optional admin comment on the action taken in response to this report. Supported by GoToSocial only.
       * @see {@link https://docs.joinmastodon.org/methods/admin/reports/#resolve}
       */
      resolveReport: async (t, s) => {
        let n;
        return this.features.mastodonAdmin ? n = await this.request(`/api/v1/admin/reports/${t}/resolve`, { method: "POST", body: { action_taken_comment: s } }) : n = await this.request(`/api/v1/pleroma/admin/reports/${t}`, {
          method: "PATCH",
          body: { reports: [{ id: t, state: "resolved" }] }
        }), e.parse(Z, n.json);
      },
      /**
       * Reopen a closed report
       * Reopen a currently closed report, if it is closed.
       * @see {@link https://docs.joinmastodon.org/methods/admin/reports/#reopen}
       */
      reopenReport: async (t) => {
        let s;
        return this.features.mastodonAdmin ? s = await this.request(`/api/v1/admin/reports/${t}/reopen`, { method: "POST" }) : s = await this.request(`/api/v1/pleroma/admin/reports/${t}`, {
          method: "PATCH",
          body: { reports: [{ id: t, state: "open" }] }
        }), e.parse(Z, s.json);
      }
    },
    statuses: {
      /**
       * @param params Retrieves all latest statuses
       *
       * The params are subject to change in case Mastodon implements alike route.
       *
       * Requires features{@link Features.pleromaAdminStatuses}.
       * @see {@link https://docs.pleroma.social/backend/development/API/admin_api/#get-apiv1pleromaadminstatuses}
       */
      getStatuses: async (t) => this.#u({
        page_size: t?.limit || 100,
        page: 1,
        local_only: t?.local_only,
        with_reblogs: t?.with_reblogs,
        godmode: t?.with_private
      }),
      /**
       * Show status by id
       *
       * Requires features{@link Features.pleromaAdminStatuses}.
       * @see {@link https://docs.pleroma.social/backend/development/API/admin_api/#get-apiv1pleromaadminstatusesid}
      */
      getStatus: async (t) => {
        const s = await this.request(`/api/v1/pleroma/admin/statuses/${t}`);
        return e.parse(f, s.json);
      },
      /**
       * Change the scope of an individual reported status
       *
       * Requires features{@link Features.pleromaAdminStatuses}.
       * @see {@link https://docs.pleroma.social/backend/development/API/admin_api/#put-apiv1pleromaadminstatusesid}
       */
      updateStatus: async (t, s) => {
        const n = await this.request(`/api/v1/pleroma/admin/statuses/${t}`, { method: "PUT", body: s });
        return e.parse(f, n.json);
      },
      /**
       * Delete an individual reported status
       *
       * Requires features{@link Features.pleromaAdminStatuses}.
       * @see {@link https://docs.pleroma.social/backend/development/API/admin_api/#delete-apiv1pleromaadminstatusesid}
       */
      deleteStatus: async (t) => {
        let s;
        return this.features.version.software === y ? s = await this.request(`/api/v1/admin/posts/${t}`, { method: "DELETE" }) : s = await this.request(`/api/v1/pleroma/admin/statuses/${t}`, { method: "DELETE" }), s.json;
      },
      /**
       * Requires features{@link Features.pleromaAdminStatusesRedact}
       */
      redactStatus: async (t, s) => {
        const n = await this.request(`/api/v1/pleroma/admin/statuses/${t}/redact`, { method: "PATCH", body: s });
        return e.parse(f, n.json);
      },
      /**
       * Requires features{@link Features.pleromaAdminStatusesRedact}
       */
      getStatusSource: async (t) => {
        const s = await this.request(`/api/v1/pleroma/admin/statuses/${t}/source`);
        return e.parse(Ye, s.json);
      }
    },
    trends: {
      /**
       * View trending links
       * Links that have been shared more than others, including unapproved and unreviewed links.
       * @see {@link https://docs.joinmastodon.org/methods/admin/trends/#links}
       */
      getTrendingLinks: async () => {
        const t = await this.request("/api/v1/admin/trends/links");
        return e.parse(r(Rt), t.json);
      },
      /**
       * View trending statuses
       * Statuses that have been interacted with more than others, including unapproved and unreviewed statuses.
       * @see {@link https://docs.joinmastodon.org/methods/admin/trends/#statuses}
       */
      getTrendingStatuses: async () => {
        const t = await this.request("/api/v1/admin/trends/statuses");
        return e.parse(r(f), t.json);
      },
      /**
       * View trending tags
       * Tags that are being used more frequently within the past week, including unapproved and unreviewed tags.
       * @see {@link https://docs.joinmastodon.org/methods/admin/trends/#tags}
       */
      getTrendingTags: async () => {
        const t = await this.request("/api/v1/admin/trends/links");
        return e.parse(r(ea), t.json);
      }
    },
    /** Block certain email addresses by their hash. */
    canonicalEmailBlocks: {
      /**
       * List all canonical email blocks
       * @see {@link https://docs.joinmastodon.org/methods/admin/canonical_email_blocks/#get}
       */
      getCanonicalEmailBlocks: async (t) => this.#e("/api/v1/admin/canonical_email_blocks", { params: t }, ke),
      /**
       * Show a single canonical email block
       * @see {@link https://docs.joinmastodon.org/methods/admin/canonical_email_blocks/#get-one}
       */
      getCanonicalEmailBlock: async (t) => {
        const s = await this.request(`/api/v1/admin/canonical_email_blocks/${t}`);
        return e.parse(ke, s.json);
      },
      /**
       * Test
       * Canoniocalize and hash an email address.
       * @see {@link https://docs.joinmastodon.org/methods/admin/canonical_email_blocks/#test}
       */
      testCanonicalEmailBlock: async (t) => {
        const s = await this.request("/api/v1/admin/canonical_email_blocks/test", { method: "POST", body: { email: t } });
        return e.parse(r(ke), s.json);
      },
      /**
       * Block a canonical email
       * @see {@link https://docs.joinmastodon.org/methods/admin/canonical_email_blocks/#create}
       */
      createCanonicalEmailBlock: async (t, s) => {
        const n = await this.request("/api/v1/admin/canonical_email_blocks", { method: "POST", body: { email: t, canonical_email_hash: s } });
        return e.parse(r(ke), n.json);
      },
      /**
       * Delete a canonical email block
       * @see {@link https://docs.joinmastodon.org/methods/admin/canonical_email_blocks/#delete}
       */
      deleteCanonicalEmailBlock: async (t) => (await this.request(`/api/v1/admin/canonical_email_blocks/${t}`, { method: "DELETE" })).json
    },
    /** Obtain qualitative metrics about the server. */
    dimensions: {
      /**
       * Get dimensional data
       * Obtain information about popularity of certain accounts, servers, languages, etc.
       * @see {@link https://docs.joinmastodon.org/methods/admin/dimensions/#get}
       */
      getDimensions: async (t, s) => {
        const n = await this.request("/api/v1/admin/dimensions", { method: "POST", params: { ...s, keys: t } });
        return e.parse(r(xs), n.json);
      }
    },
    /** Allow certain domains to federate. */
    domainAllows: {
      /**
       * List all allowed domains
       * Show information about all allowed domains.
       * @see {@link https://docs.joinmastodon.org/methods/admin/domain_allows/#get}
       */
      getDomainAllows: (t) => this.#e("/api/v1/admin/domain_allows", { params: t }, Ve),
      /**
       * Get a single allowed domain
       * Show information about a single allowed domain.
       * @see {@link https://docs.joinmastodon.org/methods/admin/domain_allows/#get-one}
       */
      getDomainAllow: async (t) => {
        const s = await this.request(`/api/v1/admin/domain_allows/${t}`);
        return e.parse(Ve, s.json);
      },
      /**
       * Allow a domain to federate
       * Add a domain to the list of domains allowed to federate, to be used when the instance is in allow-list federation mode.
       * @see {@link https://docs.joinmastodon.org/methods/admin/domain_allows/#create}
       */
      createDomainAllow: async (t) => {
        const s = await this.request("/api/v1/admin/domain_allows", { method: "POST", body: { domain: t } });
        return e.parse(Ve, s.json);
      },
      /**
       * Delete an allowed domain
       * Delete a domain from the allowed domains list.
       * @see {@link https://docs.joinmastodon.org/methods/admin/domain_allows/#delete}
       */
      deleteDomainAllow: async (t) => (await this.request(`/api/v1/admin/domain_allows/${t}`, { method: "DELETE" })).json
    },
    /** Disallow certain email domains from signing up. */
    emailDomainBlocks: {
      /**
       * List all blocked email domains
       * Show information about all email domains blocked from signing up.
       * @see {@link https://docs.joinmastodon.org/methods/admin/email_domain_blocks/#get}
       */
      getEmailDomainBlocks: (t) => this.#e("/api/v1/admin/email_domain_blocks", { params: t }, ze),
      /**
       * Get a single blocked email domain
       * Show information about a single email domain that is blocked from signups.
       * @see {@link https://docs.joinmastodon.org/methods/admin/email_domain_blocks/#get-one}
       */
      getEmailDomainBlock: async (t) => {
        const s = await this.request(`/api/v1/admin/email_domain_blocks/${t}`);
        return e.parse(ze, s.json);
      },
      /**
       * Block an email domain from signups
       * Add a domain to the list of email domains blocked from signups.
       * @see {@link https://docs.joinmastodon.org/methods/admin/email_domain_blocks/#create}
       */
      createEmailDomainBlock: async (t) => {
        const s = await this.request("/api/v1/admin/email_domain_blocks", { method: "POST", body: { domain: t } });
        return e.parse(ze, s.json);
      },
      /**
       * Delete an email domain block
       * Lift a block against an email domain.
       * @see {@link https://docs.joinmastodon.org/methods/admin/email_domain_blocks/#delete}
       */
      deleteEmailDomainBlock: async (t) => (await this.request(`/api/v1/admin/email_domain_blocks/${t}`, { method: "DELETE" })).json
    },
    /** Disallow certain IP address ranges from signing up. */
    ipBlocks: {
      /**
       * List all IP blocks
       * Show information about all blocked IP ranges.
       * @see {@link https://docs.joinmastodon.org/methods/admin/ip_blocks/#get}
       */
      getIpBlocks: (t) => this.#e("/api/v1/admin/ip_blocks", { params: t }, je),
      /**
       * Get a single IP block
       * Show information about a single IP block.
       * @see {@link https://docs.joinmastodon.org/methods/admin/ip_blocks/#get-one}
       */
      getIpBlock: async (t) => {
        const s = await this.request(`/api/v1/admin/ip_blocks/${t}`);
        return e.parse(je, s.json);
      },
      /**
       * Block an IP address range from signing up
       * Add an IP address range to the list of IP blocks.
       * @see {@link https://docs.joinmastodon.org/methods/admin/ip_blocks/#create}
       */
      createIpBlock: async (t) => {
        const s = await this.request("/api/v1/admin/ip_blocks", { method: "POST", body: t });
        return e.parse(je, s.json);
      },
      /**
       * Update a domain block
       * Change parameters for an existing IP block.
       * @see {@link https://docs.joinmastodon.org/methods/admin/ip_blocks/#update}
       */
      updateIpBlock: async (t, s) => {
        const n = await this.request(`/api/v1/admin/ip_blocks/${t}`, { method: "POST", body: s });
        return e.parse(je, n.json);
      },
      /**
       * Delete an IP block
       * Lift a block against an IP range.
       * @see {@link https://docs.joinmastodon.org/methods/admin/ip_blocks/#delete}
       */
      deleteIpBlock: async (t) => (await this.request(`/api/v1/admin/ip_blocks/${t}`, { method: "DELETE" })).json
    },
    /** Obtain quantitative metrics about the server. */
    measures: {
      /**
       * Get measurable data
       * Obtain quantitative metrics about the server.
       * @see {@link https://docs.joinmastodon.org/methods/admin/measures/#get}
       */
      getMeasures: async (t, s, n, o) => {
        const b = await this.request("/api/v1/admin/measures", { method: "POST", params: { ...o, keys: t, start_at: s, end_at: n } });
        return e.parse(r(Is), b.json);
      }
    },
    /** Show retention data over time. */
    retention: {
      /**
       * Calculate retention data
       *
       * Generate a retention data report for a given time period and bucket.
       * @see {@link https://docs.joinmastodon.org/methods/admin/retention/#create}
       */
      getRetention: async (t, s, n) => {
        const o = await this.request("/api/v1/admin/retention", { method: "POST", params: { start_at: t, end_at: s, frequency: n } });
        return e.parse(r(Ns), o.json);
      }
    },
    announcements: {
      /**
       * List announcements
       *
       * Requires features{@link Features.pleromaAdminAnnouncements}.
       * @see {@link https://docs.pleroma.social/backend/development/API/admin_api/#get-apiv1pleromaadminannouncements}
       */
      getAnnouncements: async (t) => {
        const s = await this.request("/api/v1/pleroma/admin/announcements", { params: t }), n = e.parse(r(_e), s.json);
        return {
          previous: null,
          next: n.length ? () => this.admin.announcements.getAnnouncements({ ...t, offset: (t?.offset || 0) + n.length }) : null,
          items: n,
          partial: !1
        };
      },
      /**
       * Display one announcement
       *
       * Requires features{@link Features.pleromaAdminAnnouncements}.
       * @see {@link https://docs.pleroma.social/backend/development/API/admin_api/#get-apiv1pleromaadminannouncementsid}
       */
      getAnnouncement: async (t) => {
        const s = await this.request(`/api/v1/pleroma/admin/announcements/${t}`);
        return e.parse(_e, s.json);
      },
      /**
       * Create an announcement
       *
       * Requires features{@link Features.pleromaAdminAnnouncements}.
       * @see {@link https://docs.pleroma.social/backend/development/API/admin_api/#post-apiv1pleromaadminannouncements}
       */
      createAnnouncement: async (t) => {
        const s = await this.request("/api/v1/pleroma/admin/announcements", { method: "POST", body: t });
        return e.parse(_e, s.json);
      },
      /**
       * Change an announcement
       *
       * Requires features{@link Features.pleromaAdminAnnouncements}.
       * @see {@link https://docs.pleroma.social/backend/development/API/admin_api/#patch-apiv1pleromaadminannouncementsid}
       */
      updateAnnouncement: async (t, s) => {
        const n = await this.request(`/api/v1/pleroma/admin/announcements/${t}`, { method: "PATCH", body: s });
        return e.parse(_e, n.json);
      },
      /**
       * Delete an announcement
       *
       * Requires features{@link Features.pleromaAdminAnnouncements}.
       * @see {@link https://docs.pleroma.social/backend/development/API/admin_api/#delete-apiv1pleromaadminannouncementsid}
       */
      deleteAnnouncement: async (t) => (await this.request(`/api/v1/pleroma/admin/announcements/${t}`, { method: "DELETE" })).json
    },
    domains: {
      /**
       * List of domains
       *
       * Requires features{@link Features.domains}.
       */
      getDomains: async () => {
        const t = await this.request("/api/v1/pleroma/admin/domains");
        return e.parse(r(Be), t.json);
      },
      /**
       * Create a domain
       *
       * Requires features{@link Features.domains}.
       */
      createDomain: async (t) => {
        const s = await this.request("/api/v1/pleroma/admin/domains", { method: "POST", body: t });
        return e.parse(Be, s.json);
      },
      /**
       * Change domain publicity
       *
       * Requires features{@link Features.domains}.
       */
      updateDomain: async (t, s) => {
        const n = await this.request(`/api/v1/pleroma/admin/domains/${t}`, { method: "PATCH", body: { public: s } });
        return e.parse(Be, n.json);
      },
      /**
       * Delete a domain
       *
       * Requires features{@link Features.domains}.
       */
      deleteDomain: async (t) => (await this.request(`/api/v1/pleroma/admin/domains/${t}`, { method: "DELETE" })).json
    },
    moderationLog: {
      /**
       * Get moderation log
       *
       * Requires features{@link Features.pleromaAdminModerationLog}.
       * @see {@link https://docs.pleroma.social/backend/development/API/admin_api/#get-apiv1pleromaadminmoderation_log}
      */
      getModerationLog: async ({ limit: t, ...s } = {}) => {
        const n = await this.request("/api/v1/pleroma/admin/moderation_log", { params: { page_size: t, ...s } }), o = e.parse(r(Ds), n.json.items);
        return {
          previous: s.page && s.page > 1 ? () => this.admin.moderationLog.getModerationLog({ ...s, page: s.page - 1 }) : null,
          next: n.json.total > (s.page || 1) * (t || 50) ? () => this.admin.moderationLog.getModerationLog({ ...s, page: (s.page || 1) + 1 }) : null,
          items: o,
          partial: n.status === 206
        };
      }
    },
    relays: {
      /**
       * List Relays
       *
       * Requires features{@link Features.pleromaAdminRelays}.
       * @see {@link https://docs.pleroma.social/backend/development/API/admin_api/#get-apiv1pleromaadminrelay}
       */
      getRelays: async () => {
        const t = await this.request("/api/v1/pleroma/admin/relay");
        return e.parse(r(He), t.json);
      },
      /**
       * Follow a Relay
       *
       * Requires features{@link Features.pleromaAdminRelays}.
       * @see {@link https://docs.pleroma.social/backend/development/API/admin_api/#post-apiv1pleromaadminrelay}
       */
      followRelay: async (t) => {
        const s = await this.request("/api/v1/pleroma/admin/relay", { method: "POST", body: { relay_url: t } });
        return e.parse(He, s.json);
      },
      /**
       * Unfollow a Relay
       *
       * Requires features{@link Features.pleromaAdminRelays}.
       * @see {@link https://docs.pleroma.social/backend/development/API/admin_api/#delete-apiv1pleromaadminrelay}
       */
      unfollowRelay: async (t, s = !1) => {
        const n = await this.request("/api/v1/pleroma/admin/relay", { method: "DELETE", body: { relay_url: t, force: s } });
        return e.parse(He, n.json);
      }
    },
    rules: {
      /**
       * List rules
       *
       * Requires features{@link Features.adminRules}.
       * @see {@link https://docs.pleroma.social/backend/development/API/admin_api/#get-apiv1pleromaadminrules}
       */
      getRules: async () => {
        const t = await this.request(this.features.version.software === d ? "/api/v1/admin/instance/rules" : "/api/v1/pleroma/admin/rules");
        return e.parse(r(Je), t.json);
      },
      /**
       * Create a rule
       *
       * Requires features{@link Features.adminRules}.
       * @see {@link https://docs.pleroma.social/backend/development/API/admin_api/#post-apiv1pleromaadminrules}
       */
      createRule: async (t) => {
        const s = await this.request(
          this.features.version.software === d ? "/api/v1/admin/instance/rules" : "/api/v1/pleroma/admin/rules",
          { method: "POST", body: t }
        );
        return e.parse(Je, s.json);
      },
      /**
       * Update a rule
       *
       * Requires features{@link Features.adminRules}.
       * @see {@link https://docs.pleroma.social/backend/development/API/admin_api/#patch-apiv1pleromaadminrulesid}
       */
      updateRule: async (t, s) => {
        const n = await this.request(
          `/api/v1/${this.features.version.software === d ? "admin/instance" : "pleroma/admin"}/rules/${t}`,
          { method: "PATCH", body: s }
        );
        return e.parse(Je, n.json);
      },
      /**
       * Delete a rule
       *
       * Requires features{@link Features.adminRules}.
       * @see {@link https://docs.pleroma.social/backend/development/API/admin_api/#delete-apiv1pleromaadminrulesid}
       */
      deleteRule: async (t) => (await this.request(
        `/api/v1/${this.features.version.software === d ? "admin/instance" : "pleroma/admin"}/rules/${t}`,
        { method: "DELETE" }
      )).json
    },
    config: {
      getPleromaConfig: async () => {
        const t = await this.request("/api/v1/pleroma/admin/config");
        return e.parse(_t, t.json);
      },
      updatePleromaConfig: async (t) => {
        const s = await this.request("/api/v1/pleroma/admin/config", { method: "POST", body: { configs: t } });
        return e.parse(_t, s.json);
      }
    },
    customEmojis: {
      /**
       * View local and remote emojis available to/known by this instance.
       *
       * Requires features{@link Features.adminCustomEmojis}.
       * @see {@link https://docs.gotosocial.org/en/latest/api/swagger/}
       */
      getCustomEmojis: (t) => this.#e("/api/v1/admin/custom_emojis", { params: t }, ue),
      /**
       * Get the admin view of a single emoji.
       *
       * Requires features{@link Features.adminCustomEmojis}.
       * @see {@link https://docs.gotosocial.org/en/latest/api/swagger/}
       */
      getCustomEmoji: async (t) => {
        const s = await this.request(`/api/v1/admin/custom_emojis/${t}`);
        return e.parse(ue, s.json);
      },
      /**
       * Get the admin view of a single emoji.
       *
       * Requires features{@link Features.adminCustomEmojis}.
       * @see {@link https://docs.gotosocial.org/en/latest/api/swagger/}
       */
      createCustomEmoji: async (t) => {
        const s = await this.request(
          "/api/v1/admin/custom_emojis",
          { method: "POST", body: t, contentType: "" }
        );
        return e.parse(ue, s.json);
      },
      updateCustomEmoji: async (t, s) => {
        const n = await this.request(
          `/api/v1/admin/custom_emojis/${t}`,
          { method: "PATCH", body: s, contentType: "" }
        );
        return e.parse(ue, n.json);
      },
      /**
       * Delete a **local** emoji with the given ID from the instance.
       *
       * Requires features{@link Features.adminCustomEmojis}.
       * @see {@link https://docs.gotosocial.org/en/latest/api/swagger/}
       */
      deleteCustomEmoji: async (t) => {
        const s = await this.request(
          `/api/v1/admin/custom_emojis/${t}`,
          { method: "DELETE" }
        );
        return e.parse(ue, s.json);
      }
    }
  };
  oembed = {
    /**
     * Get OEmbed info as JSON
     * @see {@link https://docs.joinmastodon.org/methods/oembed/#get}
     */
    getOembed: async (t, s, n) => {
      const o = await this.request("/api/oembed", { params: { url: t, maxwidth: s, maxheight: n } });
      return e.parse(e.object({
        type: e.fallback(e.string(), "rich"),
        version: e.fallback(e.string(), ""),
        author_name: e.fallback(e.string(), ""),
        author_url: e.fallback(e.string(), ""),
        provider_name: e.fallback(e.string(), ""),
        provider_url: e.fallback(e.string(), ""),
        cache_age: e.number(),
        html: e.string(),
        width: e.fallback(e.nullable(e.number()), null),
        height: e.fallback(e.nullable(e.number()), null)
      }), o.json);
    }
  };
  /** @see {@link https://docs.pleroma.social/backend/development/API/chats} */
  chats = {
    /**
     * create or get an existing Chat for a certain recipient
     * @see {@link https://docs.pleroma.social/backend/development/API/chats/#creating-or-getting-a-chat}
     */
    createChat: async (t) => {
      const s = await this.request(`/api/v1/pleroma/chats/by-account-id/${t}`, { method: "POST" });
      return e.parse(ne, s.json);
    },
    /**
     * @see {@link https://docs.pleroma.social/backend/development/API/chats/#creating-or-getting-a-chat}
     */
    getChat: async (t) => {
      const s = await this.request(`/api/v1/pleroma/chats/${t}`);
      return e.parse(ne, s.json);
    },
    /**
     * Marking a chat as read
     * mark a number of messages in a chat up to a certain message as read
     * @see {@link https://docs.pleroma.social/backend/development/API/chats/#marking-a-chat-as-read}
     */
    markChatAsRead: async (t, s) => {
      const n = await this.request(`/api/v1/pleroma/chats/${t}/read`, { method: "POST", body: { last_read_id: s } });
      return e.parse(ne, n.json);
    },
    /**
     * Marking a single chat message as read
     * To set the `unread` property of a message to `false`
     * https://docs.pleroma.social/backend/development/API/chats/#marking-a-single-chat-message-as-read
     */
    markChatMessageAsRead: async (t, s) => {
      const n = await this.request(`/api/v1/pleroma/chats/${t}/messages/${s}/read`, { method: "POST" });
      return e.parse(ne, n.json);
    },
    /**
     * Getting a list of Chats
     * This will return a list of chats that you have been involved in, sorted by their last update (so new chats will be at the top).
     * @see {@link https://docs.pleroma.social/backend/development/API/chats/#getting-a-list-of-chats}
     */
    getChats: async (t) => this.#e("/api/v2/pleroma/chats", { params: t }, ne),
    /**
     * Getting the messages for a Chat
     * For a given Chat id, you can get the associated messages with
     */
    getChatMessages: async (t, s) => this.#e(`/api/v1/pleroma/chats/${t}/messages`, { params: s }, ce),
    /**
     * Posting a chat message
     * Posting a chat message for given Chat id works like this:
     * @see {@link https://docs.pleroma.social/backend/development/API/chats/#posting-a-chat-message}
     */
    createChatMessage: async (t, s) => {
      const n = await this.request(`/api/v1/pleroma/chats/${t}/messages`, { method: "POST", body: s });
      return e.parse(ce, n.json);
    },
    /**
     * Deleting a chat message
     * Deleting a chat message for given Chat id works like this:
     * @see {@link https://docs.pleroma.social/backend/development/API/chats/#deleting-a-chat-message}
     */
    deleteChatMessage: async (t, s) => {
      const n = await this.request(`/api/v1/pleroma/chats/${t}/messages/${s}`, { method: "DELETE" });
      return e.parse(ce, n.json);
    },
    /**
     * Deleting a chat
     *
     * Requires features{@link Features.chatsDelete}.
     */
    deleteChat: async (t) => {
      const s = await this.request(`/api/v1/pleroma/chats/${t}`, { method: "DELETE" });
      return e.parse(ne, s.json);
    }
  };
  shoutbox = {
    connect: (t, { onMessage: s, onMessages: n }) => {
      let o = 2, b;
      if (this.#n) return this.#n;
      const g = ct("/socket/websocket", this.baseURL, { token: t, vsn: "2.0.0" }), S = new Ue(g);
      return S.onmessage = (i) => {
        const [_, u, J, T, I] = JSON.parse(i.data);
        if (T === "new_msg") {
          const N = e.parse(Ot, I);
          s(N);
        } else if (T === "messages") {
          const N = e.parse(r(Ot), I.messages);
          n(N);
        }
      }, S.onopen = () => {
        S.send(JSON.stringify(["3", `${++o}`, "chat:public", "phx_join", {}])), b = setInterval(() => {
          S.send(JSON.stringify([null, `${++o}`, "phoenix", "heartbeat", {}]));
        }, 5e3);
      }, S.onclose = () => {
        clearInterval(b);
      }, this.#n = {
        message: (i) => {
          S.send(JSON.stringify(["3", `${++o}`, "chat:public", "new_msg", { text: i }]));
        },
        close: () => {
          S.close(), this.#n = void 0, clearInterval(b);
        }
      }, this.#n;
    }
  };
  events = {
    /**
     * Creates an event
     * @see {@link https://github.com/mkljczk/pl/blob/fork/docs/development/API/pleroma_api.md#apiv1pleromaevents}
     */
    createEvent: async (t) => {
      const s = await this.request("/api/v1/pleroma/events", { method: "POST", body: t });
      return e.parse(f, s.json);
    },
    /**
     * Edits an event
     * @see {@link https://github.com/mkljczk/pl/blob/fork/docs/development/API/pleroma_api.md#apiv1pleromaeventsid}
     */
    editEvent: async (t, s) => {
      const n = await this.request(`/api/v1/pleroma/events/${t}`, { method: "PUT", body: s });
      return e.parse(f, n.json);
    },
    /**
     * Gets user's joined events
     * @see {@link https://github.com/mkljczk/pl/blob/fork/docs/development/API/pleroma_api.md#apiv1pleromaeventsjoined_events}
     */
    getJoinedEvents: async (t, s) => this.#e("/api/v1/pleroma/events/joined_events", { params: { ...s, state: t } }, f),
    /**
     * Gets event participants
     * @see {@link https://github.com/mkljczk/pl/blob/fork/docs/development/API/pleroma_api.md#apiv1pleromaeventsidparticipations}
     */
    getEventParticipations: async (t, s) => this.#e(`/api/v1/pleroma/events/${t}/participations`, { params: s }, w),
    /**
     * Gets event participation requests
     * @see {@link https://github.com/mkljczk/pl/blob/fork/docs/development/API/pleroma_api.md#apiv1pleromaeventsidparticipation_requests}
     */
    getEventParticipationRequests: async (t, s) => this.#e(`/api/v1/pleroma/events/${t}/participation_requests`, { params: s }, e.object({
      account: w,
      participation_message: e.fallback(e.string(), "")
    })),
    /**
     * Accepts user to the event
     * @see {@link https://github.com/mkljczk/pl/blob/fork/docs/development/API/pleroma_api.md#apiv1pleromaeventsidparticipation_requestsparticipant_idauthorize}
     */
    acceptEventParticipationRequest: async (t, s) => {
      const n = await this.request(`/api/v1/pleroma/events/${t}/participation_requests/${s}/authorize`, { method: "POST" });
      return e.parse(f, n.json);
    },
    /**
     * Rejects user from the event
     * @see {@link https://github.com/mkljczk/pl/blob/fork/docs/development/API/pleroma_api.md#rejects-user-from-the-event}
     */
    rejectEventParticipationRequest: async (t, s) => {
      const n = await this.request(`/api/v1/pleroma/events/${t}/participation_requests/${s}/reject`, { method: "POST" });
      return e.parse(f, n.json);
    },
    /**
     * Joins the event
     * @see {@link https://github.com/mkljczk/pl/blob/fork/docs/development/API/pleroma_api.md#joins-the-event}
     */
    joinEvent: async (t, s) => {
      const n = await this.request(`/api/v1/pleroma/events/${t}/join`, { method: "POST", body: { participation_message: s } });
      return e.parse(f, n.json);
    },
    /**
     * Leaves the event
     * @see {@link https://github.com/mkljczk/pl/blob/fork/docs/development/API/pleroma_api.md#leaves-the-event}
     */
    leaveEvent: async (t) => {
      const s = await this.request(`/api/v1/pleroma/events/${t}/leave`, { method: "POST" });
      return e.parse(f, s.json);
    },
    /**
     * Event ICS file
     * @see {@link https://github.com/mkljczk/pl/blob/fork/docs/development/API/pleroma_api.md#event-ics-file}
     */
    getEventIcs: async (t) => (await this.request(`/api/v1/pleroma/events/${t}/ics`, { contentType: "" })).data
  };
  interactionRequests = {
    /**
     * Get an array of interactions requested on your statuses by other accounts, and pending your approval.
     *
     * Requires features{@link Features.interactionRequests}.
     */
    getInteractionRequests: async (t) => this.#e("/api/v1/interaction_requests", { params: t }, Ee),
    /**
     * Get interaction request with the given ID.
     *
     * Requires features{@link Features.interactionRequests}.
     */
    getInteractionRequest: async (t) => {
      const s = await this.request(`/api/v1/interaction_requests/${t}`);
      return e.parse(Ee, s.json);
    },
    /**
     * Accept/authorize/approve an interaction request with the given ID.
     *
     * Requires features{@link Features.interactionRequests}.
     */
    authorizeInteractionRequest: async (t) => {
      const s = await this.request(`/api/v1/interaction_requests/${t}/authorize`, { method: "POST" });
      return e.parse(Ee, s.json);
    },
    /**
     * Reject an interaction request with the given ID.
     *
     * Requires features{@link Features.interactionRequests}.
     */
    rejectInteractionRequest: async (t) => {
      const s = await this.request(`/api/v1/interaction_requests/${t}/authorize`, { method: "POST" });
      return e.parse(Ee, s.json);
    }
  };
  antennas = {
    /**
     * Requires features{@link Features.antennas}.
     */
    fetchAntennas: async () => {
      const t = await this.request("/api/v1/antennas");
      return e.parse(r(ae), t.json);
    },
    /**
     * Requires features{@link Features.antennas}.
     */
    getAntennas: async (t) => {
      const s = await this.request(`/api/v1/antennas/${t}`);
      return e.parse(ae, s.json);
    },
    /**
     * Requires features{@link Features.antennas}.
     */
    createAntenna: async (t) => {
      const s = await this.request("/api/v1/antennas", { method: "POST", body: t });
      return e.parse(ae, s.json);
    },
    /**
     * Requires features{@link Features.antennas}.
     */
    updateAntenna: async (t, s) => {
      const n = await this.request(`/api/v1/antennas/${t}`, { method: "PUT", body: s });
      return e.parse(ae, n.json);
    },
    /**
     * Requires features{@link Features.antennas}.
     */
    deleteAntenna: async (t) => (await this.request(`/api/v1/antennas/${t}`, { method: "DELETE" })).json,
    /**
     * Requires features{@link Features.antennas}.
     */
    getAntennaAccounts: async (t) => {
      const s = await this.request(`/api/v1/antennas/${t}/accounts`);
      return e.parse(r(w), s.json);
    },
    /**
     * Requires features{@link Features.antennas}.
     */
    addAntennaAccount: async (t, s) => (await this.request(`/api/v1/antennas/${t}/accounts`, {
      method: "POST",
      body: { account_ids: [s] }
    })).json,
    /**
     * Requires features{@link Features.antennas}.
     */
    removeAntennaAccount: async (t, s) => (await this.request(`/api/v1/antennas/${t}/accounts`, {
      method: "DELETE",
      body: { account_ids: [s] }
    })).json,
    /**
     * Requires features{@link Features.antennas}.
     */
    getAntennaExcludeAccounts: async (t) => {
      const s = await this.request(`/api/v1/antennas/${t}/exclude_accounts`);
      return e.parse(r(w), s.json);
    },
    /**
     * Requires features{@link Features.antennas}.
     */
    addAntennaExcludeAccount: async (t, s) => (await this.request(`/api/v1/antennas/${t}/exclude_accounts`, {
      method: "POST",
      body: { account_ids: [s] }
    })).json,
    /**
     * Requires features{@link Features.antennas}.
     */
    removeAntennaExcludeAccount: async (t, s) => (await this.request(`/api/v1/antennas/${t}/exclude_accounts`, {
      method: "DELETE",
      body: { account_ids: [s] }
    })).json,
    /**
     * Requires features{@link Features.antennas}.
     */
    getAntennaDomains: async (t) => {
      const s = await this.request(`/api/v1/antennas/${t}/domains`);
      return e.parse(e.object({
        domains: r(e.string()),
        exclude_domains: r(e.string())
      }), s.json);
    },
    /**
     * Requires features{@link Features.antennas}.
     */
    addAntennaDomain: async (t, s) => (await this.request(`/api/v1/antennas/${t}/domains`, {
      method: "POST",
      body: { domains: [s] }
    })).json,
    /**
     * Requires features{@link Features.antennas}.
     */
    removeAntennaDomain: async (t, s) => (await this.request(`/api/v1/antennas/${t}/domains`, {
      method: "DELETE",
      body: { domains: [s] }
    })).json,
    /**
     * Requires features{@link Features.antennas}.
     */
    addAntennaExcludeDomain: async (t, s) => (await this.request(`/api/v1/antennas/${t}/exclude_domains`, {
      method: "POST",
      body: { domains: [s] }
    })).json,
    /**
     * Requires features{@link Features.antennas}.
     */
    removeAntennaExcludeDomain: async (t, s) => (await this.request(`/api/v1/antennas/${t}/exclude_domains`, {
      method: "DELETE",
      body: { domains: [s] }
    })).json,
    /**
     * Requires features{@link Features.antennas}.
     */
    getAntennaKeywords: async (t) => {
      const s = await this.request(`/api/v1/antennas/${t}/keywords`);
      return e.parse(e.object({
        keywords: r(e.string()),
        exclude_keywords: r(e.string())
      }), s.json);
    },
    /**
     * Requires features{@link Features.antennas}.
     */
    addAntennaKeyword: async (t, s) => (await this.request(`/api/v1/antennas/${t}/keywords`, {
      method: "POST",
      body: { keywords: [s] }
    })).json,
    /**
     * Requires features{@link Features.antennas}.
     */
    removeAntennaKeyword: async (t, s) => (await this.request(`/api/v1/antennas/${t}/keywords`, {
      method: "DELETE",
      body: { keywords: [s] }
    })).json,
    /**
     * Requires features{@link Features.antennas}.
     */
    addAntennaExcludeKeyword: async (t, s) => (await this.request(`/api/v1/antennas/${t}/exclude_keywords`, {
      method: "POST",
      body: { keywords: [s] }
    })).json,
    /**
     * Requires features{@link Features.antennas}.
     */
    removeAntennaExcludeKeyword: async (t, s) => (await this.request(`/api/v1/antennas/${t}/exclude_keywords`, {
      method: "DELETE",
      body: { keywords: [s] }
    })).json,
    /**
     * Requires features{@link Features.antennas}.
     */
    getAntennaTags: async (t) => {
      const s = await this.request(`/api/v1/antennas/${t}/tags`);
      return e.parse(e.object({
        tags: r(e.string()),
        exclude_tags: r(e.string())
      }), s.json);
    },
    /**
     * Requires features{@link Features.antennas}.
     */
    addAntennaTag: async (t, s) => (await this.request(`/api/v1/antennas/${t}/tags`, {
      method: "POST",
      body: { tags: [s] }
    })).json,
    /**
     * Requires features{@link Features.antennas}.
     */
    removeAntennaTag: async (t, s) => (await this.request(`/api/v1/antennas/${t}/tags`, {
      method: "DELETE",
      body: { tags: [s] }
    })).json,
    /**
     * Requires features{@link Features.antennas}.
     */
    addAntennaExcludeTag: async (t, s) => (await this.request(`/api/v1/antennas/${t}/exclude_tags`, {
      method: "POST",
      body: { tags: [s] }
    })).json,
    /**
     * Requires features{@link Features.antennas}.
     */
    removeAntennaExcludeTag: async (t, s) => (await this.request(`/api/v1/antennas/${t}/exclude_tags`, {
      method: "DELETE",
      body: { tags: [s] }
    })).json
  };
  circles = {
    /**
     * Requires features{@link Features.circles}.
     */
    fetchCircles: async () => {
      const t = await this.request("/api/v1/circles");
      return e.parse(r(de), t.json);
    },
    /**
     * Requires features{@link Features.circles}.
     */
    getCircle: async (t) => {
      const s = await this.request(`/api/v1/circles/${t}`);
      return e.parse(de, s.json);
    },
    /**
     * Requires features{@link Features.circles}.
     */
    createCircle: async (t) => {
      const s = await this.request("/api/v1/circles", { method: "POST", body: { title: t } });
      return e.parse(de, s.json);
    },
    /**
     * Requires features{@link Features.circles}.
     */
    updateCircle: async (t, s) => {
      const n = await this.request(`/api/v1/circles/${t}`, { method: "PUT", body: { title: s } });
      return e.parse(de, n.json);
    },
    /**
     * Requires features{@link Features.circles}.
     */
    deleteCircle: async (t) => (await this.request(`/api/v1/circles/${t}`, { method: "DELETE" })).json,
    /**
     * View accounts in a circle
     * Requires features{@link Features.circles}.
     */
    getCircleAccounts: async (t, s) => this.#e(`/api/v1/circles/${t}/accounts`, { params: s }, w),
    /**
     * Add accounts to a circle
     * Add accounts to the given circle. Note that the user must be following these accounts.
     * Requires features{@link Features.circles}.
     */
    addCircleAccounts: async (t, s) => (await this.request(`/api/v1/circles/${t}/accounts`, {
      method: "POST",
      body: { account_ids: s }
    })).json,
    /**
     * Remove accounts from circle
     * Remove accounts from the given circle.
     * Requires features{@link Features.circles}.
     */
    deleteCircleAccounts: async (t, s) => (await this.request(`/api/v1/circles/${t}/accounts`, {
      method: "DELETE",
      body: { account_ids: s }
    })).json,
    getCircleStatuses: (t, s) => this.#e(`/api/v1/circles/${t}/statuses`, { params: s }, f)
  };
  rssFeedSubscriptions = {
    /**
     * Requires features{@link Features.rssFeedSubscriptions}.
     */
    fetchRssFeedSubscriptions: async () => {
      const t = await this.request("/api/v1/pleroma/rss_feed_subscriptions");
      return e.parse(r(at), t.json);
    },
    /**
     * Requires features{@link Features.rssFeedSubscriptions}.
     */
    createRssFeedSubscription: async (t) => {
      const s = await this.request("/api/v1/pleroma/rss_feed_subscriptions", { method: "POST", body: { url: t } });
      return e.parse(at, s.json);
    },
    /**
     * Requires features{@link Features.rssFeedSubscriptions}.
     */
    deleteRssFeedSubscription: async (t) => (await this.request("/api/v1/pleroma/rss_feed_subscriptions", { method: "DELETE", body: { url: t } })).json
  };
  subscriptions = {
    /**
     * Add subscriber or extend existing subscription.
     *
     * Requires features{@link Features.subscriptions}.
     * @param subscriberId - The subscriber ID.
     * @param duration - The subscription duration (in seconds).
     */
    createSubscription: async (t, s) => {
      const n = await this.request("/api/v1/subscriptions", { method: "POST", body: { subscriber_id: t, duration: s } });
      return e.parse(Pt, n.json);
    },
    /**
     * Get list of subscription options
     *
     * Requires features{@link Features.subscriptions}.
     */
    getSubscriptionOptions: async () => {
      const t = await this.request("/api/v1/subscriptions/options");
      return e.parse(r(gn), t.json);
    },
    /**
     * Enable subscriptions or update subscription settings
     *
     * Requires features{@link Features.subscriptions}.
     * @param type - Subscription type
     * @param chainId - CAIP-2 chain ID.
     * @param price - Subscription price (only for Monero)
     * @param payoutAddress - Payout address (only for Monero)
     */
    updateSubscription: async (t, s, n, o) => {
      const b = await this.request("/api/v1/subscriptions/options", { method: "POST", body: { type: t, chain_id: s, price: n, payout_address: o } });
      return e.parse(w, b.json);
    },
    /**
     * Find subscription by sender and recipient
     *
     * Requires features{@link Features.subscriptions}.
     * @param senderId - Sender ID.
     * @param recipientId - Recipient ID.
     */
    findSubscription: async (t, s) => {
      const n = await this.request("/api/v1/subscriptions/find", { method: "POST", body: { sender_id: t, recipient_id: s } });
      return e.parse(Pt, n.json);
    },
    /**
     * Create invoice
     *
     * Requires features{@link Features.subscriptions}.
     * @param senderId - Sender ID.
     * @param recipientId - Recipient ID.
     * @param chainId - CAIP-2 chain ID.
     * @param amount - Requested payment amount (in atomic units).
     */
    createInvoice: async (t, s, n, o) => {
      const b = await this.request("/api/v1/subscriptions/invoices", {
        method: "POST",
        body: {
          sender_id: t,
          recipient_id: s,
          chain_id: n,
          amount: o
        }
      });
      return e.parse(Ze, b.json);
    },
    /**
     * View information about an invoice.
     *
     * Requires features{@link Features.invoices}.
     * @param invoiceId - Invoice ID
     */
    getInvoice: async (t) => {
      const s = await this.request(`/api/v1/subscriptions/invoices/${t}`);
      return e.parse(Ze, s.json);
    },
    /**
     * Cancel invoice.
     *
     * Requires features{@link Features.invoices}.
     * @param invoiceId - Invoice ID
     */
    cancelInvoice: async (t) => {
      const s = await this.request(`/api/v1/subscriptions/invoices/${t}`, {
        method: "DELETE"
      });
      return e.parse(Ze, s.json);
    }
  };
  drive = {
    getDrive: async () => {
      await this.#t();
      const t = await this.request("/api/iceshrimp/drive/folder");
      return e.parse(oe, t.json);
    },
    getFolder: async (t) => {
      await this.#t();
      const s = await this.request(`/api/iceshrimp/drive/folder/${t}`);
      return e.parse(oe, s.json);
    },
    createFolder: async (t, s) => {
      await this.#t();
      const n = await this.request("/api/iceshrimp/drive/folder", {
        method: "POST",
        body: { name: t, parentId: s }
      });
      return e.parse(oe, n.json);
    },
    updateFolder: async (t, s) => {
      await this.#t();
      const n = await this.request(`/api/iceshrimp/drive/folder/${t}`, {
        method: "PUT",
        body: s
      });
      return e.parse(oe, n.json);
    },
    deleteFolder: async (t) => (await this.#t(), await this.request(`/api/iceshrimp/drive/folder/${t}`, {
      method: "DELETE"
    })),
    moveFolder: async (t, s) => {
      await this.#t();
      const n = await this.request(`/api/iceshrimp/drive/folder/${t}/move`, {
        method: "POST",
        body: { folderId: s }
      });
      return e.parse(oe, n.json);
    },
    getFile: async (t) => {
      await this.#t();
      const s = await this.request(`/api/iceshrimp/drive/${t}`);
      return e.parse(De, s.json);
    },
    createFile: async (t, s) => {
      await this.#t();
      const n = await this.request("/api/iceshrimp/drive", {
        method: "POST",
        body: { file: t, folderId: s },
        contentType: ""
      });
      return e.parse(De, n.json);
    },
    updateFile: async (t, s) => {
      await this.#t();
      const n = await this.request(`/api/iceshrimp/drive/${t}`, {
        method: "PUT",
        body: s
      });
      return e.parse(De, n.json);
    },
    deleteFile: async (t) => (await this.#t(), await this.request(`/api/iceshrimp/drive/${t}`, {
      method: "DELETE"
    })),
    moveFile: async (t, s) => {
      await this.#t();
      const n = await this.request(`/api/iceshrimp/drive/${t}/move`, {
        method: "POST",
        body: { folderId: s }
      });
      return e.parse(oe, n.json);
    }
  };
  stories = {
    getRecentStories: async () => {
      const t = await this.request("/api/web/stories/v1/recent");
      return e.parse(r(Za), t.json);
    },
    getStoryViewers: async (t) => {
      const s = await this.request("/api/web/stories/v1/viewers", {
        params: { sid: t }
      });
      return e.parse(r(w), s.json);
    },
    getStoriesForProfile: async (t) => {
      const s = await this.request(`/api/web/stories/v1/profile/${t}`);
      return e.parse(r(tn), s.json);
    },
    storyExists: async (t) => {
      const s = await this.request(`/api/web/stories/v1/exists/${t}`);
      return e.parse(e.boolean(), s.json);
    },
    getStoryPollResults: async (t) => {
      const s = await this.request("/api/web/stories/v1/poll/results", {
        params: { sid: t }
      });
      return e.parse(e.array(e.number()), s.json);
    },
    markStoryAsViewed: async (t) => (await this.request("/api/web/stories/v1/viewed", {
      method: "POST",
      body: { id: t }
    })).json,
    createStoryReaction: async (t, s) => (await this.request("/api/web/stories/v1/react", {
      method: "POST",
      body: { sid: t, reaction: s }
    })).json,
    createStoryComment: async (t, s) => (await this.request("/api/web/stories/v1/comment", {
      method: "POST",
      body: { sid: t, caption: s }
    })).json,
    createStoryPoll: async (t) => (await this.request("/api/web/stories/v1/publish/poll", {
      method: "POST",
      body: t
    })).json,
    storyPollVote: async (t, s) => (await this.request("/api/web/stories/v1/publish/poll", {
      method: "POST",
      body: { sid: t, ci: s }
    })).json,
    reportStory: async (t, s) => (await this.request("/api/web/stories/v1/report", {
      method: "POST",
      body: { id: t, type: s }
    })).json,
    addMedia: async (t) => {
      const s = await this.request("/api/web/stories/v1/add", {
        method: "POST",
        body: { file: t },
        contentType: ""
      });
      return e.parse(Qa, s.json);
    },
    cropPhoto: async (t, s) => (await this.request("/api/web/stories/v1/crop", {
      method: "POST",
      body: { media_id: t, ...s }
    })).json,
    createStory: async (t, s) => (await this.request("/api/web/stories/v1/publish", {
      method: "POST",
      body: { media_id: t, ...s }
    })).json,
    deleteStory: async (t) => (await this.request(`/api/web/stories/v1/delete/${t}`, {
      method: "DELETE"
    })).json
  };
  /** Routes that are not part of any stable release */
  experimental = {
    admin: {
      /** @see {@link https://github.com/mastodon/mastodon/pull/19059} */
      groups: {
        /** list groups known to the instance. Mimics the interface of `/api/v1/admin/accounts` */
        getGroups: async (t) => {
          const s = await this.request("/api/v1/admin/groups", { params: t });
          return e.parse(r(B), s.json);
        },
        /** return basic group information */
        getGroup: async (t) => {
          const s = await this.request(`/api/v1/admin/groups/${t}`);
          return e.parse(B, s.json);
        },
        /** suspends a group */
        suspendGroup: async (t) => {
          const s = await this.request(`/api/v1/admin/groups/${t}/suspend`, { method: "POST" });
          return e.parse(B, s.json);
        },
        /** lift a suspension */
        unsuspendGroup: async (t) => {
          const s = await this.request(`/api/v1/admin/groups/${t}/unsuspend`, { method: "POST" });
          return e.parse(B, s.json);
        },
        /** deletes an already-suspended group */
        deleteGroup: async (t) => {
          const s = await this.request(`/api/v1/admin/groups/${t}`, { method: "DELETE" });
          return e.parse(B, s.json);
        }
      }
    },
    /** @see {@link https://github.com/mastodon/mastodon/pull/19059} */
    groups: {
      /** returns an array of `Group` entities the current user is a member of */
      getGroups: async () => {
        let t;
        return this.features.version.software === q ? t = await this.request("/api/v0/groups/self/list") : t = await this.request("/api/v1/groups"), e.parse(r(B), t.json);
      },
      /** create a group with the given attributes (`display_name`, `note`, `avatar` and `header`). Sets the user who made the request as group administrator */
      createGroup: async (t) => {
        let s;
        if (this.features.version.software === q) {
          if (s = await this.request("/api/v0/groups/create", {
            method: "POST",
            body: { ...t, name: t.display_name, description: t.note, membership: "public" },
            contentType: t.avatar || t.header ? "" : void 0
          }), s.json?.id)
            return this.experimental.groups.getGroup(s.json.id);
        } else
          s = await this.request("/api/v1/groups", {
            method: "POST",
            body: t,
            contentType: t.avatar || t.header ? "" : void 0
          });
        return e.parse(B, s.json);
      },
      /** returns the `Group` entity describing a given group */
      getGroup: async (t) => {
        let s;
        return this.features.version.software === q ? s = await this.request(`/api/v0/groups/${t}`) : s = await this.request(`/api/v1/groups/${t}`), e.parse(B, s.json);
      },
      /** update group attributes (`display_name`, `note`, `avatar` and `header`) */
      updateGroup: async (t, s) => {
        const n = await this.request(`/api/v1/groups/${t}`, {
          method: "PUT",
          body: s,
          contentType: s.avatar || s.header ? "" : void 0
        });
        return e.parse(B, n.json);
      },
      /** irreversibly deletes the group */
      deleteGroup: async (t) => {
        let s;
        return this.features.version.software === q ? s = await this.request("/api/v0/groups/delete", { method: "POST", params: { gid: t } }) : s = await this.request(`/api/v1/groups/${t}`, { method: "DELETE" }), s.json;
      },
      /** Has an optional role attribute that can be used to filter by role (valid roles are `"admin"`, `"moderator"`, `"user"`). */
      getGroupMemberships: async (t, s, n) => this.#e(
        this.features.version.software === q ? `/api/v0/groups/members/list?gid=${t}` : `/api/v1/groups/${t}/memberships`,
        { params: { ...n, role: s } },
        Xe
      ),
      /** returns an array of `Account` entities representing pending requests to join a group */
      getGroupMembershipRequests: async (t, s) => this.#e(
        this.features.version.software === q ? `/api/v0/groups/members/requests?gid=${t}` : `/api/v1/groups/${t}/membership_requests`,
        { params: s },
        w
      ),
      /** accept a pending request to become a group member */
      acceptGroupMembershipRequest: async (t, s) => (await this.request(`/api/v1/groups/${t}/membership_requests/${s}/authorize`, { method: "POST" })).json,
      /** reject a pending request to become a group member */
      rejectGroupMembershipRequest: async (t, s) => (await this.request(`/api/v1/groups/${t}/membership_requests/${s}/reject`, { method: "POST" })).json,
      /** delete a group post (actually marks it as `revoked` if it is a local post) */
      deleteGroupStatus: async (t, s) => {
        const n = await this.request(`/api/v1/groups/${t}/statuses/${s}`, { method: "DELETE" });
        return e.parse(f, n.json);
      },
      /** list accounts blocked from interacting with the group */
      getGroupBlocks: async (t, s) => this.#e(`/api/v1/groups/${t}/blocks`, { params: s }, w),
      /** block one or more users. If they were in the group, they are also kicked of it */
      blockGroupUsers: async (t, s) => (await this.request(`/api/v1/groups/${t}/blocks`, { method: "POST", params: { account_ids: s } })).json,
      /** block one or more users. If they were in the group, they are also kicked of it */
      unblockGroupUsers: async (t, s) => (await this.request(`/api/v1/groups/${t}/blocks`, { method: "DELETE", params: { account_ids: s } })).json,
      /** joins (or request to join) a given group */
      joinGroup: async (t) => {
        const s = await this.request(`/api/v1/groups/${t}/join`, { method: "POST" });
        return e.parse(xe, s.json);
      },
      /** leaves a given group */
      leaveGroup: async (t) => {
        const s = await this.request(`/api/v1/groups/${t}/leave`, { method: "POST" });
        return e.parse(xe, s.json);
      },
      /** kick one or more group members */
      kickGroupUsers: async (t, s) => (await this.request(`/api/v1/groups/${t}/kick`, { method: "POST", params: { account_ids: s } })).json,
      /** promote one or more accounts to role `new_role`. An error is returned if any of those accounts has a higher role than `new_role` already, or if the role is higher than the issuing user's. Valid roles are `admin`, and `moderator` and `user`. */
      promoteGroupUsers: async (t, s, n) => {
        const o = await this.request(`/api/v1/groups/${t}/promote`, { method: "POST", params: { account_ids: s, role: n } });
        return e.parse(r(Xe), o.json);
      },
      /** demote one or more accounts to role `new_role`. Returns an error unless every of the target account has a strictly lower role than the user (you cannot demote someone with the same role as you), or if any target account already has a role lower than `new_role`. Valid roles are `admin`, `moderator` and `user`. */
      demoteGroupUsers: async (t, s, n) => {
        const o = await this.request(`/api/v1/groups/${t}/demote`, { method: "POST", params: { account_ids: s, role: n } });
        return e.parse(r(Xe), o.json);
      },
      getGroupRelationships: async (t) => {
        const s = await this.request("/api/v1/groups/relationships", { params: { id: t } });
        return e.parse(r(xe), s.json);
      }
    }
  };
  #d = (t) => {
    this.#s = t, this.features = Ct(this.#s);
  };
  #t = async () => {
    this.#r || this.features.version.software === E && (this.#r = await this.settings.authorizeIceshrimp());
  };
  get accessToken() {
    return this.#o;
  }
  set accessToken(t) {
    this.#o !== t && (this.#a?.close(), this.#o = t, this.#t());
  }
  get iceshrimpAccessToken() {
    return this.#r;
  }
  get instanceInformation() {
    return this.#s;
  }
}
class uo {
  /** Unused. */
  accessToken = void 0;
  /** Unused. */
  iceshrimpAccessToken = void 0;
  /**
   * Server directory URL.
   */
  baseURL;
  request = bs.bind(this);
  /**
   * @param baseURL Server directory URL. e.g. `https://joinmastodon.org`
   */
  constructor(t) {
    this.baseURL = t;
  }
  async getStatistics() {
    const t = await this.request("/statistics");
    return e.parse(r(ca), t.json);
  }
  async getCategories(t) {
    const s = await this.request("/categories", { params: t });
    return e.parse(r(ra), s.json);
  }
  async getLanguages(t) {
    const s = await this.request("/categories", { params: t });
    return e.parse(r(ia), s.json);
  }
  async getServers(t) {
    const s = await this.request("/servers", { params: t });
    return e.parse(r(la), s.json);
  }
}
export {
  m as AKKOMA,
  U as DITTO,
  A as FIREFISH,
  R as FRIENDICA,
  Hn as GLITCH,
  d as GOTOSOCIAL,
  Fe as GroupRoles,
  x as HOLLO,
  Xn as HOMETOWN,
  P as ICESHRIMP,
  E as ICESHRIMP_NET,
  v as MASTODON,
  y as MITRA,
  q as PIXELFED,
  p as PLEROMA,
  co as PlApiClient,
  uo as PlApiDirectoryClient,
  se as SNAC,
  O as TAKAHE,
  Y as TOKI,
  lo as UNRELEASED,
  et as WORDPRESS,
  w as accountSchema,
  Ht as accountWarningSchema,
  C as adminAccountSchema,
  _e as adminAnnouncementSchema,
  ke as adminCanonicalEmailBlockSchema,
  Ns as adminCohortSchema,
  ue as adminCustomEmojiSchema,
  xs as adminDimensionSchema,
  Ve as adminDomainAllowSchema,
  ye as adminDomainBlockSchema,
  Be as adminDomainSchema,
  ze as adminEmailDomainBlockSchema,
  je as adminIpBlockSchema,
  Ls as adminIpSchema,
  Is as adminMeasureSchema,
  Ds as adminModerationLogEntrySchema,
  He as adminRelaySchema,
  Z as adminReportSchema,
  Je as adminRuleSchema,
  ea as adminTagSchema,
  Xt as announcementReactionSchema,
  dt as announcementSchema,
  ae as antennaSchema,
  Ie as applicationSchema,
  aa as asyncRefreshSchema,
  na as authorizationServerMetadataSchema,
  jt as backupSchema,
  Yt as baseFilterSchema,
  Zt as blurhashSchema,
  pe as bookmarkFolderSchema,
  ce as chatMessageSchema,
  ne as chatSchema,
  de as circleSchema,
  oa as contextSchema,
  ot as conversationSchema,
  ve as credentialAccountSchema,
  sa as credentialApplicationSchema,
  ee as customEmojiSchema,
  ra as directoryCategorySchema,
  ia as directoryLanguageSchema,
  la as directoryServerSchema,
  ca as directoryStatisticsPeriodSchema,
  ua as domainBlockSchema,
  De as driveFileSchema,
  oe as driveFolderSchema,
  mt as emojiReactionSchema,
  da as extendedDescriptionSchema,
  ma as familiarFollowersSchema,
  Ke as featuredTagSchema,
  fe as filterKeywordSchema,
  Gs as filterResultSchema,
  Se as filterSchema,
  Ne as filterStatusSchema,
  sn as followRelationshipUpdateSchema,
  Ct as getFeatures,
  Xe as groupMemberSchema,
  xe as groupRelationshipSchema,
  B as groupSchema,
  St as groupedNotificationsResultsSchema,
  Jt as historySchema,
  Et as instanceSchema,
  yt as interactionPoliciesSchema,
  be as interactionPolicySchema,
  Ee as interactionRequestSchema,
  Q as listSchema,
  is as locationSchema,
  Ia as markerSchema,
  rt as markersSchema,
  re as mediaAttachmentSchema,
  Wt as mentionSchema,
  As as mutedAccountSchema,
  Ea as notificationGroupSchema,
  qt as notificationPolicySchema,
  Tt as notificationRequestSchema,
  it as notificationSchema,
  Wa as oauthTokenSchema,
  Qs as partialStatusSchema,
  _t as pleromaConfigSchema,
  st as pollSchema,
  Ws as previewCardAuthorSchema,
  Qt as previewCardSchema,
  Ja as privacyPolicySchema,
  F as relationshipSchema,
  ss as relationshipSeveranceEventSchema,
  wt as reportSchema,
  le as roleSchema,
  at as rssFeedSchema,
  Me as ruleSchema,
  qe as scheduledStatusSchema,
  $t as scrobbleSchema,
  Ka as searchSchema,
  Ot as shoutMessageSchema,
  Ya as statusEditSchema,
  f as statusSchema,
  Ye as statusSourceSchema,
  Zs as statusWithoutAccountSchema,
  Za as storyCarouselItemSchema,
  Qa as storyMediaSchema,
  en as storyNodeSchema,
  tn as storyProfileSchema,
  wn as streamingEventSchema,
  Pt as subscriptionDetailsSchema,
  Ze as subscriptionInvoiceSchema,
  gn as subscriptionOptionSchema,
  vn as suggestionSchema,
  X as tagSchema,
  At as termsOfServiceSchema,
  Te as tokenSchema,
  nt as translationSchema,
  Rt as trendsLinkSchema,
  _n as userInfoSchema,
  Qe as webPushSubscriptionSchema
};
//# sourceMappingURL=main.es.js.map
